import { CommonModule, formatDate } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountRegistryService } from '../../services/account-registry.service';
import { ActivatedRoute, Router } from '@angular/router';
import { INDUSTRY_ENUM } from '../shared/enums/industry.enum';
// import { numberToWords } from "amount-to-words";
import { QRCodeModule } from 'angularx-qrcode';
import {
  NgxScannerQrcodeComponent,
  NgxScannerQrcodeModule,
  ScannerQRCodeConfig,
  ScannerQRCodeResult,
} from 'ngx-scanner-qrcode';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { customFontsVfs } from '../../assets/fonts/custom-fonts.vfs';
import { VariantSelectorComponent } from '../shared/components/variant-selector/variant-selector.component';
import { resetFunction } from './dashboard.reset'; // Import the function

import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import {
  ToggleButtonChangeEvent,
  ToggleButtonModule,
} from 'primeng/togglebutton';
import {
  catchError,
  debounceTime,
  delay,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  timer,
} from 'rxjs';
import {
  Invoice,
  InvoiceHttpResponse,
  Salesitem,
} from '../../modals/invoice.model';
import {
  HoldHttpResponse,
  HoldReceiptInfo,
  OrderHttpResponse,
  Product,
  ProductHttpResponse,
  ProductMapValue,
  ProductSearchHttpResponse,
  Quotation,
  Transaction,
  TransactionHttpResponse,
} from '../../modals/product.modals';
import { User } from '../../modals/user.model';
import { AuthService } from '../../services/auth.service';
import {
  CashDenominationService,
  PunchStatus,
} from '../../services/cash-denomination.service';
import {
  ClientSettingsService,
  ModePermissions,
} from '../../services/client-settings.service';
import { ClientTemplateService } from '../../services/client-template.service';
import { FormDataService } from '../../services/form-data.service';
import { IndustryService } from '../../services/industry.service';
import { KeyboardEventService } from '../../services/keyboard-event.service';
import { NetworkHealthService } from '../../services/network-health.service';
import {
  Customer,
  OfferGroupService,
  PricingGroup,
} from '../../services/offer-group.service';
import { DynamicTemplateConfigService } from '../../services/pdf-generation/dynamic-template-config.service';
import { PdfGenerationService } from '../../services/pdf-generation/pdf-generation.service';
import { PdfUploadService } from '../../services/pdf-upload.service';
import { WhatsappShareService } from '../../services/whatsapp-share.service';
import { ProductDbService } from '../../services/productdb.service';
import { ToasterService } from '../../services/toaster.service';
import { CashDenominationComponent } from '../cash-denomination/cash-denomination.component';
import { IndustryType } from '../config/industry/industry-types.enum';
import { RestaurantBillPanelComponent } from '../industries/restaurant/components/restaurant-bill-panel/restaurant-bill-panel.component';
import { RestaurantDashboardComponent } from '../industries/restaurant/restaurant-dashboard/restaurant-dashboard.component';
import { LoginComponent } from '../login/login.component';
import { EmptyCartComponent } from './components/empty-cart/empty-cart.component';
import { DashboardRightPanelComponent } from '../shared/components/dashboard-right-panel/dashboard-right-panel.component';
import { FooterActionButtonsComponent } from '../shared/components/footer-action-buttons/footer-action-buttons.component';
import { HoldReceiptDialogComponent } from '../shared/components/hold-receipt-dialog/hold-receipt-dialog.component';
import { InvoiceDetailsDialogComponent } from '../shared/components/invoice-details-dialog/invoice-details-dialog.component';
import { OfferGroupCustomerDialogComponent } from '../shared/components/offer-group-customer-dialog/offer-group-customer-dialog.component';
import { PaymentTotalDialogComponent } from '../shared/components/payment-total-dialog/payment-total-dialog.component';
import { QuotationHistoryDialogComponent } from '../shared/components/quotation-history-dialog/quotation-history-dialog.component';
import {
  QuotationOptions,
  QuotationOptionsDialogComponent,
} from '../shared/components/quotation-options-dialog/quotation-options-dialog.component';
import { ResumeReceiptDialogComponent } from '../shared/components/resume-receipt-dialog/resume-receipt-dialog.component';
import { SalesHistoryDialogComponent } from '../shared/components/sales-history-dialog/sales-history-dialog.component';
import { SplitBillDialogComponent } from '../shared/components/split-bill-dialog/split-bill-dialog.component';
import { IndustryUiConfigService } from '../shared/industry-ui-config.service';
import { IndustryUiConfig } from '../shared/industry-ui.model';
import { UpiPaymentRequest } from '../shared/interfaces/payment-dialog.interface';
import { HoldReceiptSubmitEvent } from '../shared/models/hold-receipt.model';
import { createDefaultPaymentSessionState } from '../shared/models/payment-session.model';
import {
  BarcodeScannerDeps,
  BarcodeScannerService,
} from '../shared/services/barcode-scanner.service';
import { BillingGuardService } from '../shared/services/billing-guard.service';
import {
  CustomerLookupDeps,
  CustomerLookupService,
} from '../shared/services/customer-lookup.service';
import { DashboardPdfService } from '../shared/services/dashboard-pdf.service';
import { FocusManagerService } from '../shared/services/focus-manager.service';
import {
  KeyboardNavigationDeps,
  KeyboardNavigationService,
} from '../shared/services/keyboard-navigation.service';
import { MobileStockReservationService } from '../shared/services/mobile-stock-reservation.service';
import {
  OfferGroupModeDeps,
  OfferGroupModeService,
} from '../shared/services/offer-group-mode.service';
import {
  OrderModeDeps,
  OrderModeService,
} from '../shared/services/order-mode.service';
import { PaymentCalculationService } from '../shared/services/payment-calculation.service';
import {
  PaymentStatusService,
  PaymentStatusUpdate,
} from '../shared/services/payment-status.service';
import { BillNumberRefreshService } from '../shared/services/bill-number-refresh.service';
import { PaymentValidationService } from '../shared/services/payment-validation.service';
import {
  InclLineBreakup,
  PosCalculationService,
} from '../shared/services/pos-calculation.service';
import {
  ProductMappingDeps,
  ProductMappingService,
} from '../shared/services/product-mapping.service';
import { ResumeReceiptService } from '../shared/services/resume-receipt.service';
import {
  TransactionHistoryDeps,
  TransactionHistoryService,
} from '../shared/services/transaction-history.service';
import {
  allowAlphabeticOnly as allowAlphabeticOnlyUtil,
  allowAlphaNumeric as allowAlphaNumericUtil,
  allowOnlyNumbers as allowOnlyNumbersUtil,
} from '../shared/utils/input-restriction.util';
import { responsiveOptions, scannerConfig } from './dashboard.config';
import { PrimeNgModule } from './primeng.import';
// Merge default Roboto VFS with custom Tamil font VFS
pdfMake.vfs = { ...pdfFonts.pdfMake.vfs, ...customFontsVfs };

// Register font families including Tamil
(pdfMake as any).fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf',
  },
  NotoSansTamil: {
    normal: 'NotoSansTamil-Regular.ttf',
    bold: 'NotoSansTamil-Bold.ttf',
    italics: 'NotoSansTamil-Regular.ttf',
    bolditalics: 'NotoSansTamil-Bold.ttf',
  },
};

interface InvoiceSuggestion extends Invoice {
  formattedLabel?: string;
}
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    QRCodeModule,
    LoginComponent,
    NgxScannerQrcodeModule,
    ToggleButtonModule,
    ReactiveFormsModule,
    ...PrimeNgModule,
    LoginComponent,
    CashDenominationComponent,
    VariantSelectorComponent,
    InvoiceDetailsDialogComponent,
    HoldReceiptDialogComponent,
    ResumeReceiptDialogComponent,
    SalesHistoryDialogComponent,
    QuotationHistoryDialogComponent,
    OfferGroupCustomerDialogComponent,
    DashboardRightPanelComponent,
    SplitBillDialogComponent,
    PaymentTotalDialogComponent,
    FooterActionButtonsComponent,
    EmptyCartComponent,
    RestaurantDashboardComponent,
    RestaurantBillPanelComponent,
    QuotationOptionsDialogComponent,
  ],
  providers: [
    ProductDbService,
    ToasterService,
    ConfirmationService,
    MessageService,
    AuthService,
    CashDenominationService,
    ResumeReceiptService,
    DashboardPdfService,
    WhatsappShareService,
    CustomerLookupService,
    BarcodeScannerService,
    OfferGroupModeService,
    ProductMappingService,
    TransactionHistoryService,
    OrderModeService,
    KeyboardNavigationService,
    PaymentStatusService,
    BillNumberRefreshService,
    PosCalculationService,
    PaymentCalculationService,
    PaymentValidationService,
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss', './dashboard-dialogs.scss'],
})
export class DashboardComponent implements OnDestroy, OnInit, AfterViewInit {
  /** UI switch: true when logged-in user's industry is Restaurant (code 7) */
  get isRestaurantIndustry(): boolean {
    return this.industryConfig?.industryId === IndustryType.RESTAURANT;
  }

  /** UI switch: true when logged-in user's industry is Pharmacy (code 15) */
  get isPharmacyIndustry(): boolean {
    return this.industryConfig?.industryId === IndustryType.PHARMACY;
  }

  public INDUSTRY_ENUM = INDUSTRY_ENUM;
  industryConfig!: IndustryUiConfig;
  selectAll: boolean = false;
  mappingOptions: any;
  variants: any;
  displayModal!: boolean;
  items: MenuItem[] | undefined;
  isProductSearch: boolean = false;
  // filteredInvoiceSuggestions: InvoiceSuggestion[] = [];
  displayNoItem = false;
  isMobileMandatory = true;
  isDiscountAfterTaxEnabled = false;
  private productSearch$ = new Subject<string | undefined>();
  private productSearchSubscription!: Subscription;
  displayMobileNumberDialog = false;
  mobileNumber!: string;
  enableFreeQty: boolean = false;

  // Cash In/Out Dialog properties
  showCashInDialog = false;
  punchStatus: PunchStatus | null = null;
  private _customerName!: string;
  get customerName(): string {
    return this._customerName;
  }
  set customerName(value: string) {
    this._customerName = value;
  }

  showInvoiceDialog: boolean = false;

  displayHoldNameDialog: boolean = false;
  holdReceiptName: string = '';
  itemId = '';
  isBouncing: boolean = false;
  currentPSID: string = '';
  private destroy$ = new Subject<void>();

  /**
   * True when NetworkHealthService reports that placing an order is unsafe:
   * covers OFFLINE (no network), SLOW (3G-level), and CRITICAL (very slow).
   * Updated reactively from isOrderBlocked$ — no API call needed to trigger.
   */
  isOrderBlocked: boolean = false;

  /** True when the browser is completely offline */
  isNetworkOffline: boolean = false;
  autoCompletedselectedProduct!: Product;
  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  @ViewChild('dashboardContainer') dashboardContainer!: ElementRef;
  public scannerConfig: ScannerQRCodeConfig = scannerConfig;

  responsiveOptions = responsiveOptions;
  displayTransactions: boolean = false;
  transactions: Transaction[] = [];
  flattenedTransactions: any[] = []; // Flattened transaction items for table display
  selectedTransactionForPrint: string = ''; // UUID of selected transaction for printing
  selectedTransactionIndex: number = 0; // Index of currently selected transaction for keyboard navigation
  isNavigatingProgrammatically: boolean = false; // Flag to prevent radio button event loops

  // Quotation History properties
  quotations: Quotation[] = [];
  filteredQuotations: Quotation[] = []; // Filtered quotations for search
  quotationSearchTerm: string = ''; // Search term for quotation filtering
  selectedQuotationForView: string = ''; // UUID of selected quotation for viewing
  selectedQuotationIndex: number = 0; // Index of currently selected quotation for keyboard navigation
  activeHistoryTab: number = 0; // 0 = Transaction History, 1 = Quotation History
  selectedInvoiceData!: Invoice;
  // REFACTORED: moved to PaymentSessionService — see the getter/setter shims
  // near the other payment-session fields (activePaymentTab, cashAmount, etc.)
  get selectedInvoiceNo(): string {
    return this.paymentSessionState.selectedInvoiceNo;
  }
  set selectedInvoiceNo(value: string) {
    this.paymentSessionState.selectedInvoiceNo = value;
  }
  filteredInvoices: Invoice[] = []; // Array to hold filtered invoices for autocomplete
  selectedInvoice: Invoice | null = null; // To store the selected invoice (if needed)
  searchDate: Date | null = null; // To store the selected date
  currentSearchTerm: string = ''; // Current search term for highlighting
  isCounterSessionEnabled: boolean = false; // Flag to indicate if counter session monitoring is enabled (from client settings)
  selectedTransaction!: any;
  displayDialog: boolean = false; // for transaction detail dialog
  splitBillDialog: boolean = false;
  splitMethod: string = 'item';
  numberOfPeople: number = 1;
  savedReceipts: HoldReceiptInfo[] = [];
  selectedReceipt: string | null = null;
  savedReceiptsDialog: boolean = false;
  searchProductTerm = new FormControl(''); // Create FormControl with required validation
  hasScannerClicked = false;
  isDeleteMode = false; // Global Delete Mode flag (F9 toggle)
  isDateEditMode = false; // Global Date Edit Mode flag
  vatRate = 0;
  searchTerm: string = '';
  filteredProducts!: Partial<Product[]>; // Now an observable
  barcodeInput: string = ''; // For barcode search input
  showKeyboardHelp: boolean = false; // For keyboard shortcuts help
  private barcodeInputTimer: any;
  isBarcodeEnabled: boolean = true; // Barcode visibility from client settings
  isBatchEnabled: boolean = true; // Batch visibility from client settings
  isFreeQtyEnabled: boolean = false;

  /**
   * Returns the product's real barcode, or '' when it has none. When the barcode
   * setting is off at creation, the backend stores a generated 32-char hex UUID
   * as the barcode; that is never shown.
   */
  displayBarcode(product: any): string {
    const barcode = product?.barcode;
    if (!barcode) return '';
    if (product.showbarcode != null) return product.showbarcode == 1 ? barcode : '';
    return /^[0-9a-f]{32}$/i.test(barcode) ? '' : barcode;
  }

  showTotalDialog: boolean = false;
  showItemDetailDialog: boolean = false;
  showTransactionDialog: boolean = false;
  showDescriptionDialog: boolean = false;
  selectedProductForDescription: Product | null = null;
  tempDescription: string = '';
  showWarrantyDialog: boolean = false;
  selectedProductForWarranty: Product | null = null;
  tempWarrantyDate: Date | null = null;
  readonly today = new Date();
  private readonly accountRegistry = inject(AccountRegistryService);
  products: Product[] = [];
  // Discount mode options
  discountModeOptions = [
    { label: '%', value: 'percentage' },
    { label: '₹', value: 'amount' },
  ];

  discountMode: 'percentage' | 'amount' = 'percentage';

  enableOverAllDiscount: boolean = false;
  overAllDiscount: number = 0;
  overAllDiscountPercent: number = 0;
  overAllDiscountMode: 'percentage' | 'amount' = 'percentage';
  productsTemp: Partial<Product[]> = [];
  isExchangeOrder: boolean = false;
  isQuotationMode: boolean = false;
  isSuspenseMode: boolean = false;
  isWholesaleMode: boolean = false;
  modePermissions: ModePermissions = {
    wholesaleMode: false,
    quotationMode: false,
    suspenseMode: false,
    pricingGroupMode: false,
  };

  enableCursorFocus: boolean = false;
  isDecimalQuantityEnabled: boolean = false; // Decimal quantity support from client settings
  isSalesDiscountEditEnabled: boolean = false; // Sales discount edit permission from client settings
  isSalesPriceEditEnabled: boolean = false; // Sales price edit permission from client settings
  isUnitPriceInclTax: boolean = false; // Show unit price incl tax when true, excl tax when false (default)

  isOfferGroupMode = false;
  selectedOfferGroupId: number | null = null;
  lastSelectedOfferGroupId: number | null = null;
  pricingGroups: PricingGroup[] = [];
  customers: Customer[] = [];
  loadingCustomers = false;
  customerMobile = '';
  selectedCustomer: Customer | null = null;
  showOfferGroupCustomerDialog = false;
  hasCustomerOverride = false;

  filteredCustomers: Customer[] = [];
  filteredCustomersForMobile: Customer[] = [];
  filteredCustomersForOfferGroup: Customer[] = [];
  doctorName: string = '';
  doctorMobile: string = '';

  isEditingQuotation: boolean = false;

  pendingExchangePayload: {
    payload: any;
    needHold: boolean;
    tempId: string;
  } | null = null;
  editingQuotationUuid: string = '';
  editingQuotationNumber: string = ''; // Keep for display purposes
  quotationValidityDate: Date = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000); // Default: current date + 7 days
  minValidityDate: Date = new Date(); // Today
  maxValidityDate: Date = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000); // 30 days from now
  isProcessingQuotation: boolean = false; // Loading state for quotation processing
  /** Controls the pre-PDF quotation options popup */
  showQuotationOptionsDialog: boolean = false;
  /** Last resolved withGst preference from the options dialog */
  private _quotationWithGst: boolean = true;
  /** Exact customer details chosen in the quotation options dialog */
  private _quotationCustomerDetails: QuotationOptions | null = null;
  selectedProductId: string | null = null;
  hasScannedProduct: boolean = false;
  userName!: string;
  /* Payment variables start*/
  paymentOptions: string[] = ['Cash', 'UPI', 'Card', 'Redeem Credit'];
  @ViewChild('autoCompleteInput') autoCompleteInput!: AutoComplete;
  @ViewChild(PaymentTotalDialogComponent)
  paymentTotalDialogRef!: PaymentTotalDialogComponent;
  @ViewChild('offerGroupMobileAutocomplete')
  offerGroupMobileAutocomplete!: AutoComplete;
  private customerNameValidationTimer: any;
  private mobileNumberValidationTimer: any;

  private readonly _fallbackPaymentSessionState =
    createDefaultPaymentSessionState();
  private get paymentSessionState() {
    return (
      this.paymentTotalDialogRef?.session?.state ??
      this._fallbackPaymentSessionState
    );
  }

  get selectedPaymentOptions(): string | string[] | null {
    return this.paymentSessionState.selectedPaymentOptions;
  }
  set selectedPaymentOptions(value: string | string[] | null) {
    this.paymentSessionState.selectedPaymentOptions = value;
  }

  get isPartPaymentCash(): boolean {
    return this.paymentSessionState.isPartPaymentCash;
  }
  set isPartPaymentCash(value: boolean) {
    this.paymentSessionState.isPartPaymentCash = value;
  }

  get isPartPaymentCard(): boolean {
    return this.paymentSessionState.isPartPaymentCard;
  }
  set isPartPaymentCard(value: boolean) {
    this.paymentSessionState.isPartPaymentCard = value;
  }

  get isPartPaymentUPI(): boolean {
    return this.paymentSessionState.isPartPaymentUPI;
  }
  set isPartPaymentUPI(value: boolean) {
    this.paymentSessionState.isPartPaymentUPI = value;
  }

  get activePaymentTab(): 'Cash' | 'Card' | 'UPI' | 'Redeem Points' | 'Split' {
    return this.paymentSessionState.activePaymentTab;
  }
  set activePaymentTab(
    value: 'Cash' | 'Card' | 'UPI' | 'Redeem Points' | 'Split',
  ) {
    this.paymentSessionState.activePaymentTab = value;
  }

  get splitPaymentAmounts() {
    return this.paymentSessionState.splitPaymentAmounts;
  }
  set splitPaymentAmounts(value: { cash: number; card: number; upi: number }) {
    this.paymentSessionState.splitPaymentAmounts = value;
  }

  get cashAmount(): number {
    return this.paymentSessionState.cashAmount;
  }
  set cashAmount(value: number) {
    this.paymentSessionState.cashAmount = value;
  }

  get cardDetails() {
    return this.paymentSessionState.cardDetails;
  }
  set cardDetails(value: {
    name: string | null;
    number: number;
    expiry: string | null;
    amount: number | null;
    transactionId: string | null;
  }) {
    this.paymentSessionState.cardDetails = value;
  }

  get upiDetails() {
    return this.paymentSessionState.upiDetails;
  }
  set upiDetails(value: {
    upiId: string | null;
    upiAmount: number;
    transactionId: string | null;
  }) {
    this.paymentSessionState.upiDetails = value;
  }

  upiQrCodeImage: string | null = null;
  upiQrExpirySeconds: number | null = null;
  private upiPaymentRequestInFlight = false;
  paymentId: string | null = null;
  transactionId: string | null = null;

  loading = false;
  error = '';

  get redeemCreditAmount(): number {
    return this.paymentSessionState.redeemCreditAmount;
  }
  set redeemCreditAmount(value: number) {
    this.paymentSessionState.redeemCreditAmount = value;
  }

  get availableCreditAmount(): number {
    return this.paymentSessionState.availableCreditAmount;
  }
  set availableCreditAmount(value: number) {
    this.paymentSessionState.availableCreditAmount = value;
  }

  isLoadingCreditAmount: boolean = false;
  hasShownCreditNumberMessage: boolean = false;

  get refundCashAmount(): number {
    return this.paymentSessionState.refundCashAmount;
  }
  set refundCashAmount(value: number) {
    this.paymentSessionState.refundCashAmount = value;
  }

  currentOrderId!: string;
  holdOrderId!: string;
  showExchangeConfirmation: boolean = false;
  invoice!: Invoice;
  formData: {
    currentDate: Date | null;
    empCode: string;
    storeCode: string;
    mobileNumber: string;
    customerName: string;
    salesRep: string;
  } | null = null;

  // Add missing properties (restored)
  showItemDetail: boolean = false;
  showBillDetail: boolean = true;
  showCalculator: boolean = false;
  activeItem: any = null;

  // ===== INFINITE SCROLL / PAGINATION STATE =====
  // 1. Declare pagination state variables
  page: number = 1;
  pageSize: number = 20;
  currentSearchText: string = '';
  hasMore: boolean = false;
  /** True while a load-more API call is in flight (prevents duplicate page requests) */
  isLoadingMoreProducts: boolean = false;
  /** True if there are more pages to fetch for the current search query */
  hasMoreProducts: boolean = false;
  /** The search query that the currently displayed filteredProducts belong to */
  private activeSearchQuery: string = '';
  /** Subject to trigger loading the next page — concatMap serializes requests */
  private loadMorePage$ = new Subject<void>();
  /** Reference to the scroll handler function so it can be removed exactly */
  private autocompleteScrollHandler: ((event: Event) => void) | null = null;
  /** The panel element we attached the scroll listener to */
  private autocompletePanel: Element | null = null;

  public get storename() {
    return JSON.parse(localStorage.getItem('storename') || '{}');
  }

  private clientId = localStorage.getItem('client_id');

  private customEventSubscription: Subscription;
  private authSubscription!: Subscription;
  private formDataSubscription: Subscription | undefined;

  selectedVariantProduct: Product | null = null;
  variantOpenTick = 0;
  openVariantSelector(product: Product, event: MouseEvent) {
    event.stopPropagation();

    this.selectedVariantProduct = product;
    this.variantOpenTick++;
  }

  // One-shot open signal: once the row's dialog has opened, clear the target
  // so a later re-render of that row (variant/mapping change alters its
  // trackBy key) doesn't reopen the popup. Deferred to avoid changing the
  // [openSignal] binding mid change-detection.
  onVariantOpenSignalConsumed(product: Product) {
    Promise.resolve().then(() => {
      if (this.selectedVariantProduct === product) {
        this.selectedVariantProduct = null;
      }
    });
  }

  onVariantSelected(product: Product, value: ProductMapValue) {
    // Stock guard: the chosen batch/variant pool is shared by every cart row
    // pointing at it (any mapping), so check what's left excluding this row
    // before committing - otherwise a second row could claim the same IMEI
    // or the last unit of a color.
    const poolKeyForPick = this.mobileStockReservationService.buildPoolKey(product.psid, value.id);
    const availableForPick = this.mobileStockReservationService.getAvailableQty(
      poolKeyForPick,
      value.qty,
      this.products,
      [product],
    );
    if (availableForPick < (product.increaseQuantity || 1)) {
      this.messageService.add({
        severity: 'warn',
        summary: availableForPick <= 0 ? 'Already in Cart' : 'Stock Limited',
        detail: availableForPick <= 0
          ? `${this.getVariantSummary(value)} has no stock left - it is already in the cart.`
          : `Only ${availableForPick} left for ${this.getVariantSummary(value)}.`,
        life: 3000,
      });
      // A pending row that never got a variant has nothing to fall back to.
      if (!product.selectedMapValue) {
        const pendingIndex = this.products.indexOf(product);
        if (pendingIndex !== -1) {
          this.products.splice(pendingIndex, 1);
        }
      }
      this.productsTemp = this.products.map((p) => ({ ...p }));
      return;
    }

    product.selectedMapValue = value;
    delete product.isPendingVariant;

    const productMappingId = product.mapping_id ?? product.selectedMappingId ?? null;

    const duplicateIndex = this.products.findIndex((item) => {
      if (item === product) return false;
      if (item.psid?.toLowerCase() !== product.psid?.toLowerCase())
        return false;
      if (item.selectedMapValue?.id !== value.id) return false;

      const existingMappingId =
        item.mapping_id ?? item.selectedMappingId ?? null;

      // Pre-mapping phase: either side has no mapping → do NOT merge yet
      if (productMappingId == null || existingMappingId == null) return false;

      // Post-mapping phase: both have a mapping — merge only on exact triple match
      return existingMappingId === productMappingId;
    });

    if (duplicateIndex === -1) {
      // No duplicate anywhere else — nothing more to do.
      product.stockquanity = value.qty;
      this.productsTemp = this.products.map((p) => ({ ...p }));
      if (this.industryService.isMobile()) {
        this.mobileStockReservationService.syncToStorage(this.products);
      }
      return;
    }

    const existingItem = this.products[duplicateIndex];
    const currentIndex = this.products.indexOf(product);
    const isSerialized = !!value.parameter1_value; // IMEI / serial present

    if (isSerialized) {
      if (currentIndex !== -1) {
        this.products.splice(currentIndex, 1);
      }
      this.productsTemp = this.products.map((p) => ({ ...p }));
      this.messageService.add({
        severity: 'warn',
        summary: 'Already in Cart',
        detail: `${this.getVariantSummary(value)} is already in the cart removed the duplicate row.`,
        life: 3000,
      });
      return;
    }

    // Non-serialized variant (plain color/size pool) â€” safe to sum
    // quantities across the two rows, capped at what the shared
    // batch/variant pool actually has (excluding both merging rows, since
    // their combined qty is about to become the pool's only claim from
    // this cart — any OTHER mapping row still drawing from the same pool
    // is left out of the two rows below and still subtracted correctly).
    const existingQty = existingItem.increaseQuantity || 0;
    const thisRowQty = product.increaseQuantity || 1;
    const combinedQty = existingQty + thisRowQty;
    const poolKey = this.mobileStockReservationService.buildPoolKey(
      product.psid,
      value.id,
    );
    const maxQty = this.mobileStockReservationService.getAvailableQty(
      poolKey,
      value.qty,
      this.products,
      [product, existingItem],
    );

    existingItem.increaseQuantity = Math.min(combinedQty, maxQty);
    if (currentIndex !== -1) {
      this.products.splice(currentIndex, 1);
    }
    this.productsTemp = this.products.map((p) => ({ ...p }));
    if (this.industryService.isMobile()) {
      this.mobileStockReservationService.syncToStorage(this.products);
    }

    if (combinedQty > maxQty) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Stock Limited',
        detail: `Combined quantity capped at available stock (${maxQty}) for ${this.getVariantSummary(value)}`,
        life: 3000,
      });
    } else {
      this.messageService.add({
        severity: 'success',
        summary: 'Merged',
        detail: `Combined with existing ${this.getVariantSummary(value)} row - quantity now ${existingItem.increaseQuantity}`,
        life: 3000,
      });
    }
  }
  constructor(
    private readonly productService: ProductDbService,
    private formDataService: FormDataService,
    private readonly authService: AuthService,
    private readonly eventService: KeyboardEventService,
    private readonly toasterService: ToasterService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private readonly whatsappShareService: WhatsappShareService,
    private readonly clientSettingsService: ClientSettingsService,
    private readonly offerGroupService: OfferGroupService,
    private readonly pdfGenerationService: PdfGenerationService,
    private readonly clientTemplateService: ClientTemplateService,
    private readonly cashDenominationService: CashDenominationService,
    private readonly dynamicTemplateConfigService: DynamicTemplateConfigService,
    private readonly pdfUploadService: PdfUploadService,
    private readonly ngZone: NgZone,
    private readonly router: Router,
    private route: ActivatedRoute,
    private industryUiConfigService: IndustryUiConfigService,
    private readonly industryService: IndustryService,
    private readonly resumeReceiptService: ResumeReceiptService,
    private readonly posCalculationService: PosCalculationService,
    private readonly paymentCalculationService: PaymentCalculationService,
    private readonly paymentValidationService: PaymentValidationService,
    private readonly dashboardPdfService: DashboardPdfService,
    private readonly focusManagerService: FocusManagerService,
    private readonly keyboardNavigationService: KeyboardNavigationService,
    private readonly customerLookupService: CustomerLookupService,
    private readonly barcodeScannerService: BarcodeScannerService,
    private readonly paymentStatusService: PaymentStatusService,
    private readonly offerGroupModeService: OfferGroupModeService,
    private readonly orderModeService: OrderModeService,
    private readonly transactionHistoryService: TransactionHistoryService,
    private readonly productMappingService: ProductMappingService,
    private readonly mobileStockReservationService: MobileStockReservationService,
    public readonly billingGuardService: BillingGuardService,
    private readonly networkHealthService: NetworkHealthService,
    private readonly billNumberRefreshService: BillNumberRefreshService,
  ) {
    this.customEventSubscription = this.eventService.customEvent$.subscribe(
      (eventId) => {
        this.handleEvent(eventId);
      },
    );
    this.productSearchSubscription = this.productSearch$
      .pipe(
        debounceTime(200),
        // switchMap cancels the in-flight request on every new keystroke,
        // which also handles search race conditions automatically.
        switchMap((searchText) => {
          const query = searchText ?? '';

          // ── Reset pagination on every new search ──────────────────────────
          this.page = 1;
          this.hasMoreProducts = true;
          this.isLoadingMoreProducts = false;
          this.activeSearchQuery = query; // track to guard stale append
          this.currentSearchText = query;
          // ─────────────────────────────────────────────────────────────────

          const groupId = this.isOfferGroupMode
            ? this.selectedOfferGroupId
            : undefined;
          return this.productService
            .getAllProduct(query, groupId, this.page, this.pageSize)
            .pipe(
              catchError((error) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Search Error',
                  detail: 'Failed to fetch products. Please try again.',
                  life: 3000,
                });
                return of({
                  code: '500',
                  status: 500,
                  data: [],
                  message: 'Error fetching products',
                } as ProductHttpResponse);
              }),
            );
        }),
      )
      .subscribe((productsResponse: ProductHttpResponse) => {
        const data = productsResponse.data ?? [];
        if (data.length > 0) {
          // Replace (not append) — this is always page 1 from a fresh search
          this.formAllProducts(data);
          // Determine whether more pages exist
          this.hasMoreProducts = data.length >= this.pageSize;
        } else {
          this.filteredProducts = [];
          this.hasMoreProducts = false;
        }
      });
  }

  onSelectAllToggle(event: any) {
    const isChecked = event.checked;

    // Assuming 'this.products' is your array of row data
    // and it uses the 'selected' property like your other checkboxes
    if (this.products && this.products.length > 0) {
      this.products.forEach((product) => {
        product.selected = isChecked;
      });
    }
  }

  // ===== INFINITE SCROLL METHODS =====

  /**
   * Called by (onShow) on p-autoComplete.
   *
   * ROOT CAUSE FIX:
   * The CSS sets:
   *   .enhanced-autocomplete-panel { overflow: hidden !important }  ← outer panel, NOT scrollable
   *   .p-autocomplete-items         { overflow-y: auto !important }  ← ACTUAL scrollable element
   *
   * So we must attach the scroll listener to .p-autocomplete-items inside the panel,
   * NOT to .enhanced-autocomplete-panel itself (which never fires scroll events).
   */
  attachAutocompleteScrollListener(): void {
    setTimeout(() => {
      // Target the ACTUAL scrollable element — .p-autocomplete-items inside the panel.
      // .enhanced-autocomplete-panel has overflow:hidden so scroll events never fire on it.
      const scrollableEl = document.querySelector(
        '.enhanced-autocomplete-panel .p-autocomplete-items',
      ) as HTMLElement;

      if (!scrollableEl) {
        console.warn(
          '[InfiniteScroll] Could not find .p-autocomplete-items inside panel.',
        );
        return;
      }

      // Detach any existing listener first to avoid duplicates.
      this.detachAutocompleteScrollListener();

      this.autocompletePanel = scrollableEl;
      this.autocompleteScrollHandler = (event: Event) =>
        this.onAutocompleteScroll(event);
      scrollableEl.addEventListener('scroll', this.autocompleteScrollHandler, {
        passive: true,
      });

      console.log(
        '[InfiniteScroll] Scroll listener attached to:',
        scrollableEl,
      );
    }, 150);
  }

  /**
   * Called by (onHide) on p-autoComplete and in ngOnDestroy.
   * Safely removes the scroll listener to avoid memory leaks.
   */
  detachAutocompleteScrollListener(): void {
    if (this.autocompletePanel && this.autocompleteScrollHandler) {
      this.autocompletePanel.removeEventListener(
        'scroll',
        this.autocompleteScrollHandler,
      );
    }
    this.autocompletePanel = null;
    this.autocompleteScrollHandler = null;
  }

  /**
   * Scroll handler invoked when the user scrolls inside the autocomplete items list.
   * Triggers loadMorePage$ when within 80px of the bottom.
   */
  onAutocompleteScroll(event: Event): void {
    const el = event.target as HTMLElement;
    if (!el) return;

    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    const threshold = 80; // px from bottom to trigger next page load

    if (
      distanceFromBottom <= threshold &&
      !this.isLoadingMoreProducts &&
      this.hasMoreProducts
    ) {
      console.log(
        '[InfiniteScroll] Near bottom, loading next page:',
        this.page + 1,
      );
      this.loadMorePage$.next();
    }
  }

  /**
   * Fetches the next page of products and APPENDS them to filteredProducts.
   *
   * Guards:
   *  - isLoadingMoreProducts: prevents duplicate in-flight requests for same page.
   *  - hasMoreProducts: stops loading once the server has no more results.
   *  - activeSearchQuery check after response: prevents stale search results
   *    from being appended to a newer search's results.
   */
  loadMoreProducts(): void {
    if (this.isLoadingMoreProducts || !this.hasMoreProducts) {
      return;
    }

    this.isLoadingMoreProducts = true;
    this.page++; // Advance to the next page

    const query = this.activeSearchQuery;
    const groupId = this.isOfferGroupMode
      ? this.selectedOfferGroupId
      : undefined;

    this.productService
      .getAllProduct(query, groupId, this.page, this.pageSize)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: ProductHttpResponse) => {
          this.isLoadingMoreProducts = false;

          // Guard: if the user changed their search while this request was in
          // flight, discard this response to prevent stale data being appended.
          if (query !== this.activeSearchQuery) {
            console.log(
              '[InfiniteScroll] Discarding stale page response for:',
              query,
            );
            return;
          }

          const newProducts = response?.data ?? [];
          if (newProducts.length > 0) {
            // Snapshot existing filteredProducts BEFORE calling formAllProducts,
            // because formAllProducts calls setFilteredProducts internally which
            // REPLACES the array (not appends).
            const existingProducts: any[] =
              (this.filteredProducts as any[]) ?? [];

            // formAllProducts will call setFilteredProducts (= this.filteredProducts = newFormatted).
            // After this call, this.filteredProducts contains only the new page's items.
            this.formAllProducts(newProducts);

            // Now append: existing + newly formatted
            this.filteredProducts = [
              ...existingProducts,
              ...((this.filteredProducts as any[]) ?? []),
            ] as any;

            // If fewer results than a full page, we have reached the end.
            this.hasMoreProducts = newProducts.length >= this.pageSize;
          } else {
            // No more results from the server.
            this.hasMoreProducts = false;
          }
        },
        error: (error: any) => {
          this.isLoadingMoreProducts = false;
          this.page--; // Roll back so user can retry.
          console.error('[InfiniteScroll] Error loading more products:', error);
        },
      });
  }
  // ===== END INFINITE SCROLL METHODS =====

  ngOnInit() {
    // Switch Company warns before dropping an unsaved bill
    this.accountRegistry.setPendingBillCounter(() => this.products.length);
    this.whatsappShareService.loadApiStatus();
    this.paymentStatusService.status$
      .pipe(takeUntil(this.destroy$))
      .subscribe((statusUpdate) => this.handleTrackedUpiStatus(statusUpdate));

    // ── Network billing-block guard ────────────────────────────────────────────
    // isOrderBlocked$ covers OFFLINE, SLOW, and CRITICAL states.
    // Reactively disables Process Order/Payment button — no API call needed.
    // Slow-network blocking disabled — orders are now blocked only when OFFLINE.
    // this.networkHealthService.isOrderBlocked$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((blocked) => {
    //     this.isOrderBlocked = blocked;
    //   });

    this.networkHealthService.isOffline$
      .pipe(takeUntil(this.destroy$))
      .subscribe((offline) => {
        this.isNetworkOffline = offline;
        this.isOrderBlocked = offline;
      });
    // ───────────────────────────────────────────────────────────────────

    // ===== INFINITE SCROLL: subscribe to loadMorePage$ in ngOnInit =====
    // concatMap: serializes requests — if a load is already in flight,
    // the next void emission queues and waits rather than firing immediately.
    this.loadMorePage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadMoreProducts());
    // ====================================================================

    this.industryUiConfigService.config$
      .pipe(takeUntil(this.destroy$))
      .subscribe((cfg) => {
        if (cfg) {
          this.industryConfig = cfg;
        }
      });
    this.dynamicTemplateConfigService.loadClientSaleData().subscribe();
    // SSO Login: check query params for SSO token FIRST before any auto-login
    this.route.queryParams.subscribe((params) => {
      if (params['forceLogout']) {
        this.authService.logoutSilently();
        sessionStorage.clear();
      }
      const ssoToken = params['sso'];

      if (ssoToken) {
        // Hide the login dialog immediately for SSO flow
        this.displayModal = false;

        // Clear all existing session data from localStorage BEFORE anything else
        localStorage.removeItem('storename');
        localStorage.removeItem('name');
        localStorage.removeItem('client_id');
        localStorage.removeItem('auth_credentials');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
        localStorage.removeItem('punchStatus');
        localStorage.removeItem('shiftStartTime');
        localStorage.removeItem('shiftEndTime');
        this.mobileStockReservationService.clear();

        // Reset the auth subject so old user data doesn't interfere
        this.authService.setUserValue(null as any);

        this.loading = true;

        // Call SSO login API - this internally sets localStorage items
        // (name, storename, client_id) from the response
        this.authService.ssoLogin(ssoToken).subscribe({
          next: (data) => {
            // Update the auth user subject so subscribers pick it up
            this.authService.setUserValue(data);
            this.userName = data.name || '';

            // Store shift times if counter session exists
            if (data.countersession) {
              this.cashDenominationService.storeShiftTimes(
                data.countersession.start_time,
                data.countersession.end_time,
              );
            }

            this.loading = false;
            // Reload client settings and templates with new client_id
            this.loadClientSettings();
            this.loadClientTemplates();
            this.checkPunchStatusOnLoad();

            // Clean the SSO token from the URL to prevent re-triggering on refresh
            this.router.navigate([], {
              queryParams: { sso: null },
              queryParamsHandling: 'merge',
              replaceUrl: true,
            });
          },
          error: (error) => {
            this.loading = false;
            this.error = error?.error?.message || 'SSO Login failed';
            console.error('SSO Login failed:', error);
            // Show login dialog on SSO failure so user can login manually
            this.displayModal = true;
          },
        });
      } else {
        // Normal flow - show login dialog if no user is authenticated
        this.displayModal = true;

        // Normal login flow - subscribe to auth user changes
        this.authSubscription = this.authService.currentUser.subscribe(
          (user: User) => {
            this.userName = user && user.name ? user.name : '';

            // Check punch status after user is authenticated
            if (this.userName) {
              this.displayModal = false;
              this.checkPunchStatusOnLoad();
            }
          },
        );
      }
    });

    // console.log('Client ID:', parseInt(this.clientId ?? ''));
    this.loadClientSettings();
    this.loadClientTemplates();
    const clientId = parseInt(this.clientId ?? '');
    if (clientId) {
      this.dynamicTemplateConfigService
        .preloadTemplateConfig(clientId)
        .subscribe({
          next: () => {
            console.log('[Dashboard] Client data preloaded on init');
          },
          error: (error) => {
            console.error(
              '[Dashboard] Error preloading client data on init:',
              error,
            );
          },
        });
    }

    if (this.industryService.isRetail()) {
      this.loadPricingGroups();
    }

    this.formDataSubscription = this.formDataService.formData$.subscribe(
      (data) => {
        this.formData = data;
        const newMobileNumber = data?.mobileNumber || '';
        const newCustomerName = data?.customerName || '';
        const newCustomerId = data?.customerId;

        if (this.isOfferGroupMode && newMobileNumber !== this.mobileNumber) {
          this.customerMobile = newMobileNumber;
          this.ensureCustomersLoaded().then(() => {
            this.onMobileEntered();
            this.updateHeaderAfterCustomerLookup();
          });
        }

        this.mobileNumber = newMobileNumber;
        this.customerName = newCustomerName;

        if (
          newCustomerId &&
          (!this.selectedCustomer || this.selectedCustomer.id !== newCustomerId)
        ) {
          this.ensureCustomersLoaded().then(() => {
            const customer = this.customers.find((c) => c.id === newCustomerId);
            if (customer) {
              this.selectedCustomer = customer;
            }
          });
        }
      },
    );

    // Subscribe to pricing group changes from the dropdown (layout component)
    this.offerGroupService.selectedGroup$.subscribe((groupId) => {
      if (
        this.isOfferGroupMode &&
        groupId !== null &&
        groupId !== this.selectedOfferGroupId
      ) {
        const previousGroupId = this.selectedOfferGroupId;
        this.selectedOfferGroupId = groupId;

        if (previousGroupId !== null) {
          const currentSearchText =
            typeof this.itemId === 'string' ? this.itemId : '';

          if (currentSearchText && currentSearchText.trim() !== '') {
            this.getProducts(currentSearchText);
          }

          // Update existing cart items with new pricing group's offer prices
          this.updateExistingItemsWithOfferPrices(groupId);
        }
      }
    });
    this.displayNoItem = true;
  }

  ngAfterViewInit() {
    // Setup global keyboard shortcut support
    this.setupGlobalKeyboardShortcuts();
    if (
      this.offerGroupMobileAutocomplete &&
      this.offerGroupMobileAutocomplete.el
    ) {
      const inputElement =
        this.offerGroupMobileAutocomplete.el.nativeElement.querySelector(
          'input',
        );
      if (inputElement) {
        inputElement.setAttribute('maxlength', '10');
        inputElement.setAttribute('inputmode', 'numeric');
        inputElement.setAttribute('pattern', '[0-9]*');

        // Restrict to numbers only on keypress
        inputElement.addEventListener('keypress', (event: KeyboardEvent) => {
          const charCode = event.which ? event.which : event.keyCode;
          const isMainKeyboardNumber = charCode >= 48 && charCode <= 57;
          const isNumpadNumber = charCode >= 96 && charCode <= 105;
          const isSpecialKey = [8, 9, 13, 46, 37, 38, 39, 40].includes(
            charCode,
          );

          if (!isMainKeyboardNumber && !isNumpadNumber && !isSpecialKey) {
            event.preventDefault();
          }
        });

        // Handle paste event to allow only numbers
        inputElement.addEventListener('paste', (event: ClipboardEvent) => {
          event.preventDefault();
          const pastedText = event.clipboardData?.getData('text') || '';
          const numericValue = pastedText
            .replace(/[^0-9]/g, '')
            .substring(0, 10);

          this.customerMobile = numericValue;
          const target = event.target as HTMLInputElement;
          if (target) {
            target.value = numericValue;
          }
        });

        inputElement.addEventListener('input', (event: any) => {
          const numericValue = event.target.value.replace(/[^0-9]/g, '');
          if (event.target.value !== numericValue) {
            event.target.value = numericValue;
            this.customerMobile = numericValue;
          }
        });
      }
    }
  }

  // MOVED-TO: src/app/shared/services/customer-lookup.service.ts -> CustomerLookupService (whole cluster)
  // Builds the shared dependency bag for the customer-lookup cluster (mobile/name
  // change handlers, autocomplete filtering, debounced validation, and the
  // proceed-gating checks). These methods call each other, so they were extracted
  // together rather than one at a time. `validateCustomerName`/`validateMobileNumber`
  // route back through this component's own delegating methods (not the service
  // sibling directly) so debounce timers always see live state when they fire.
  private buildCustomerLookupDeps(): CustomerLookupDeps {
    return {
      mobileNumber: this.mobileNumber,
      customerName: this.customerName,
      customers: this.customers,
      getCustomers: () => this.customers,
      holdReceiptName: this.holdReceiptName,
      isMobileMandatory: this.isMobileMandatory,
      customerNameValidationTimer: this.customerNameValidationTimer,
      mobileNumberValidationTimer: this.mobileNumberValidationTimer,
      loadingCustomers: this.loadingCustomers,
      formData: this.formData,
      setMobileNumber: (value) => (this.mobileNumber = value),
      setCustomerName: (value) => (this.customerName = value),
      setCustomers: (value) => (this.customers = value),
      setSelectedCustomer: (value) => (this.selectedCustomer = value),
      setFilteredCustomers: (value) => (this.filteredCustomers = value),
      setFilteredCustomersForMobile: (value) =>
        (this.filteredCustomersForMobile = value),
      setCustomerNameValidationTimer: (value) =>
        (this.customerNameValidationTimer = value),
      setMobileNumberValidationTimer: (value) =>
        (this.mobileNumberValidationTimer = value),
      setLoadingCustomers: (value) => (this.loadingCustomers = value),
      setIsMobileMandatory: (value) => (this.isMobileMandatory = value),
      setDisplayMobileNumberDialog: (value) =>
        (this.displayMobileNumberDialog = value),
      setDisplayHoldNameDialog: (value) => (this.displayHoldNameDialog = value),
      resetLoyaltyData: () =>
        this.paymentTotalDialogRef?.loyalty?.resetLoyaltyData(),
      validateCustomerName: () => this.validateCustomerName(),
      validateMobileNumber: () => this.validateMobileNumber(),
    };
  }

  onMobileNumberChange(event: any) {
    this.customerLookupService.onMobileNumberChange(
      event,
      this.buildCustomerLookupDeps(),
    );
  }

  handleMobileNumberPaste(event: ClipboardEvent) {
    this.customerLookupService.handleMobileNumberPaste(
      event,
      this.buildCustomerLookupDeps(),
    );
  }

  onCustomerNameChange(event: any) {
    this.customerLookupService.onCustomerNameChange(
      event,
      this.buildCustomerLookupDeps(),
    );
  }

  // Filter customers for autocomplete
  async filterCustomers(event: any) {
    await this.customerLookupService.filterCustomers(
      event,
      this.buildCustomerLookupDeps(),
    );
  }

  // Handle customer selection from autocomplete
  onCustomerSelectFromAutocomplete(event: any) {
    const customer = event.value || event;
    if (customer && customer.customer_name) {
      this.customerName = customer.customer_name;
      this.mobileNumber = customer.mobile_no;
      this.selectedCustomer = customer;

      // Load loyalty points if customer has ID
      if (customer.id) {
        this.paymentTotalDialogRef?.loyalty?.loadCustomerLoyaltyPoints(
          customer.id,
          this.isExchangeOrder,
        );
      }

      // Update form data service
      this.formDataService.updateFormData({
        ...this.formData,
        mobileNumber: this.mobileNumber,
        empCode: this.formData?.empCode || '',
        storeCode: this.formData?.storeCode || '',
        currentDate: this.formData?.currentDate || new Date(),
        customerName: this.customerName || '',
        salesRep: this.formData?.salesRep || '',
        customerId: customer.id,
      });
    }
  }

  // Filter customers for mobile number autocomplete
  async filterCustomersByMobile(event: any) {
    await this.customerLookupService.filterCustomersByMobile(
      event,
      this.buildCustomerLookupDeps(),
    );
  }

  // Handle mobile number selection from autocomplete
  onMobileSelectFromAutocomplete(event: any) {
    const customer = event.value || event;
    if (customer && customer.mobile_no) {
      this.mobileNumber = customer.mobile_no;
      this.customerName = customer.customer_name;
      this.selectedCustomer = customer;

      // Load loyalty points if customer has ID
      if (customer.id) {
        this.paymentTotalDialogRef?.loyalty?.loadCustomerLoyaltyPoints(
          customer.id,
          this.isExchangeOrder,
        );
      }

      //alert('Mobile Number' + this.mobileNumber);
      // Update form data service
      this.formDataService.updateFormData({
        ...this.formData,
        mobileNumber: this.mobileNumber,
        empCode: this.formData?.empCode || '',
        storeCode: this.formData?.storeCode || '',
        currentDate: this.formData?.currentDate || new Date(),
        customerName: this.customerName || '',
        salesRep: this.formData?.salesRep || '',
        customerId: customer.id,
      });
    }
  }

  // Handle customer name model change (when user types)
  onCustomerNameModelChange(value: any) {
    this.customerLookupService.onCustomerNameModelChange(
      value,
      this.buildCustomerLookupDeps(),
    );
  }

  // Validate customer name and clear mobile if not found
  private validateCustomerName() {
    this.customerLookupService.validateCustomerName(
      this.buildCustomerLookupDeps(),
    );
  }

  onCustomerNameInputBlur() {
    this.customerLookupService.onCustomerNameInputBlur(
      this.buildCustomerLookupDeps(),
    );
  }

  onMobileNumberModelChange(value: any) {
    this.customerLookupService.onMobileNumberModelChange(
      value,
      this.buildCustomerLookupDeps(),
    );
  }

  private validateMobileNumber() {
    this.customerLookupService.validateMobileNumber(
      this.buildCustomerLookupDeps(),
    );
  }

  onMobileNumberInputBlur() {
    this.customerLookupService.onMobileNumberInputBlur(
      this.buildCustomerLookupDeps(),
    );
  }

  canProceedMobile(): boolean {
    return this.customerLookupService.canProceedMobile(
      this.buildCustomerLookupDeps(),
    );
  }

  canProceedReceipt(): boolean {
    return this.customerLookupService.canProceedReceipt(
      this.buildCustomerLookupDeps(),
    );
  }
  // handleTabChange method removed - tabs converted to popups

  handleEvent(eventId: string): void {
    // Handle each event based on eventId (e.g., F1, F2, ...)

    // Block ALL F-keys when ANY dialog is open - only one dialog at a time
    const hasOpenDialog =
      this.showCashInDialog ||
      this.showTotalDialog ||
      this.showInvoiceDialog ||
      this.showTransactionDialog ||
      this.displayHoldNameDialog ||
      this.savedReceiptsDialog ||
      this.showKeyboardHelp ||
      this.showOfferGroupCustomerDialog ||
      this.displayDialog ||
      this.splitBillDialog ||
      this.showItemDetailDialog ||
      this.showDescriptionDialog ||
      this.showWarrantyDialog ||
      this.showQuotationOptionsDialog ||
      this.displayMobileNumberDialog ||
      this.isDeleteMode; // Block F-keys when delete mode is active

    if (
      hasOpenDialog &&
      [
        'F1',
        'F2',
        'F3',
        'F4',
        'F5',
        'F6',
        'F7',
        'F8',
        'F9',
        'F10',
        'F11',
        'F12',
      ].includes(eventId)
    ) {
      // Allow F9 to pass through even in delete mode (to toggle delete mode off)
      if (eventId === 'F9' && this.isDeleteMode) {
        // Let F9 pass through to toggle delete mode
      } else {
        return; // Block all other F-keys when any dialog is open or delete mode is active
      }
    }

    switch (eventId) {
      case 'F1':
        this.printReceipt(false);
        break;
      case 'F2':
        this.openTransactionDialog();
        break;
      case 'F3':
        if (this.showOfferGroupCustomerDialog) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Not Available',
            detail:
              'Exchange is not available while Offer Group dialog is open',
            life: 3000,
          });
        } else {
          this.exchangeProduct();
        }
        //    this.showSplitBillDialog();
        break;
      case 'F4':
        // saveReceipt(true) internally calls canProceedReceipt() which opens
        // displayHoldNameDialog and focuses the first input if needed.
        // HoldReceiptDialogComponent also auto-focuses on ngOnChanges.
        // DO NOT call focusHoldReceiptNameInput() here â€” it causes a double-trigger.
        this.saveReceipt(true);
        break;
      case 'F5':
        this.canResetPOS(this);
        break;
      case 'F6':
        // Use the new facade-backed method instead of the old showSavedReceiptsDialog().
        // onOpenResumeDialog() fetches receipts via ResumeReceiptService and opens the dialog.
        this.onOpenResumeDialog();
        break;
      case 'F7':
        if (this.isOrderBlocked) {
          this.showOrderBlockedMessage();
          break;
        }
        if (this.isExchangeOrder) {
          if (this.products && this.products.length > 0) {
            this.showTotalDialog = true;
            if (this.enableCursorFocus) {
              setTimeout(() => {
                this.focusFirstDialogElement();
              }, 100);
            }
          } else {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Exchange',
              detail: 'Please add items to process exchange',
              life: 3000,
            });
          }
        } else if (this.canProcessPayment()) {
          this.showTotalDialog = true;
          if (this.enableCursorFocus) {
            setTimeout(() => {
              this.focusFirstDialogElement();
            }, 100);
          }
        } else if (this.hasOnlyFreeItemsInMobileCart()) {
          this.processFreeMobileCheckout();
        } else {
          const hasProducts = this.products && this.products.length > 0;
          const total = this.getRoundedTotal();

          if (!hasProducts) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Payment',
              detail: 'Please add items to cart before processing payment',
              life: 3000,
            });
          } else if (total <= 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Payment',
              detail:
                'Order total is ₹0. Please check item prices and quantities',
              life: 3000,
            });
          }
        }
        break;
      case 'F8':
        if (this.isOrderBlocked) {
          this.showOrderBlockedMessage();
          break;
        }
        if (this.isExchangeOrder) {
          if (this.products && this.products.length > 0) {
            this.showTotalDialog = true;
            if (this.enableCursorFocus) {
              setTimeout(() => {
                this.focusFirstDialogElement();
              }, 100);
            }
          } else {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Exchange',
              detail: 'Please add items to process exchange',
              life: 3000,
            });
          }
        } else if (this.canProcessPayment()) {
          this.showTotalDialog = true;
          if (this.enableCursorFocus) {
            setTimeout(() => {
              this.focusFirstDialogElement();
            }, 100);
          }
        } else if (this.hasOnlyFreeItemsInMobileCart()) {
          this.processFreeMobileCheckout();
        } else {
          const hasProducts = this.products && this.products.length > 0;
          const total = this.getRoundedTotal();

          if (!hasProducts) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Payment',
              detail: 'Please add items to cart before processing payment',
              life: 3000,
            });
          } else if (total <= 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cannot Process Payment',
              detail:
                'Order total is ₹0. Please check item prices and quantities',
              life: 3000,
            });
          }
        }
        break;
      case 'F9':
        // Disable F9 delete functionality in exchange mode
        if (this.isExchangeOrder) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Not Available',
            detail: 'Delete functionality is disabled in exchange mode',
            life: 3000,
          });
        } else {
          this.toggleDeleteMode();
        }
        break;
      // F10, F11, F12 are handled by layout component - not via customEvent$

      default:
        break;
    }
  }

  showPaymentMode() {
    this.displayDialog = false;
  }

  deleteItem() {
    if (this.selectedProductId) {
      const foundProduct = this.getSelectedProduct(this.selectedProductId);
      if (foundProduct) {
        this.displayNoItem = true;
        this.removeItem(foundProduct);
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Select an item',
        detail: 'Item not Selected',
        life: 3000,
      });
    }
  }

  confirmDeleteItem(product: Product) {
    this.confirmationService.confirm({
      message: `Are you sure you want to remove "${product.name}" from the cart?`,
      header: 'Remove Item',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.deleteItemCompletely(product);
      },
      reject: () => {
        // User cancelled - do nothing
      },
      key: 'positionDialog',
    });
  }

  deleteItemCompletely(product: Product) {
    const productDetails = {
      productId: product.productId,
      psid: product.psid,
      name: product.name,
      quantity: product.increaseQuantity,
      sellingprice: product.sellingprice,
      hsncode: product.hsncode,
      tax: product.tax,
      ctax: product.ctax,
      stax: product.stax,
      warehouse_id: product.warehouse_id,
      deletedAt: new Date().toISOString(),
      deletedBy: this.formData?.customerName || 'POS User',
      reason: 'Button delete operation',
    };

    this.productService
      .voidItem(productDetails)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.code === '200') {
            // API call successful - remove the entire item regardless of
            // quantity. Matched via findCartRowIndex (not psid alone) so
            // that when the same product has multiple cart rows (mobile
            // industry: same batch/variant under different mappings, e.g.
            // "S2" vs "A36"), the row the user actually clicked delete on
            // is the one removed - not just the first psid match.
            const foundIndex = this.findCartRowIndex(product);
            if (foundIndex !== -1) {
              this.products.splice(foundIndex, 1);
            }

            if (this.industryService.isMobile()) {
              this.mobileStockReservationService.syncToStorage(this.products);
            }

            this.messageService.add({
              severity: 'success',
              summary: 'Item Removed',
              detail: `${product.name} removed from cart`,
              life: 3000,
            });

            if (
              !this.paymentTotalDialogRef?.loyalty?.checkAndClearLoyaltyIfInvalid(
                this.getRoundedTotal(),
              )
            ) {
              this.calculateBalance();
            }

            if (this.products.length === 0) {
              this.displayNoItem = true;
              this.showBillDetail = false;
              this.showItemDetail = false;
            }
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Remove Failed',
              detail: response.message || 'Failed to remove item',
              life: 3000,
            });
          }
        },
        error: (error) => {
          console.error('Void API Error:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Remove Failed',
            detail: 'Failed to remove item from cart',
            life: 3000,
          });
        },
      });
  }

  // MOVED-TO: src/app/shared/services/barcode-scanner.service.ts -> BarcodeScannerService (whole cluster)
  // Builds the shared dependency bag for the barcode/QR-scanning cluster
  // (onBarcodeEnter/Input/Blur, onQRScan, toggleQR, openScannerForDelete).
  // `scheduleOpenScanner` stays a component-owned callback because it closes
  // over `this.destroy$` and `this.openScanner` (a bound arrow-function field
  // tied to the ViewChild scanner action), which aren't worth relocating.
  // `getBarcodeInput` is a live getter, not a snapshot -- see the interface
  // doc comment in barcode-scanner.service.ts for why onBarcodeInput needs it.
  private buildBarcodeScannerDeps(): BarcodeScannerDeps {
    return {
      barcodeInput: this.barcodeInput,
      getBarcodeInput: () => this.barcodeInput,
      barcodeInputTimer: this.barcodeInputTimer,
      isDeleteMode: this.isDeleteMode,
      enableCursorFocus: this.enableCursorFocus,
      isExchangeOrder: this.isExchangeOrder,
      products: this.products,
      hasScannerClicked: this.hasScannerClicked,
      items: this.items,
      setBarcodeInput: (value) => (this.barcodeInput = value),
      setBarcodeInputTimer: (value) => (this.barcodeInputTimer = value),
      setHasScannerClicked: (value) => (this.hasScannerClicked = value),
      setShowItemDetail: (value) => (this.showItemDetail = value),
      setDisplayDialog: (value) => (this.displayDialog = value),
      setDisplayTransactions: (value) => (this.displayTransactions = value),
      setActiveItem: (value) => (this.activeItem = value),
      setDisplayNoItem: (value) => (this.displayNoItem = value),
      setShowBillDetail: (value) => (this.showBillDetail = value),
      removeItemByPSID: (psid) => this.removeItemByPSID(psid),
      addProducts: (psid) => this.addProducts(psid),
      focusQuantityInput: () => this.focusQuantityInput(),
      scheduleOpenScanner: () => {
        timer(20)
          .pipe(delay(800), takeUntil(this.destroy$))
          .subscribe(this.openScanner);
      },
    };
  }

  openScannerForDelete() {
    this.barcodeScannerService.openScannerForDelete(
      this.buildBarcodeScannerDeps(),
    );
  }

  toggleDeleteMode() {
    // Check if in exchange mode
    if (this.isExchangeOrder) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Not Available',
        detail: 'Delete mode is not available in exchange mode',
        life: 3000,
      });
      return;
    }

    // Check if other modes are active (mutually exclusive)
    if (this.isQuotationMode || this.isWholesaleMode || this.isOfferGroupMode) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Cannot Enable',
        detail: 'Please exit current mode before enabling Delete Mode',
        life: 3000,
      });
      return;
    }

    // Toggle Delete Mode
    this.isDeleteMode = !this.isDeleteMode;

    if (this.isDeleteMode) {
      // Check if there are items to delete when entering delete mode
      if (!this.products || this.products.length === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'No Items',
          detail: 'No items in cart to delete. Add items first.',
          life: 3000,
        });
        this.isDeleteMode = false; // Revert delete mode
        return;
      }

      // Entering Delete Mode
      this.messageService.add({
        severity: 'info',
        summary: 'Delete Mode Enabled',
        detail:
          'Scan or select items to remove them from cart. Press F9 to exit.',
        life: 4000,
      });

      // Open scanner dialog for delete
      this.openScannerForDelete();

      // Focus barcode search input for immediate scan/type deletion
      setTimeout(() => {
        this.focusBarcodeSearch();
      }, 100);

      // Broadcast Delete Mode state
      this.formDataService.updateFormData({
        ...this.formData,
        mobileNumber: this.mobileNumber,
        empCode: this.formData?.empCode || '',
        storeCode: this.formData?.storeCode || '',
        currentDate: this.formData?.currentDate || new Date(),
        customerName: this.customerName || '',
        salesRep: this.formData?.salesRep || '',
        isDeleteMode: true,
      });
    } else {
      // Exiting Delete Mode
      this.messageService.add({
        severity: 'success',
        summary: 'Delete Mode Disabled',
        detail: 'Returned to normal mode',
        life: 3000,
      });

      // Close scanner if open
      if (this.hasScannerClicked) {
        this.toggleQR();
      }

      // Broadcast Delete Mode state
      this.formDataService.updateFormData({
        ...this.formData,
        mobileNumber: this.mobileNumber,
        empCode: this.formData?.empCode || '',
        storeCode: this.formData?.storeCode || '',
        currentDate: this.formData?.currentDate || new Date(),
        customerName: this.customerName || '',
        salesRep: this.formData?.salesRep || '',
        isDeleteMode: false,
      });
    }
  }

  getSelectedProduct(selectedProductId: string): Product | null {
    return (
      this.productsTemp.find(
        (detail: any) => detail.productId === selectedProductId,
      ) || null
    );
  }

  addProducts(psid: string, sellingprice?: number, batch?: string) {
    // Only check for existing product if we have the identifying information
    // When called from autocomplete, we have sellingprice/batch
    // When called from barcode scan, we don't - so we fetch from API first
    const hasIdentifyingInfo = this.isBatchEnabled
      ? batch !== undefined
      : sellingprice !== undefined;

    let productFound = hasIdentifyingInfo
      ? this.findScannedProduct(psid, sellingprice, batch)
      : null;

    if (productFound) {
      this.updateQuantity(psid, productFound, sellingprice, batch);
    } else {
      const groupId = this.isOfferGroupMode
        ? this.selectedOfferGroupId
        : undefined;
      this.productService
        .findItemUsingPSID(psid, groupId || undefined)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (itemFound: any) => {
            // Mobile /scanitem returns `data` as an array of barcode rows; retail returns one object
            const rows = Array.isArray(itemFound?.data)
              ? itemFound.data
              : itemFound?.data ? [itemFound.data] : [];
            if (rows.length == 0) {
              this.filteredProducts = [];
              this.messageService.add({
                severity: 'error',
                summary: 'Rejected',
                detail: itemFound?.message || 'Item not found',
                life: 2000,
              });
              return;
            }
            const scanned = rows[0];

            // Same as the search path: /scanitem lacks fields like unit_mappings and
            // parameters/variants, so fetch full detail by barcode row id and merge
            // (scan values win, so the scanned psid/batch/price are kept).
            if (scanned.id) {
              this.productService
                .getProductDetails(scanned.id, groupId || undefined)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (response: ProductSearchHttpResponse) => {
                    this.addProductToCart({ ...(response?.data || {}), ...scanned });
                  },
                  error: () => this.addProductToCart(scanned),
                });
              return;
            }
            itemFound = { ...itemFound, data: scanned };
            if (this.isQuotationMode) {
              // In quotation mode, always use barcodesellprice
              itemFound.data.sellingprice = itemFound.data.barcodesellprice;
            } else if (
              this.isOfferGroupMode &&
              itemFound.data.groupingprice &&
              itemFound.data.groupingprice > 0
            ) {
              // In offer group mode, use grouping price
              itemFound.data.sellingprice = itemFound.data.groupingprice;
            } else if (itemFound.data.offerprice > 0) {
              // Otherwise, use offer price if available
              itemFound.data.sellingprice = itemFound.data.offerprice;
            }

            let newProduct: Product = {
              ...itemFound.data,
              batch: itemFound.data.batch || '',
              purchaseorder_id: itemFound.data.purchaseorder_id || 0,
              store_id: itemFound.data.store_id || 0,
              mrp: itemFound.data.mrp || 0,
              costprice: itemFound.data.costprice || 0,
              wholesaleprice: itemFound.data.wholesaleprice || 0,
              retailprice: itemFound.data.retailprice || 0,
              sales_tax: itemFound.data.sales_tax || 0,
              rack: itemFound.data.rack || '',
              //discount: itemFound.data.discount || 0,
              //discountval: itemFound.data.discountval || 0
            };
            this.productMappingService.normalizeProductColumns(newProduct);
            this.productMappingService.autoSelectSingleMapping(newProduct);

            // FIX: Barcode/scan path — /scanitem API does not always return
            // selling_price_incl / product_selling_price_incl. Compute it here
            // from sellingprice × (1 + tax%) so the cart column shows correctly.
            // Autocomplete path gets this from /productdetails which includes the field.
            if (newProduct.product_selling_price_incl == null) {
              const taxRate = Number(newProduct.sales_tax || newProduct.tax || 0);
              const exclPrice = Number(newProduct.sellingprice || 0);
              newProduct.product_selling_price_incl = taxRate > 0
                ? Number((exclPrice * (1 + taxRate / 100)).toFixed(2))
                : Number(exclPrice.toFixed(2));
            }

            console.log("Mapped newProduct for cart:", { isbulk: newProduct.isbulk, mappings: newProduct.unit_mappings, data: newProduct });

            // Now check if this product (with its price/batch from API) already exists in cart
            const existingProduct = this.findScannedProduct(
              newProduct.psid,
              newProduct.sellingprice,
              newProduct.batch,
            );

            if (existingProduct) {
              // Product already exists, just increase quantity
              this.updateQuantity(
                newProduct.psid,
                existingProduct,
                newProduct.sellingprice,
                newProduct.batch,
              );
            } else {
              let discountValue = 0;
              let discountValValue = 0;

              if (!this.isSalesDiscountEditEnabled) {
                // Setting disabled: Use API discount values as-is (backend already calculated)
                discountValue = newProduct.discount || 0;
                discountValValue = newProduct.discountval || 0;
                // Note: API's sellingprice already has discount applied, don't recalculate
              }
              // else: Setting enabled: User controls discount, start with 0

              let rawUnitId = newProduct.unit ?? newProduct.unit_mappings?.[0]?.unitid ?? null;
              let defaultUnitId = rawUnitId != null && !isNaN(Number(rawUnitId)) ? Number(rawUnitId) : rawUnitId;
              console.log(newProduct, "newproduct")
              let addQtyToNewPdt = {
                ...newProduct,
                increaseQuantity: 1,
                discount: discountValue,
                discountval: discountValValue,
                unit_id: defaultUnitId,
                // Separate API stock from user-entered cart qty:
                // free_qty_available = available free stock from API (read-only cap)
                // cart_free_qty     = qty user actually wants to give free (editable, starts 0)
                free_qty_available: Number(newProduct.free_qty) || 0,
                cart_free_qty: 0,
              };

              // No price recalculation needed - API already provides correct sellingprice

              if (this.isSuspenseMode) {
                addQtyToNewPdt.isgst = 1;
                addQtyToNewPdt.selected = false;
              }

              if (itemFound && Object.keys(itemFound)) {
                this.itemId = '';
                this.products = [addQtyToNewPdt, ...this.products];
                this.productsTemp = this.products.map((product) => ({
                  ...product,
                }));

                // Mobile Industry: Handle parameter/variant workflow
                if (this.industryService.isMobile()) {
                  // Case 1: Parameters + Variants - Auto-open parameter popup
                  if (
                    this.hasParametersAndVariants(addQtyToNewPdt) ||
                    this.hasOnlyVariants(addQtyToNewPdt)
                  ) {
                    // Mark that popup should open
                    addQtyToNewPdt.variantAccordionExpanded = true;
                    this.selectedVariantProduct = this.products[0];
                    this.variantOpenTick++;
                  }
                }
              }
            }
          },
          (error) => {
            console.error('Error finding item:', error);
            this.filteredProducts = [];
            this.messageService.add({
              severity: 'error',
              summary: 'Rejected',
              detail: 'Item not found',
              life: 2000,
            });
          },
        );
    }
  }

  onDiscountModeChange(event: any): void {
    // Only recalculate if user can edit discounts
    if (this.isSalesDiscountEditEnabled) {
      this.DiscountchangeCalc();
    }
  }

  setDiscountMode(mode: 'percentage' | 'amount'): void {
    this.discountMode = mode;
    // Only recalculate if user can edit discounts
    if (this.isSalesDiscountEditEnabled) {
      this.DiscountchangeCalc();
    }
  }

  // Computed property for toggle switch (true = amount, false = percentage)
  get isAmountMode(): boolean {
    return this.discountMode === 'amount';
  }

  set isAmountMode(value: boolean) {
    this.discountMode = value ? 'amount' : 'percentage';
  }

  @HostListener('window:keydown', ['$event'])
  onCtrl3Shortcut(event: KeyboardEvent): void {
    // Ctrl+3 toggles discount mode (% ↔ ₹) only when cart has items
    if (
      event.ctrlKey &&
      (event.key === '3' || event.code === 'Digit3') &&
      this.products &&
      this.products.length > 0 &&
      (this.isSalesDiscountEditEnabled ||
        this.industryConfig?.table?.industry === INDUSTRY_ENUM.MOBILE)
    ) {
      event.preventDefault();
      this.discountMode =
        this.discountMode === 'percentage' ? 'amount' : 'percentage';
      if (this.isSalesDiscountEditEnabled) {
        this.DiscountchangeCalc();
      }
    }
  }

  onDiscountToggle(event: any): void {
    if (typeof event === 'string') {
      this.discountMode = event as 'percentage' | 'amount';
    } else if (event && typeof event.checked === 'boolean') {
      this.discountMode = event.checked ? 'amount' : 'percentage';
    } else if (typeof event === 'boolean') {
      this.discountMode = event ? 'amount' : 'percentage';
    }
    // Only recalculate if user can edit discounts
    if (this.isSalesDiscountEditEnabled) {
      this.DiscountchangeCalc();
    }
  }

  DiscountchangeCalc(): void {
    this.products.forEach((product) => this.applyLineDiscount(product));
  }

  /**
   * Recalculates one cart line's discount from its base price for the
   * currently selected sale unit (see getEffectiveBasePrice).
   */
  private applyLineDiscount(product: Product): void {
    // Ensure discount is properly initialized
    if (this.isDiscountAfterTaxEnabled) {
      let discount = Number(product.discount) || 0;
      const basePrice = this.getEffectiveBasePrice(product);
      const costPrice = this.getEffectiveCostPrice(product);

      const maxDiscountValue = basePrice - costPrice;
      const taxAmount = this.gettotaltaxval(product, 1);
      const priceAfterTax = basePrice + taxAmount;
      let discvalue = 0;
      if (this.discountMode === 'percentage') {
        discount = Math.min(Math.max(discount, 0), 100);
        discvalue =
          this.discountMode === 'percentage'
            ? (priceAfterTax * discount) / 100
            : discount;
        product.discount = discount; // Update the product's discount to the validated percentage
      } else {
        discvalue = discount;
      }

      product.discountval = Math.max(
        0,
        Math.min(discvalue, maxDiscountValue),
      );
    } else {
      const discount = Number(product.discount) || 0;
      const basePrice = this.getEffectiveBasePrice(product);
      const costPrice = this.getEffectiveCostPrice(product);

      const maxDiscountValue = basePrice - costPrice;

      const discvalue =
        this.discountMode === 'percentage'
          ? (basePrice * discount) / 100
          : discount;

      product.discountval = Math.max(
        0,
        Math.min(discvalue, maxDiscountValue),
      );
      product.sellingprice = basePrice - product.discountval;
    }
  }

  getSubtotalAfterLineDiscount(): number {
    return this.posCalculationService.getSubtotalAfterLineDiscount(
      this.products,
    );
  }

  getOverAllDiscountAmount(): number {
    return this.posCalculationService.getOverAllDiscountAmount(
      this.overAllDiscountMode,
      this.overAllDiscountPercent,
      this.overAllDiscount,
      this.getSubtotalAfterLineDiscount(),
    );
  }

  // overall discount mode change (amount/percentage toggle)
  onOverAllDiscountModeChange(event: any): void {
    const newMode = typeof event === 'string' ? event : event?.value || event;
    if (newMode === 'percentage' || newMode === 'amount') {
      this.overAllDiscountMode = newMode;
    }
    this.overAllDiscount = 0;
    this.overAllDiscountPercent = 0;
    this.calculateGlobalDiscountShares();
  }

  onOverAllDiscountChange(value: number): void {
    const res = this.posCalculationService.onOverAllDiscountChange(
      value,
      this.overAllDiscountMode,
      this.getSubtotalAfterLineDiscount(),
    );
    this.overAllDiscount = res.overAllDiscount;
    this.overAllDiscountPercent = res.overAllDiscountPercent;
    this.calculateGlobalDiscountShares();
  }

  onOverAllDiscountBlur(): void {
    this.calculateGlobalDiscountShares();
  }

  calculateGlobalDiscountShares(): void {
    this.posCalculationService.calculateGlobalDiscountShares(
      this.products,
      this.getSubtotalAfterLineDiscount(),
      this.getOverAllDiscountAmount(),
    );
  }

  resetOverAllDiscount(): void {
    this.overAllDiscount = 0;
    this.overAllDiscountPercent = 0;
    this.overAllDiscountMode = 'amount';
    this.products.forEach((product) => {
      (product as any).globalDiscountShare = 0;
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    allowOnlyNumbersUtil(event);
  }

  allowAlphaNumeric(event: KeyboardEvent) {
    allowAlphaNumericUtil(event);
  }

  allowAlphabeticOnly(event: KeyboardEvent) {
    allowAlphabeticOnlyUtil(event);
  }

  logOut() {
    this.userName = '';
    this.displayModal = true;

    this.pricingGroups = [];
    this.customers = [];
    this.selectedCustomer = null;
    this.selectedOfferGroupId = null;
    this.isOfferGroupMode = false;
    this.mobileStockReservationService.clear();

    this.authService.logout().subscribe({
      next: () => {
        window.location.reload();
      },
      error: () => {
        window.location.reload();
      },
    });
  }
  updateQuantity(
    psid: string,
    productFound: Product,
    sellingprice?: number,
    batch?: string,
  ) {
    let foundIndex: number;

    if (this.isBatchEnabled) {
      // Batch mode: match psid + batch
      foundIndex = this.products.findIndex(
        (item: any) =>
          item.psid?.toLowerCase() === psid?.toLowerCase() &&
          item.batch === (batch !== undefined ? batch : productFound.batch),
      );
    } else {
      // Non-batch mode: match psid + sellingprice
      foundIndex = this.products.findIndex(
        (item: any) =>
          item.psid?.toLowerCase() === psid?.toLowerCase() &&
          item.sellingprice ===
            (sellingprice !== undefined
              ? sellingprice
              : productFound.sellingprice),
      );
    }

    // =====================================================================
    // MOBILE INDUSTRY: Variant-aware quantity update
    // When industry is Mobile and the product has productmapvalues, we
    // intercept the normal flow to:
    //  1. Open the variant selector if no variant has been selected yet.
    //  2. Increase qty on the matching cart row when the same variant is
    //     selected again (with stock check against selectedMapValue.qty).
    //  3. Add a brand-new cart row when a different variant is selected
    //     (with stock availability check on selectedMapValue.qty).
    // =====================================================================
    if (
      this.industryService.isMobile() &&
      productFound.productmapvalues &&
      productFound.productmapvalues.length > 0
    ) {
      // A product with a real variant/IMEI choice must always go through the
      // selector again when searched/scanned - productFound here is usually
      // an already-settled cart row (findScannedProduct matches psid+batch
      // only), and silently bumping its qty would block adding the same or
      // another variant under a different mapping.
      const needsChoice =
        this.hasParametersAndVariants(productFound) ||
        this.hasOnlyVariants(productFound) ||
        productFound.productmapvalues.length > 1;

      // --- No variant chosen yet (or a choice is required): open the selector and bail out ---
      if (needsChoice || !productFound.selectedMapValue) {
        // Only reuse a cart row that is ALSO still pending variant selection.
        // Never reuse a row that already has a variant settled -” that row
        // belongs to a different variant and must not be mutated here.
        const pendingIndex = this.products.findIndex(
          (item: any) =>
            item.psid?.toLowerCase() === psid?.toLowerCase() &&
            !item.selectedMapValue,
        );

        let targetProduct: any;
        if (pendingIndex !== -1) {
          targetProduct = this.products[pendingIndex];
        } else {
          // Always clone â€” a settled row for this psid may already exist in
          // the cart (a different variant), but we must not touch it.
          // Strip the settled row's variant/mapping so the new row starts clean.
          const singleMappingId =
            productFound.mappings?.length === 1
              ? (productFound.mappings[0].id ?? null)
              : null;
          targetProduct = {
            ...productFound,
            selectedMapValue: null,
            mapping_id: singleMappingId,
            selectedMappingId: singleMappingId,
            stockquanity: undefined,
            increaseQuantity: 1,
            isPendingVariant: true,
          };
          this.products.unshift(targetProduct);
          this.productsTemp = this.products.map((p) => ({ ...p }));
        }

        targetProduct.variantAccordionExpanded = true;
        this.selectedVariantProduct = targetProduct;
        this.variantOpenTick++;
        return;
      }

      // A variant IS selected — check whether the exact same (variant + mapping)
      // combination is already present in the cart as a SETTLED row.
      //
      // Mapping phase-sensitivity:
      //  • If EITHER side has no mapping chosen yet (null), match on variant only
      //    (pre-mapping phase — keeps existing behaviour).
      //  • If BOTH sides have a mapping, require it to match too
      //    (post-mapping phase — different mapping → different cart row).
      const selectedVariantId = productFound.selectedMapValue.id;
      const incomingMappingId =
        productFound.mapping_id ?? productFound.selectedMappingId ?? null;

      // Pool key = product + physical batch/variant row, ignoring mapping.
      // Two rows tagged with different mappings (e.g. "S2" vs "A36") but
      // the same underlying productmapvalues entry draw from the SAME
      // physical stock, so they must share one qty cap, not one each.
      const poolKey = this.mobileStockReservationService.buildPoolKey(
        psid,
        selectedVariantId,
      );
      const poolBaseQty = productFound.selectedMapValue.qty;

      const sameVariantIndex = this.products.findIndex((item: any) => {
        if (item.psid?.toLowerCase() !== psid?.toLowerCase()) return false;
        if (item.selectedMapValue?.id !== selectedVariantId) return false;

        const existingMappingId =
          item.mapping_id ?? item.selectedMappingId ?? null;
        return existingMappingId === incomingMappingId;
      });
      if (sameVariantIndex !== -1) {
        // Same (variant + mapping) already in cart as a separate settled
        // row → bump that row's qty, capped by what the shared pool has
        // left across every mapping drawing from it.
        const existingItem = this.products[sameVariantIndex];
        const existingQty = existingItem.increaseQuantity || 0;
        const availableInPool =
          this.mobileStockReservationService.getAvailableQty(
            poolKey,
            poolBaseQty,
            this.products,
          );

        if (availableInPool <= 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Rejected',
            detail: `Cannot add more than available stock for ${existingItem.name}`,
            life: 3000,
          });
        } else {
          this.products[sameVariantIndex].increaseQuantity = existingQty + 1;
          this.productsTemp = this.products.map((p) => ({ ...p }));
          this.mobileStockReservationService.syncToStorage(this.products);
          this.messageService.add({
            severity: 'success',
            summary: 'Confirmed',
            detail: `${existingItem.name} quantity increased by 1`,
            life: 3000,
          });
        }
      } else {
        // A brand-new row for this (variant + mapping) combo — still capped
        // by what the shared batch/variant pool has left, since other
        // mappings of the same pool may already be sitting in the cart.
        const availableInPool =
          this.mobileStockReservationService.getAvailableQty(
            poolKey,
            poolBaseQty,
            this.products,
            productFound.isPendingVariant ? [productFound] : undefined,
          );

        if (availableInPool <= 0) {
          this.messageService.add({
            severity: 'error',
            summary: 'Out of Stock',
            detail: `Selected variant is not available for ${productFound.name}`,
            life: 3000,
          });
          if (productFound.isPendingVariant) {
            const dupIndex = this.products.indexOf(productFound);
            if (dupIndex !== -1) {
              this.products.splice(dupIndex, 1);
              this.productsTemp = this.products.map((p) => ({ ...p }));
            }
          }
        } else if (productFound.isPendingVariant) {
          // Settle the existing pending row in place â€” no new row needed.
          delete productFound.isPendingVariant;
          productFound.increaseQuantity = 1;
          this.productsTemp = this.products.map((p) => ({ ...p }));
          this.mobileStockReservationService.syncToStorage(this.products);
          this.messageService.add({
            severity: 'success',
            summary: 'Added',
            detail: `${productFound.name} added with selected variant`,
            life: 3000,
          });
        } else {
          // productFound already has a variant attached and no pending row
          // exists for it (e.g. called directly) â†’ add as a new row.
          this.products.unshift({ ...productFound, increaseQuantity: 1 });
          this.productsTemp = this.products.map((p) => ({ ...p }));
          this.mobileStockReservationService.syncToStorage(this.products);
          this.messageService.add({
            severity: 'success',
            summary: 'Added',
            detail: `${productFound.name} added with selected variant`,
            life: 3000,
          });
        }
      }

      if (this.enableCursorFocus) {
        setTimeout(() => {
          this.focusAutoComplete();
        }, 500);
      }
      return; // Always exit here â€” standard flow below is for non-mobile / no-variant products
    }
    // =====================================================================
    // END MOBILE VARIANT BLOCK .” standard flow continues below
    // =====================================================================

    if (foundIndex !== -1) {
      this.itemId = '';
      let existingQty = this.products[foundIndex]?.increaseQuantity || 0;
      let productName = this.products[foundIndex]?.name;
      let productType = this.products[foundIndex]?.product_type;
      let qty = this.products[foundIndex]?.quantity || 100;

      qty = 100; // ToDO

      // For Non-stock products, skip stock validation
      if (productType === 'Non Stock') {
        this.messageService.add({
          severity: 'success',
          summary: 'Confirmed',
          detail: `${productName} quantity increased by 1`,
          life: 3000,
        });
        if (this.products[foundIndex])
          this.products[foundIndex].increaseQuantity = existingQty + 1;
        this.productsTemp = this.products.map((product) => ({ ...product }));
      } else {
        // For Stock products, check availability
        if (existingQty >= qty) {
          this.messageService.add({
            severity: 'error',
            summary: 'Rejected',
            detail: `${productName} not available`,
            life: 3000,
          });
        } else {
          const maxQuantity = this.getMaxQuantityForProduct(
            this.products[foundIndex],
          );
          if (existingQty + 1 > maxQuantity) {
            this.messageService.add({
              severity: 'error',
              summary: 'Rejected',
              detail: `Cannot add more than available stock for ${productName}`,
              life: 3000,
            });
            return;
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Confirmed',
              detail: `${productName} quantity increased by 1`,
              life: 3000,
            });

            if (this.products[foundIndex])
              this.products[foundIndex].increaseQuantity = existingQty + 1;
            this.productsTemp = this.products.map((product) => ({
              ...product,
            }));
          }
        }
      }

      if (this.enableCursorFocus) {
        setTimeout(() => {
          this.focusAutoComplete();
        }, 500);
      }
    } else {
      this.products.unshift({
        ...productFound,
        free_qty_available: Number(productFound.free_qty) || 0,
        cart_free_qty: 0,
      });
      this.productsTemp = this.products.map((product) => ({ ...product }));
    }
  }

  gettotaltaxval(product: Product, flag: number) {
    let totaltax = 0;
    let totaltaxvalue = 0;
    const effectivePrice = this.getEffectivePrice(product);

    if (this.isInterStateTax()) {
      if (product.itax && product.itax > 0) {
        totaltax += Number(product.itax);
        totaltaxvalue += (Number(effectivePrice) * Number(product.itax)) / 100;
      }
    } else {
      if (product.stax && product.stax > 0) {
        totaltax += Number(product.stax);
        totaltaxvalue += (Number(effectivePrice) * Number(product.stax)) / 100;
      }
      if (product.ctax && product.ctax > 0) {
        totaltax += Number(product.ctax);
        totaltaxvalue += (Number(effectivePrice) * Number(product.ctax)) / 100;
      }
    }
    if (flag == 0) return totaltax;
    else return totaltaxvalue;
  }

  // MOVED-TO: src/app/shared/services/product-mapping.service.ts -> ProductMappingService (whole cluster)
  // Builds the shared dependency bag for the product-mapping cluster
  // (dropdownSelection, onMappingSelected, mapItemsToProducts,
  // onInvoiceRowClick, mapSalesItemToProduct, onInvoiceSelected,
  // onInvoiceDialogClosed, getProducts, formAllProducts,
  // populateFilterProducts, onSelectProduct, findSelectedProduct,
  // trackByProductId). onInvoiceRowClick/onInvoiceSelected have an async gap
  // (ensureCustomersLoaded().then(...)), so state is exposed as live
  // getters/setters -- see the interface doc comment in
  // product-mapping.service.ts.
  private buildProductMappingDeps(): ProductMappingDeps {
    return {
      getIsDeleteMode: () => this.isDeleteMode,
      setAutoCompletedSelectedProduct: (value) =>
        (this.autoCompletedselectedProduct = value),
      setSelecteMapping: (value) => (this.selecteMapping = value),
      getSelectedCustomer: () => this.selectedCustomer,
      setSelectedCustomer: (value) => (this.selectedCustomer = value),
      getIsSuspenseMode: () => this.isSuspenseMode,
      getIsQuotationMode: () => this.isQuotationMode,
      getIsWholesaleMode: () => this.isWholesaleMode,
      setIsQuotationMode: (value) => (this.isQuotationMode = value),
      setIsWholesaleMode: (value) => (this.isWholesaleMode = value),
      getIsOfferGroupMode: () => this.isOfferGroupMode,
      setIsSuspenseMode: (value) => (this.isSuspenseMode = value),
      getCartProducts: () => this.products,
      setCartProducts: (value) => (this.products = value),
      setProductsTemp: (value) => (this.productsTemp = value),
      setSelectedInvoiceData: (value) => (this.selectedInvoiceData = value),
      setSelectedInvoiceNo: (value) => (this.selectedInvoiceNo = value),
      setIsExchangeOrder: (value) => (this.isExchangeOrder = value),
      getMobileNumber: () => this.mobileNumber,
      setMobileNumber: (value) => (this.mobileNumber = value),
      setCustomerName: (value) => (this.customerName = value),
      getFormData: () => this.formData,
      setSelectedPaymentOptions: (value) =>
        (this.selectedPaymentOptions = value),
      setRefundCashAmount: (value) => (this.refundCashAmount = value),
      setDiscountMode: (value) => (this.discountMode = value),
      getCustomers: () => this.customers,
      getIsSalesDiscountEditEnabled: () => this.isSalesDiscountEditEnabled,
      setShowBillDetail: (value) => (this.showBillDetail = value),
      setShowItemDetail: (value) => (this.showItemDetail = value),
      setDisplayNoItem: (value) => (this.displayNoItem = value),
      setDisplayTransactions: (value) => (this.displayTransactions = value),
      setActiveItem: (value) => (this.activeItem = value),
      getItems: () => this.items,
      getEnableCursorFocus: () => this.enableCursorFocus,
      setShowInvoiceDialog: (value) => (this.showInvoiceDialog = value),
      productSearch$: this.productSearch$,
      setFilteredProducts: (value) => (this.filteredProducts = value),
      getIsProductSearch: () => this.isProductSearch,
      setIsProductSearch: (value) => (this.isProductSearch = value),
      setSelectedProductId: (value) => (this.selectedProductId = value),
      setCurrentPSID: (value) => (this.currentPSID = value),
      setShowCalculator: (value) => (this.showCalculator = value),
      removeItemByPSID: (psid) => this.removeItemByPSID(psid),
      addProducts: (psid, sellingprice, batch) =>
        this.addProducts(psid, sellingprice, batch),
      disableOfferGroupMode: () => this.disableOfferGroupMode(),
      updateFormDataWithQuotationMode: () =>
        this.updateFormDataWithQuotationMode(),
      resetPartPaymentStates: () => this.resetPartPaymentStates(),
      getRoundedTotal: () => this.getRoundedTotal(),
      ensureCustomersLoaded: () => this.ensureCustomersLoaded(),
      isInterStateTax: () => this.isInterStateTax(),
      discountChangeCalc: () => this.DiscountchangeCalc(),
      focusFirstExchangeQuantityInput: () =>
        this.focusFirstExchangeQuantityInput(),
      triggerBounce: () => this.triggerBounce(),
    };
  }

  dropdownSelection(event: any) {
    this.productMappingService.dropdownSelection(
      event,
      this.buildProductMappingDeps(),
    );
  }

  findScannedProduct(
    psid: string,
    sellingprice?: number,
    batch?: string,
  ): Product | null {
    // IMPORTANT: Search this.products (the actual cart), NOT this.productsTemp.
    // this.productsTemp is overwritten by formAllProducts() on every search query,
    // so after the user types to search again, productsTemp contains search results
    // (which have no psid field) — causing findScannedProduct to always return null
    // and add a duplicate cart row instead of updating quantity.
    return this.barcodeScannerService.findScannedProduct(
      psid,
      sellingprice,
      batch,
      this.isBatchEnabled,
      this.products,
    );
  }

  // MOVED-TO: src/app/shared/services/transaction-history.service.ts -> TransactionHistoryService (whole cluster)
  // Builds the shared dependency bag for the transaction/quotation-history
  // cluster (getAllTransaction, getAllQuotation, createFlattenedTransactions,
  // quotation search/select/navigate, viewQuotation, getQuotationDetails,
  // transaction select/navigate). Several methods here have async gaps (HTTP
  // subscribe, setTimeout for DOM focus/scroll), so state is exposed as live
  // getters/setters rather than snapshots -- see the interface doc comment
  // in transaction-history.service.ts.
  private buildTransactionHistoryDeps(): TransactionHistoryDeps {
    return {
      getSavedReceipts: () => this.savedReceipts,
      setSavedReceipts: (value) => (this.savedReceipts = value),
      getTransactions: () => this.transactions,
      setTransactions: (value) => (this.transactions = value),
      getQuotations: () => this.quotations,
      setQuotations: (value) => (this.quotations = value),
      getFilteredQuotations: () => this.filteredQuotations,
      setFilteredQuotations: (value) => (this.filteredQuotations = value),
      getSelectedQuotationIndex: () => this.selectedQuotationIndex,
      setSelectedQuotationIndex: (value) =>
        (this.selectedQuotationIndex = value),
      getSelectedQuotationForView: () => this.selectedQuotationForView,
      setSelectedQuotationForView: (value) =>
        (this.selectedQuotationForView = value),
      getQuotationSearchTerm: () => this.quotationSearchTerm,
      setQuotationSearchTerm: (value) => (this.quotationSearchTerm = value),
      getFlattenedTransactions: () => this.flattenedTransactions,
      setFlattenedTransactions: (value) => (this.flattenedTransactions = value),
      getSelectedTransactionIndex: () => this.selectedTransactionIndex,
      setSelectedTransactionIndex: (value) =>
        (this.selectedTransactionIndex = value),
      setSelectedTransactionForPrint: (value) =>
        (this.selectedTransactionForPrint = value),
      setCurrentOrderId: (value) => (this.currentOrderId = value),
      getCurrentSearchTerm: () => this.currentSearchTerm,
      getActiveHistoryTab: () => this.activeHistoryTab,
      setActiveHistoryTab: (value) => (this.activeHistoryTab = value),
      getIsExchangeOrder: () => this.isExchangeOrder,
      setIsExchangeOrder: (value) => (this.isExchangeOrder = value),
      getIsWholesaleMode: () => this.isWholesaleMode,
      setIsWholesaleMode: (value) => (this.isWholesaleMode = value),
      getIsOfferGroupMode: () => this.isOfferGroupMode,
      getIsSuspenseMode: () => this.isSuspenseMode,
      setIsSuspenseMode: (value) => (this.isSuspenseMode = value),
      getIsQuotationMode: () => this.isQuotationMode,
      setIsQuotationMode: (value) => (this.isQuotationMode = value),
      getCartProducts: () => this.products,
      setCartProducts: (value) => (this.products = value),
      setProductsTemp: (value) => (this.productsTemp = value),
      setSelectedInvoiceNo: (value) => (this.selectedInvoiceNo = value),
      setRefundCashAmount: (value) => (this.refundCashAmount = value),
      setHoldOrderId: (value) => (this.holdOrderId = value),
      setCustomerName: (value) => (this.customerName = value),
      setDiscountMode: (value) => (this.discountMode = value),
      getIsSalesDiscountEditEnabled: () => this.isSalesDiscountEditEnabled,
      setShowTransactionDialog: (value) => (this.showTransactionDialog = value),
      getEnableCursorFocus: () => this.enableCursorFocus,
      getIsNavigatingProgrammatically: () => this.isNavigatingProgrammatically,
      setIsNavigatingProgrammatically: (value) =>
        (this.isNavigatingProgrammatically = value),
      disableOfferGroupMode: () => this.disableOfferGroupMode(),
      updateFormDataWithQuotationMode: () =>
        this.updateFormDataWithQuotationMode(),
      mapItemsToProducts: (items, isExchangeOrder, isQuotation) =>
        this.mapItemsToProducts(items, isExchangeOrder, isQuotation),
      discountChangeCalc: () => this.DiscountchangeCalc(),
      restoreSavedLinePrices: (applySavedDiscount) =>
        this.restoreSavedLinePrices(applySavedDiscount),
      focusQuantityInput: () => this.focusQuantityInput(),
    };
  }

  getAllTransaction(showSavedTransaction: boolean) {
    this.transactionHistoryService.getAllTransaction(
      showSavedTransaction,
      this.buildTransactionHistoryDeps(),
    );
  }
  getAllQuotation() {
    this.transactionHistoryService.getAllQuotation(
      this.buildTransactionHistoryDeps(),
    );
  }
  // Search quotations by quotation number, customer name, or mobile number
  onQuotationSearch(): void {
    this.transactionHistoryService.onQuotationSearch(
      this.buildTransactionHistoryDeps(),
    );
  }
  // Clear quotation search
  clearQuotationSearch(): void {
    this.transactionHistoryService.clearQuotationSearch(
      this.buildTransactionHistoryDeps(),
    );
  }

  // Create flattened transaction items for table display
  createFlattenedTransactions() {
    this.transactionHistoryService.createFlattenedTransactions(
      this.buildTransactionHistoryDeps(),
    );
  }

  highlightSearchTerm(text: string): string {
    return this.transactionHistoryService.highlightSearchTerm(
      text,
      this.buildTransactionHistoryDeps(),
    );
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  selecteMapping: any;
  onMappingSelected(product: any, event: any) {
    this.productMappingService.onMappingSelected(
      product,
      event,
      this.buildProductMappingDeps(),
    );
  }
  // Reusable method to map items to Product structure
  private mapItemsToProducts(
    items: any[],
    isExchangeOrder: boolean = false,
    isQuotation: boolean = false,
  ): Product[] {
    return this.productMappingService.mapItemsToProducts(
      items,
      isExchangeOrder,
      isQuotation,
      this.buildProductMappingDeps(),
    );
  }
  onInvoiceRowClick(event: any) {
    this.productMappingService.onInvoiceRowClick(
      event,
      this.buildProductMappingDeps(),
    );
  }
  mapSalesItemToProduct(
    salesItem: Salesitem,
    products: Product[],
  ): Product | undefined {
    return this.productMappingService.mapSalesItemToProduct(
      salesItem,
      products,
    );
  }

  exchangeProduct() {
    this.showInvoiceDialog = true;
  }
  onInvoiceSelected(event: any) {
    this.productMappingService.onInvoiceSelected(
      event,
      this.buildProductMappingDeps(),
    );
  }

  // Handler for dialog close event
  onInvoiceDialogClosed() {
    this.productMappingService.onInvoiceDialogClosed(
      this.buildProductMappingDeps(),
    );
  }

  getProducts(searchText?: string) {
    this.productMappingService.getProducts(
      searchText,
      this.buildProductMappingDeps(),
    );
  }
  formAllProducts(products: Product[], isResumeReceipt?: boolean) {
    this.productMappingService.formAllProducts(
      products,
      isResumeReceipt,
      this.buildProductMappingDeps(),
    );
  }
  populateFilterProducts(event: any) {
    this.productMappingService.populateFilterProducts(
      event,
      this.buildProductMappingDeps(),
    );
  }
  onSelectProduct(
    productId: string | null,
    psid: string,
    isUISelect?: boolean,
  ) {
    this.productMappingService.onSelectProduct(
      productId,
      psid,
      isUISelect,
      this.buildProductMappingDeps(),
    );
  }

  triggerBounce() {
    this.isBouncing = true;
    setTimeout(() => {
      this.isBouncing = false;
    }, 5000);
  }

  actionSelected() {
    this.onSelectProduct(
      this.autoCompletedselectedProduct.productId,
      this.autoCompletedselectedProduct.psid,
      false,
    );

    if (this.isDeleteMode) {
      // In Delete Mode: Remove item instead of adding
      this.removeItemByPSID(this.autoCompletedselectedProduct.psid);
    } else {
      // Normal Mode: Add item with sellingprice and batch for proper unique identification
      this.addProducts(
        this.autoCompletedselectedProduct.psid,
        this.autoCompletedselectedProduct.sellingprice,
        this.autoCompletedselectedProduct.batch,
      );
    }

    this.itemId = '';
    this.selectedProductId = this.autoCompletedselectedProduct.productId;
    this.currentPSID = this.autoCompletedselectedProduct.psid;

    this.autoCompletedselectedProduct = null as any;
  }
  enterSelected() {
    if (
      this.autoCompletedselectedProduct &&
      this.autoCompletedselectedProduct.psid
    ) {
      // Product is already selected from autocomplete dropdown
      // onSelect event already handled it, so do nothing to avoid duplicate
      // Just clear the selection
      this.autoCompletedselectedProduct = null as any;
      this.itemId = '';
    } else if (this.itemId && this.itemId.trim()) {
      // User typed a barcode/PSID manually and pressed Enter
      let itemid = this.itemId;

      if (this.isDeleteMode) {
        // In Delete Mode: Remove item from cart
        this.removeItemByPSID(itemid);
      } else {
        // Normal Mode: Add item to cart
        this.addProducts(itemid);
      }

      this.itemId = '';
    }
  }
  onBarcodeEnter() {
    this.barcodeScannerService.onBarcodeEnter(this.buildBarcodeScannerDeps());
  }
  onBarcodeInput() {
    this.barcodeScannerService.onBarcodeInput(this.buildBarcodeScannerDeps());
  }

  onBarcodeBlur() {
    this.barcodeScannerService.onBarcodeBlur(this.buildBarcodeScannerDeps());
  }

  // MOVED-TO: src/app/shared/services/keyboard-navigation.service.ts -> KeyboardNavigationService (whole cluster)
  // Builds the shared dependency bag passed to every method in the keyboard-navigation
  // cluster (handleKeyboardShortcuts, handleEscapeKey, onGlobalKeyDown, onPaymentDialogKeyDown,
  // onTransactionHistoryKeyDown, navigate*, handleOfferGroupDialogTabNavigation,
  // setupGlobalKeyboardShortcuts). These methods call each other, so they are extracted and
  // documented together rather than one at a time.
  private buildKeyboardNavDeps(): KeyboardNavigationDeps {
    return {
      userName: this.userName,
      displayModal: this.displayModal,
      showTransactionDialog: this.showTransactionDialog,
      displayHoldNameDialog: this.displayHoldNameDialog,
      showOfferGroupCustomerDialog: this.showOfferGroupCustomerDialog,
      savedReceiptsDialog: this.savedReceiptsDialog,
      showCashInDialog: this.showCashInDialog,
      showTotalDialog: this.showTotalDialog,
      showInvoiceDialog: this.showInvoiceDialog,
      showKeyboardHelp: this.showKeyboardHelp,
      displayDialog: this.displayDialog,
      splitBillDialog: this.splitBillDialog,
      showItemDetailDialog: this.showItemDetailDialog,
      showDescriptionDialog: this.showDescriptionDialog,
      showWarrantyDialog: this.showWarrantyDialog,
      showQuotationOptionsDialog: this.showQuotationOptionsDialog,
      displayMobileNumberDialog: this.displayMobileNumberDialog,
      isDeleteMode: this.isDeleteMode,
      hasScannerClicked: this.hasScannerClicked,
      activeHistoryTab: this.activeHistoryTab,
      flattenedTransactions: this.flattenedTransactions,
      quotations: this.quotations,
      selectedTransactionIndex: this.selectedTransactionIndex,
      selectedQuotationIndex: this.selectedQuotationIndex,
      customerMobile: this.customerMobile,
      offerGroupMobileAutocomplete: this.offerGroupMobileAutocomplete,
      dashboardContainer: this.dashboardContainer,
      enableCursorFocus: this.enableCursorFocus,
      isQuotationMode: this.isQuotationMode,
      isProcessingQuotation: this.isProcessingQuotation,
      getUserName: () => this.userName,
      getEnableCursorFocus: () => this.enableCursorFocus,
      setShowTransactionDialog: (value) => (this.showTransactionDialog = value),
      setDisplayHoldNameDialog: (value) => (this.displayHoldNameDialog = value),
      setShowOfferGroupCustomerDialog: (value) =>
        (this.showOfferGroupCustomerDialog = value),
      setSavedReceiptsDialog: (value) => (this.savedReceiptsDialog = value),
      setShowKeyboardHelp: (value) => (this.showKeyboardHelp = value),
      setSelectedTransactionIndex: (value) =>
        (this.selectedTransactionIndex = value),
      setSelectedQuotationIndex: (value) =>
        (this.selectedQuotationIndex = value),
      handleEvent: (key) => this.handleEvent(key),
      closeTotalDialog: () => this.closeTotalDialog(),
      closeItemDetailDialog: () => (this.showItemDetailDialog = false),
      closeDescriptionDialog: () => this.closeDescriptionDialog(),
      closeWarrantyDialog: () => this.closeWarrantyDialog(),
      toggleQR: () => this.toggleQR(),
      focusBarcodeSearch: () => this.focusBarcodeSearch(),
      focusProductSearch: () => this.focusProductSearch(),
      focusOnDiscountToggle: () => this.focusOnDiscountToggle(),
      toggleQuotationMode: () => this.toggleQuotationMode(),
      toggleSuspenseMode: () => this.toggleSuspenseMode(),
      toggleWholesaleMode: () => this.toggleWholesaleMode(),
      toggleOfferGroupMode: () => this.toggleOfferGroupMode(),
      canCompleteQuotation: () => this.canCompleteQuotation(),
      processQuotation: () => this.processQuotation(),
      canCompletePayment: () => this.canCompletePayment(),
      processPayment: () => this.processPayment(),
      switchHistoryTab: (goNext) => this.switchHistoryTab(goNext),
      printReceipt: (canGenerateInvoice) =>
        this.printReceipt(canGenerateInvoice),
      editQuotation: (quotation) => this.editQuotation(quotation),
      selectTransactionByIndex: (index) => this.selectTransactionByIndex(index),
      selectQuotationByIndex: (index) => this.selectQuotationByIndex(index),
      proceedWithCustomer: () => this.proceedWithCustomer(),
      proceedWithoutCustomer: () => this.proceedWithoutCustomer(),
    };
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardShortcuts(event: KeyboardEvent) {
    this.keyboardNavigationService.handleKeyboardShortcuts(
      event,
      this.buildKeyboardNavDeps(),
    );
  }
  handleEscapeKey() {
    this.keyboardNavigationService.handleEscapeKey(this.buildKeyboardNavDeps());
  }

  toggleKeyboardHelp() {
    this.keyboardNavigationService.toggleKeyboardHelp(
      this.buildKeyboardNavDeps(),
    );
  }

  // Popup dialog methods
  openTotalDialog() {
    if (this.isOrderBlocked) {
      this.showOrderBlockedMessage();
      return;
    }
    if (this.hasPendingMappingSelection()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Mapping Required',
        detail: 'Please select a mapping for all items before processing order',
        life: 3000,
      });
      return;
    }
    this.activePaymentTab = 'Cash';
    this.selectedPaymentOptions = ['Cash'];
    this.showTotalDialog = true;
  }

  async onPaymentDialogShow() {
    if (this.isExchangeOrder) {
      this.autoCheckCashForRefund();
      const domMobile = (() => {
        if (this.paymentTotalDialogRef?.mobileNumberAutocomplete?.el) {
          const input =
            this.paymentTotalDialogRef.mobileNumberAutocomplete.el.nativeElement.querySelector(
              'input',
            );
          return input?.value?.trim() || '';
        }
        return '';
      })();

      const resolvedMobile = this.mobileNumber?.trim() || domMobile || '';
      const resolvedName =
        this.customerName?.trim() || this.formData?.customerName || '';

      if (resolvedMobile || resolvedName) {
        this.mobileNumber = resolvedMobile;
        this.formDataService.updateFormData({
          ...this.formData,
          mobileNumber: resolvedMobile,
          empCode: this.formData?.empCode || '',
          storeCode: this.formData?.storeCode || '',
          currentDate: this.formData?.currentDate || new Date(),
          customerName: resolvedName,
          salesRep: this.formData?.salesRep || '',
        });
      }
      // ... rest unchanged

      if (!this.pendingExchangePayload) {
        this.buildExchangePayload();
      }
    }

    // Capture customer name from input field if property is empty
    if (
      !this.customerName &&
      this.paymentTotalDialogRef?.customerNameAutocomplete &&
      this.paymentTotalDialogRef.customerNameAutocomplete.el
    ) {
      const customerNameInput =
        this.paymentTotalDialogRef.customerNameAutocomplete.el.nativeElement.querySelector(
          'input',
        );
      if (customerNameInput && customerNameInput.value) {
        this.customerName = customerNameInput.value;
      }
    }

    // Check and clear loyalty if order value is below minimum
    this.paymentTotalDialogRef?.loyalty?.checkAndClearLoyaltyIfInvalid(
      this.getRoundedTotal(),
    );

    // Load loyalty points if customer is already selected
    if (this.selectedCustomer && this.selectedCustomer.id) {
      this.paymentTotalDialogRef?.loyalty?.loadCustomerLoyaltyPoints(
        this.selectedCustomer.id,
        this.isExchangeOrder,
      );
    } else if (this.mobileNumber) {
      // Ensure customers are loaded before searching
      await this.ensureCustomersLoaded();

      const customer = this.customers.find(
        (c) => c.mobile_no === this.mobileNumber,
      );
      if (customer && customer.id) {
        this.selectedCustomer = customer;
        this.paymentTotalDialogRef?.loyalty?.loadCustomerLoyaltyPoints(
          customer.id,
          this.isExchangeOrder,
        );
      } else {
        console.log(
          ' Customer not found in customers array. Mobile:',
          this.mobileNumber,
          'Customers count:',
          this.customers.length,
        );
      }
    } else {
      console.log(' No customer selected and no mobile number provided');
    }

    setTimeout(() => {
      if (!this.isExchangeOrder) {
        // Always focus on mobile number autocomplete input (whether filled or not)
        if (
          this.paymentTotalDialogRef?.mobileNumberAutocomplete &&
          this.paymentTotalDialogRef.mobileNumberAutocomplete.el
        ) {
          const inputElement =
            this.paymentTotalDialogRef.mobileNumberAutocomplete.el.nativeElement.querySelector(
              'input',
            );
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      }
    }, 150);
  }

  closeTotalDialog() {
    this.showTotalDialog = false;
    this.clearUpiQrState();

    this.pendingExchangePayload = null;

    if (this.isExchangeOrder) {
      this.cashAmount = 0;
      this.refundCashAmount = 0;
      this.resetCardDetails();
      this.resetUpiDetails();
      this.splitPaymentAmounts = { cash: 0, card: 0, upi: 0 };
      this.resetPartPaymentStates();
      this.selectedPaymentOptions = ['Cash'];
    } else {
      this.resetPartPaymentStates();
      this.resetCashDetails();
      this.resetCardDetails();
      this.resetUpiDetails();
      this.resetRedeemCreditDetails();
      this.splitPaymentAmounts = { cash: 0, card: 0, upi: 0 };
    }
  }

  canProcessPayment(): boolean {
    // Enable "Continue to Payment" button when there are items in cart
    // Payment options will be selected in the payment dialog
    return (
      this.getRoundedTotal() > 0 && this.products && this.products.length > 0
    );
  }

  canCompletePayment(): boolean {
    // Check if payment can be completed (for Process Payment button)
    const hasPaymentOptions =
      this.selectedPaymentOptions &&
      (Array.isArray(this.selectedPaymentOptions)
        ? this.selectedPaymentOptions.length > 0
        : true);

    // Allow payment processing even with 0 or negative balance (refund scenario)
    const balance = this.calculateBalance();
    const isAddToCreditMode =
      this.isExchangeOrder && this.isSelected('Add to Credit');
    const isBalanceValid =
      balance <= 0 || this.isAnyPartPaymentEnabled() || isAddToCreditMode;

    // Check if mobile number is valid when credit is enabled
    const isCreditEnabled =
      this.isPartPaymentCash ||
      this.isPartPaymentCard ||
      this.isPartPaymentUPI ||
      isAddToCreditMode;
    const isMobileValid =
      !isCreditEnabled ||
      !!(this.mobileNumber && this.mobileNumber.length === 10);
    return (
      this.getRoundedTotal() > 0 &&
      !!hasPaymentOptions &&
      isBalanceValid &&
      isMobileValid
    );
  }

  showProductDetails(product: Product) {
    this.selectedProductId = product.productId;
    this.onSelectProduct(product.productId, product.psid, false);
    this.showItemDetailDialog = true;
  }

  openDescriptionDialog(product: Product) {
    this.selectedProductForDescription = product;
    this.tempDescription = product.description || '';
    this.showDescriptionDialog = true;
  }

  /** Description dialog (onShow): put the caret in the textarea with the existing text selected. */
  focusDescriptionTextarea(textarea: HTMLTextAreaElement) {
    textarea.focus();
    textarea.select();
  }

  closeDescriptionDialog() {
    this.showDescriptionDialog = false;
    this.selectedProductForDescription = null;
    this.tempDescription = '';
  }

  saveDescription() {
    if (this.selectedProductForDescription) {
      this.selectedProductForDescription.description =
        this.tempDescription.trim();
      const productIndex = this.products.findIndex(
        (p) => p.psid === this.selectedProductForDescription!.psid,
      );
      if (productIndex !== -1) {
        this.products[productIndex].description = this.tempDescription.trim();
        this.productsTemp = this.products.map((product) => ({ ...product }));
      }
    }
    this.closeDescriptionDialog();
  }

  openWarrantyDialog(product: Product) {
    this.selectedProductForWarranty = product;
    this.tempWarrantyDate = product.warranty_date
      ? new Date(`${product.warranty_date}T00:00:00`)
      : null;
    this.showWarrantyDialog = true;
  }

  closeWarrantyDialog() {
    this.showWarrantyDialog = false;
    this.selectedProductForWarranty = null;
    this.tempWarrantyDate = null;
  }

  setWarrantyMonths(months: number) {
    const date = new Date();
    date.setMonth(date.getMonth() + months);
    this.tempWarrantyDate = date;
  }

  clearWarranty() {
    this.tempWarrantyDate = null;
    this.saveWarranty();
  }

  saveWarranty() {
    if (this.selectedProductForWarranty) {
      const date = this.tempWarrantyDate;
      // Local calendar date as YYYY-MM-DD (toISOString would shift it by the UTC offset)
      const value = date
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
        : null;
      this.selectedProductForWarranty.warranty_date = value;
      const productIndex = this.products.findIndex(
        (p) => p.psid === this.selectedProductForWarranty!.psid,
      );
      if (productIndex !== -1) {
        this.products[productIndex].warranty_date = value;
        this.productsTemp = this.products.map((product) => ({ ...product }));
      }
    }
    this.closeWarrantyDialog();
  }

  openTransactionDialog() {
    this.showTransactions(); // Load transactions
    this.showTransactionDialog = true;

    // Always focus on the first tab when dialog opens
    setTimeout(() => {
      this.focusHistoryDialogFirstElement();
    }, 150);
  }
  focusHistoryDialogFirstElement() {
    this.focusManagerService.focusHistoryDialogFirstElement();
  }
  focusFirstDialogElement() {
    this.focusManagerService.focusFirstDialogElement();
  }

  refreshTransactions() {
    // Don't clear selection here - let createFlattenedTransactions auto-select first transaction
    this.showTransactions(); // Reload transactions
  }

  findSelectedProduct(productId: string): Product | null {
    return this.productMappingService.findSelectedProduct(
      productId,
      this.buildProductMappingDeps(),
    );
  }

  // Optimized getter for selected product details to avoid multiple method calls in template
  get selectedProductDetails(): Product | null {
    // console.log(this.findSelectedProduct(this.selectedProductId || ''),'selectedProductId')
    return this.selectedProductId
      ? this.findSelectedProduct(this.selectedProductId)
      : null;
  }

  trackByProductId = (index: number, product: Product): string => {
    return this.productMappingService.trackByProductId(index, product);
  };

  /** Checks if the base unit is already represented in unit_mappings */
  hasBaseUnitInMappings(product: any): boolean {
    if (!product?.unit_mappings?.length) return false;
    return product.unit_mappings.some(
      (m: any) => m.unitid == null || m.unitid == product.unit,
    );
  }

  /**
   * Remembers the line's base-unit values the first time its unit is changed,
   * so switching back (or to another unit) always starts from the real base
   * values instead of whatever the previous unit left on the line.
   */
  private ensureBaseUnitSnapshot(product: any): void {
    if (product.baseUnitSnapshot) return;
    product.baseUnitSnapshot = {
      // Held/quotation lines come back with their saved unit already on the line,
      // so the server sends the real base-unit price/MRP separately.
      sellingprice: product.baseunitprice ?? (product.barcodesellprice || product.sellingprice),
      wholesaleprice: product.wholesaleprice,
      costprice: product.costprice,
      purchaseprice: product.purchaseprice,
      sellingmrp: product.baseunitmrp ?? product.sellingmrp,
      product_cost_price_incl: product.product_cost_price_incl,
      product_selling_price_incl: product.product_selling_price_incl,
    };
  }

  /** True when the line is sold in the product's base unit (no unit-specific price). */
  private isBaseSaleUnit(product: any): boolean {
    return !product.unit_id || product.unit_id == product.unit || (product.unit_mappings?.length && product.unit_id == product.unit_mappings[0].unitid && !product.unit_mappings[0].sellingprice);
  }

  /** Re-applies the line's existing discount after its unit price changed. */
  private reapplyLineDiscount(product: any): void {
    if (this.isSalesDiscountEditEnabled) {
      this.applyLineDiscount(product);
    }
  }

  /** When user changes the sale unit on a multi-unit product, update price from mapping */
  onSaleUnitChange(product: any): void {
    this.setSaleUnitPrices(product);
    this.reapplyLineDiscount(product);
    this.calculateBalance();
  }

  /**
   * Sets the line's price, cost and MRP for its selected sale unit
   * (base unit = saved base values, secondary unit = its unit mapping).
   * Does not touch the discount.
   */
  private setSaleUnitPrices(product: any): void {
    this.ensureBaseUnitSnapshot(product);
    const base = product.baseUnitSnapshot;

    if (this.isBaseSaleUnit(product)) {
      // Reverted to base unit - restore the base-unit price, cost and MRP
      product.sellingprice = base.sellingprice;
      product.orgprice = base.sellingprice;
      product.unitsellprice = undefined;
      product.wholesaleprice = base.wholesaleprice;
      product.costprice = base.costprice;
      product.purchaseprice = base.purchaseprice;
      product.sellingmrp = base.sellingmrp;
      product.product_cost_price_incl = base.product_cost_price_incl;
      product.product_selling_price_incl = base.product_selling_price_incl;
      if (product.baseunitprice != null) {
        // Loaded held/quotation line: barcodesellprice held the saved unit's price; quotation mode prices from it
        product.barcodesellprice = base.sellingprice;
      }
      product.uom = product.unit_mappings?.[0]?.unitdetails?.displayname || product.unit_mappings?.[0]?.unitdetails?.name || null;
      return;
    }
    const mapping = (product.unit_mappings || []).find(
      (m: any) => m.unitid == product.unit_id,
    );
    if (mapping) {
      const taxRate = Number(product.sales_tax || product.tax || 0);

      let inclusivePrice: any;
      if (this.isWholesaleMode) {
        // Always derive from the base-unit wholesale price so repeated unit switches don't compound
        inclusivePrice = Number(base.wholesaleprice || 0) / mapping.conversionfactor
      } else {
        inclusivePrice = Number(mapping.sellingprice || 0);
      }
      const inclusiveCostPrice = Number(mapping.purchaseprice || 0)

      const exclusiveCostPrice = inclusiveCostPrice / (1 + taxRate / 100);
      const exclusivePrice = inclusivePrice / (1 + taxRate / 100);

      product.sellingprice = Number(exclusivePrice.toFixed(2));
      product.wholesaleprice = Number(exclusivePrice.toFixed(2));
      product.orgprice = product.sellingprice;
      // Undiscounted price for this unit; discount recalculation starts from it
      product.unitsellprice = product.sellingprice;
      product.sellingmrp = mapping.mrp || base.sellingmrp;
      product.purchaseprice = Number(exclusiveCostPrice.toFixed(2));
      product.costprice = exclusiveCostPrice;
      product.product_selling_price_incl = mapping.sellingprice;
      product.product_cost_price_incl = inclusiveCostPrice;
      product.uom = mapping.unitdetails?.displayname || mapping.unitdetails?.name || String(product.unit_id);
    }
  }

  /**
   * After a held receipt or quotation is loaded into the cart:
   *  - lines saved in a secondary sale unit are priced from that unit's mapping
   *    (same as picking the unit in the dropdown), instead of the base-unit price;
   *  - with applySavedDiscount (held receipts), the saved per-unit discount amount is taken
   *    off the line price. The server returns held lines at their undiscounted price, so
   *    without this the discount is shown but not charged. Only for modes whose totals use
   *    sellingprice and discount-before-tax (after-tax discount is subtracted from totals).
   */
  restoreSavedLinePrices(applySavedDiscount: boolean): void {
    const discountReducesPrice =
      applySavedDiscount &&
      !this.isDiscountAfterTaxEnabled &&
      !this.isQuotationMode &&
      !this.isWholesaleMode &&
      !this.isOfferGroupMode;

    (this.products || []).forEach((product: any) => {
      if (product.unit_mappings?.length && !this.isBaseSaleUnit(product)) {
        this.setSaleUnitPrices(product);
      }
      if (this.isQuotationMode) {
        // Keep sellingprice (used for the overall-discount base) in line with the quotation price
        product.sellingprice = Number(this.getEffectivePrice(product)) || 0;
      }
      if (discountReducesPrice) {
        const savedDiscount = Number(product.discountval) || 0;
        if (savedDiscount > 0) {
          const basePrice = Number(this.getEffectiveBasePrice(product)) || 0;
          product.discountval = Math.min(savedDiscount, basePrice);
          product.sellingprice = basePrice - product.discountval;
        }
      }
    });
    this.productsTemp = this.products.map((product) => ({ ...product }));
  }

  decreaseQuantity(product: Product) {
    const newQuantity = product.increaseQuantity - 1;
    const minQuantity = this.getMinQuantityForProduct(product);

    if (newQuantity >= minQuantity) {
      product.increaseQuantity = newQuantity;
      // Releases this row's unit back to the shared batch/variant pool —
      // the pool is derived live from `this.products`, so any other row
      // (e.g. a different mapping of the same batch/variant) sees the
      // freed-up stock on its very next cap check, no separate bookkeeping.
      if (this.industryService.isMobile() && product?.selectedMapValue) {
        this.mobileStockReservationService.syncToStorage(this.products);
      }
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Minimum Quantity',
        detail: `Quantity cannot be less than ${minQuantity}`,
        life: 2000,
      });
    }
  }

  getMaxQuantity(product: Product): any {
    return product.selectedMapValue?.qty ?? product.qty;
  }
  increaseQuantity(product: Product) {
    const maxQuantity = this.getMaxQuantityForProduct(product);
    const newQuantity = product.increaseQuantity + 1;
    if (product.product_type === 'Non Stock' || newQuantity <= maxQuantity) {
      product.increaseQuantity = newQuantity;
      this.activeItem = this.items && this.items[0];
      this.showItemDetail = false;
      this.displayNoItem = false;
      this.showBillDetail = true;
      if (this.industryService.isMobile() && product?.selectedMapValue) {
        this.mobileStockReservationService.syncToStorage(this.products);
      }
    } else {
      product.increaseQuantity = maxQuantity;
      this.messageService.add({
        severity: 'warn',
        summary: 'Stock Limit',
        detail: `Maximum available quantity is ${maxQuantity}`,
        life: 2000,
      });
    }
  }

  getdecimalval(quantity: number | null | undefined): number {
    if (quantity === null || quantity === undefined || isNaN(quantity)) {
      return 0;
    }

    if (this.isDecimalQuantityEnabled) {
      /*console.log(
        'Decimal quantity enabled, returning quantity with 2 decimal places:',
        quantity,
      );*/
      return parseFloat(quantity.toFixed(2));
    } else {
      return Math.round(quantity);
    }
  }

  getMaxQuantityForProduct(product: Product): number {
    if (product.product_type === 'Non Stock') {
      return Number.MAX_SAFE_INTEGER; //  unlimited
    }
    if (this.industryService.isMobile() && product?.selectedMapValue) {
      // Cap this row by what the shared batch/variant pool has left, not
      // the raw per-row qty — other cart rows tagged with a different
      // mapping (e.g. "S2" vs "A36") but the same underlying batch+variant
      // draw from the same physical stock.
      const poolKey = this.mobileStockReservationService.buildPoolKey(
        product.psid,
        product.selectedMapValue.id,
      );
      const reservedByOthers =
        this.mobileStockReservationService.getReservedQty(
          poolKey,
          this.products,
          [product],
        );
      return Math.max(0, product.selectedMapValue.qty - reservedByOthers);
    }

    // In quotation mode, use stockquanity (currently available stock)
    // In all other modes, use quantity (available stock)
    let baseMax = -1;
    // stock values can arrive as strings (e.g. mobile rows before a variant is picked), so coerce before toFixed
    if (product.stockquanity) {
      baseMax = parseFloat(Number(product.stockquanity).toFixed(2)) || -1;
    } else {
      baseMax = parseFloat(Number(product.quantity).toFixed(2)) || -1;
    }

    if (baseMax > 0 && product.unit_id && product.unit_mappings) {
      const isLowBaseUnit = product.unit_mappings.some(
        (m: any) => parseFloat(m.conversionfactor) >= 1,
      );
      const mapping = product.unit_mappings.find(
        (m: any) => m.unitid == product.unit_id,
      );

      if (isLowBaseUnit) {
        // Sort mappings by id to ensure correct chain order
        const sortedMappings = [...product.unit_mappings].sort(
          (a: any, b: any) => a.id - b.id,
        );
        const selectedIndex = sortedMappings.findIndex(
          (m: any) => m.unitid == product.unit_id,
        );

        if (selectedIndex !== -1) {
          // Multiply all factors up to and including the selected unit
          let chainMultiplier = 1;
          for (let i = 0; i <= selectedIndex; i++) {
            chainMultiplier *= parseFloat(
              sortedMappings[i].conversionfactor || 1,
            );
          }
          baseMax = parseFloat((baseMax * chainMultiplier).toFixed(2));
        }
      } else {
        if (mapping && mapping.conversionfactor) {
          baseMax = parseFloat((baseMax / mapping.conversionfactor).toFixed(2));
        }
      }
    }
    return baseMax;
  }

  // "Stock : X" badge shown under the qty stepper. For mobile-industry
  // variant rows this must NOT be getMaxQuantityForProduct()'s row ceiling
  // (that number includes the row's OWN qty, so it looks unchanged when you
  // increase that same row, and looks "too high" on a sibling mapping row
  // that hasn't consumed its share yet). This shows the pool's true
  // unclaimed remainder — the same figure on every row of the same
  // batch/variant, decreasing as ANY of them grows and rising as any is
  // reduced or removed.
  getDisplayStockQty(product: Product): number {
    if (product.product_type === 'Non Stock') {
      return Number.MAX_SAFE_INTEGER;
    }
    if (this.industryService.isMobile() && product?.selectedMapValue) {
      const poolKey = this.mobileStockReservationService.buildPoolKey(
        product.psid,
        product.selectedMapValue.id,
      );
      return this.mobileStockReservationService.getAvailableQty(
        poolKey,
        product.selectedMapValue.qty,
        this.products,
      );
    }
    return this.getMaxQuantityForProduct(product);
  }

  getMinQuantityForProduct(product: Product): number {
    // Check both global setting AND product-level setting
    if (this.isDecimalQuantityEnabled && product.allowdecimalquantity === 1) {
      return 0.01; // Allow decimals
    }
    return 1; // Integer only
  }

  canProductUseDecimals(product: Product): boolean {
    return this.isDecimalQuantityEnabled && product.allowdecimalquantity === 1;
  }

  onQuantityChange(product: Product): void {
    let newQuantity = Number(product.increaseQuantity);
    const minQuantity = this.getMinQuantityForProduct(product);
    const maxQuantity = this.getMaxQuantityForProduct(product);

    // Ensure minimum quantity based on product settings
    if (isNaN(newQuantity) || newQuantity < minQuantity) {
      newQuantity = minQuantity;
    }

    if (product.product_type !== 'Non Stock' && newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
      this.messageService.add({
        severity: 'warn',
        summary: 'Stock Limit Exceeded',
        detail: `Maximum available quantity is ${maxQuantity}`,
        life: 2000,
      });
    }

    product.increaseQuantity = newQuantity;
    if (this.industryService.isMobile() && product?.selectedMapValue) {
      this.mobileStockReservationService.syncToStorage(this.products);
    }
  }

  onQuantityFocusOut(product: Product): void {
    const maxQuantity = this.getMaxQuantityForProduct(product);
    const minQuantity = this.getMinQuantityForProduct(product);
    const canUseDecimals = this.canProductUseDecimals(product);
    let newQuantity = Number(product.increaseQuantity);

    if (isNaN(newQuantity) || newQuantity < minQuantity) {
      newQuantity = minQuantity;
      product.increaseQuantity = newQuantity;
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Quantity',
        detail: `Quantity reset to minimum: ${minQuantity}`,
        life: 2000,
      });
      return;
    }

    if (!canUseDecimals && newQuantity % 1 !== 0) {
      newQuantity = Math.round(newQuantity);
      product.increaseQuantity = newQuantity;
      this.messageService.add({
        severity: 'info',
        summary: 'Quantity Rounded',
        detail: `Decimal quantities not allowed. Rounded to ${newQuantity}`,
        life: 2000,
      });
      return;
    }

    // On focus out, reset to max if exceeds limit (only for Stock products, including undefined product_type)
    if (product.product_type !== 'Non Stock' && newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
      product.increaseQuantity = newQuantity;
      this.messageService.add({
        severity: 'warn',
        summary: 'Stock Limit Exceeded',
        detail: `Quantity reset to maximum available: ${maxQuantity}`,
        life: 3000,
      });
    }
    if (this.industryService.isMobile() && product?.selectedMapValue) {
      this.mobileStockReservationService.syncToStorage(this.products);
    }
  }

  // Locates the exact row a cart action (remove/delete) was triggered on.
  // Matching on psid alone is ambiguous once a product can appear as
  // multiple cart rows (mobile industry: same batch/variant sold under
  // different mappings, e.g. "S2" vs "A36") - a psid-only lookup could
  // silently act on the wrong row and leave the intended one untouched.
  private findCartRowIndex(product: Product): number {
    const byRef = this.products.indexOf(product);
    if (byRef !== -1) return byRef;

    return this.products.findIndex(
      (item) =>
        item?.psid?.toLowerCase() === product.psid?.toLowerCase() &&
        item.batch === product.batch &&
        (item.selectedMapValue?.id ?? null) ===
          (product.selectedMapValue?.id ?? null) &&
        (item.mapping_id ?? item.selectedMappingId ?? null) ===
          (product.mapping_id ?? product.selectedMappingId ?? null),
    );
  }

  removeItem(product: Product) {
    const foundIndex = this.findCartRowIndex(product);

    if (
      this.isExchangeOrder &&
      foundIndex !== -1 &&
      this.selectedInvoiceData?.invoice?.salesitems
    ) {
      const productUuid = this.products[foundIndex]?.uuid;
      if (productUuid) {
        const salesItemIndex =
          this.selectedInvoiceData.invoice.salesitems.findIndex(
            (salesItem) => salesItem.uuid === productUuid,
          );
        if (salesItemIndex !== -1) {
          this.selectedInvoiceData.invoice.salesitems.splice(salesItemIndex, 1);
        }
      }
    }

    if (this.products[foundIndex]?.returned === true) {
      delete this.products[foundIndex].returned;
      this.products.splice(foundIndex, 1);
      this.currentPSID = this.products[foundIndex].psid;
    } else if (this.products[foundIndex]?.increaseQuantity > 1) {
      this.activeItem = this.items && this.items[0];
      this.displayNoItem = false;
      this.showItemDetail = false;
      this.showBillDetail = true;
      this.products[foundIndex].increaseQuantity =
        this.products[foundIndex]?.increaseQuantity - 1;
    } else if (this.products?.length < 0) {
      this.displayNoItem = true;
    } else {
      this.products.splice(foundIndex, 1);
    }

    if (this.industryService.isMobile()) {
      this.mobileStockReservationService.syncToStorage(this.products);
    }

    this.paymentTotalDialogRef?.loyalty?.checkAndClearLoyaltyIfInvalid(
      this.getRoundedTotal(),
    );
  }

  removeItemByPSID(psid: string) {
    // Find the product by PSID in the current cart (case-insensitive)
    const foundProduct = this.products.find(
      (item) => item?.psid?.toLowerCase() === psid?.toLowerCase(),
    );

    if (foundProduct) {
      const productDetails = {
        productId: foundProduct.productId,
        psid: foundProduct.psid,
        name: foundProduct.name,
        quantity: foundProduct.increaseQuantity,
        sellingprice: foundProduct.sellingprice,
        hsncode: foundProduct.hsncode,
        tax: foundProduct.tax,
        ctax: foundProduct.ctax,
        stax: foundProduct.stax,
        warehouse_id: foundProduct.warehouse_id,
        deletedAt: new Date().toISOString(),
        deletedBy: this.formData?.customerName || 'POS User',
        reason: 'Scanner delete operation',
      };

      // Call void item API
      this.productService.voidItem(productDetails).subscribe({
        next: (response) => {
          if (response.code === '200') {
            // API call successful - proceed with removal
            this.removeItem(foundProduct);
            this.messageService.add({
              severity: 'success',
              summary: 'Item Voided',
              detail: `${foundProduct.name} voided and removed from cart`,
              life: 3000,
            });

            this.calculateBalance();

            if (this.products.length === 0) {
              this.displayNoItem = true;
              this.showBillDetail = false;
              this.showItemDetail = false;
            }
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Void Failed',
              detail: response.message || 'Failed to void item',
              life: 3000,
            });
          }
        },
        error: (error) => {
          console.error('Void API Error:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'API Error',
            detail: 'Failed to void item. Please try again.',
            life: 3000,
          });
        },
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Item Not Present',
        detail: 'Item is not present in cart to remove',
        life: 3000,
      });
    }
  }

  getIncreaseQuantity(product: Product): number {
    return Math.min(1, product.quantity);
  }
  getUniqueItemsCount(): number {
    return this.posCalculationService.getUniqueItemsCount(
      this.products,
      this.isExchangeOrder,
    );
  }

  getTotalCount(): number {
    return this.posCalculationService.getTotalCount(
      this.products,
      this.isExchangeOrder,
    );
  }
  getFreeCount(): number {
    if (!this.products || !this.products.length) return 0;
    return this.products
      .filter((p) => !p.returned)
      .reduce((sum, p) => sum + (Number(p.cart_free_qty) || 0), 0);
  }

  /** Returns true when at least one cart item has available free stock (drives column visibility) */
  hasFreeQtyProducts(): boolean {
    return (this.products || []).some(
      (p) => (Number(p.free_qty_available) || 0) > 0,
    );
  }

  increaseFreeQty(product: Product): void {
    const current = Number(product.cart_free_qty) || 0;
    const step = this.canProductUseDecimals(product) ? 0.01 : 1;
    const available = Number(product.free_qty_available) || 0;
    const next = parseFloat((current + step).toFixed(2));
    // Cap at available free stock
    product.cart_free_qty = available > 0 ? Math.min(next, available) : next;
  }

  decreaseFreeQty(product: Product): void {
    const current = Number(product.cart_free_qty) || 0;
    const step = this.canProductUseDecimals(product) ? 0.01 : 1;
    const next = parseFloat((current - step).toFixed(2));
    product.cart_free_qty = Math.max(0, next);
  }

  /**
   * Called on every keystroke of the free qty input.
   * Empty/NaN input is left as-is (returns early) to avoid showing errors mid-type.
   * Negative values are clamped to 0.
   */
  onFreeQtyChange(product: Product): void {
    const raw = product.cart_free_qty as any;
    // If input is empty string / undefined, allow it temporarily (blur will normalise)
    if (raw === '' || raw === null || raw === undefined) {
      product.cart_free_qty = undefined;
      return;
    }
    const parsed = Number(raw);
    if (isNaN(parsed)) {
      product.cart_free_qty = 0;
      return;
    }
    if (parsed < 0) {
      product.cart_free_qty = 0;
      return;
    }
    const available = Number(product.free_qty_available) || 0;
    const clamped = available > 0 ? Math.min(parsed, available) : parsed;
    if (!this.canProductUseDecimals(product)) {
      product.cart_free_qty = Math.round(clamped);
    } else {
      product.cart_free_qty = clamped;
    }
  }

  /**
   * Called on blur of free qty input.
   * Normalises empty/NaN to 0 and rounds if decimals not allowed.
   */
  onFreeQtyFocusOut(product: Product): void {
    const raw = product.cart_free_qty as any;
    if (raw === '' || raw === null || raw === undefined || isNaN(Number(raw))) {
      product.cart_free_qty = 0;
      return;
    }
    const parsed = Number(raw);
    if (parsed < 0) {
      product.cart_free_qty = 0;
      return;
    }
    const available = Number(product.free_qty_available) || 0;
    const clamped = available > 0 ? Math.min(parsed, available) : parsed;
    if (!this.canProductUseDecimals(product)) {
      product.cart_free_qty = Math.round(clamped);
    } else {
      product.cart_free_qty = parseFloat(clamped.toFixed(2));
    }
  }

  getDisctotal(): number {
    return this.posCalculationService.getDisctotal(
      this.products,
      this.isExchangeOrder,
    );
  }
  getSubtotal(): number {
    return this.posCalculationService.getSubtotal(
      this.products,
      this.isExchangeOrder,
      (p) => this.getEffectivePrice(p),
      (p) => this.getInclLineBreakup(p),
    );
  }

  /**
   * Profit Amount = Σ (product.marginamount × quantity) for all active cart items.
   * Delegates to PosCalculationService.getProfitAmount() — auto-recalculates
   * whenever this.products or isExchangeOrder changes (same as all other totals).
   */
  getProfitAmount(): number {
    return this.posCalculationService.getProfitAmount(
      this.products,
      this.isExchangeOrder,
      this.getDisctotal(),
      this.getOverAllDiscountAmount(),
    );
  }

  isInterStateTax(): boolean {
    return this.posCalculationService.isInterStateTax(this.selectedCustomer);
  }
  getCGST(): number {
    return this.posCalculationService.getCGST(
      this.products,
      this.isExchangeOrder,
      this.isSuspenseMode,
      this.selectedCustomer,
      (p) => this.getEffectivePrice(p),
      (p) => this.getInclLineBreakup(p),
    );
  }

  getSGST(): number {
    return this.posCalculationService.getSGST(
      this.products,
      this.isExchangeOrder,
      this.isSuspenseMode,
      this.selectedCustomer,
      (p) => this.getEffectivePrice(p),
      (p) => this.getInclLineBreakup(p),
    );
  }
  getIGST(): number {
    return this.posCalculationService.getIGST(
      this.products,
      this.isExchangeOrder,
      this.isSuspenseMode,
      this.selectedCustomer,
      (p) => this.getEffectivePrice(p),
      (p) => this.getInclLineBreakup(p),
    );
  }
  getCESS(): number {
    return this.posCalculationService.getCESS(
      this.products,
      this.isExchangeOrder,
      this.isSuspenseMode,
      (p) => this.getEffectivePrice(p),
    );
  }
  getTotal(): number {
    return this.posCalculationService.getTotal(
      this.getSubtotal(),
      this.getIGST(),
      this.getSGST(),
      this.getCGST(),
      this.getCESS(),
    );
  }
  getExactTotal(): number {
    return this.posCalculationService.getExactTotal(
      this.products,
      this.isExchangeOrder,
      this.isDiscountAfterTaxEnabled,
      this.getTotal(),
      this.getOverAllDiscountAmount(),
    );
  }
  getRoundOffAmount(): number {
    return this.posCalculationService.getRoundOffAmount(
      this.getExactTotal(),
      this.getRoundedTotal(),
    );
  }

  getRoundedTotal(): number {
    return this.posCalculationService.getRoundedTotal(this.getExactTotal());
  }

  getAbsoluteBalance(): number {
    return this.paymentCalculationService.getBalanceAmount(
      this.calculateBalance(),
    );
  }

  updateRefundCashAmount(value: number) {
    if (this.isExchangeOrder) {
      this.refundCashAmount = this.getAbsoluteBalance();
    } else {
      this.refundCashAmount = value;
    }
  }

  validateCashAmount() {
    if (this.cashAmount !== null && this.cashAmount !== undefined) {
      this.cashAmount = this.paymentValidationService.roundCurrency(
        this.cashAmount,
      );
    }

    // For exchange orders, auto-calculate refund cash amount
    if (this.isExchangeOrder && this.isSelected('Cash')) {
      this.refundCashAmount =
        this.paymentValidationService.computeExchangeRefundCash(
          this.getRoundedTotal(),
          this.cashAmount || 0,
        );
    }

    this.validatePartPaymentAmount('Cash');
    const balance = this.calculateBalance();

    // For regular orders-  calculate refund when customer pays more than total
    if (!this.isExchangeOrder) {
      this.refundCashAmount =
        this.paymentValidationService.computeRegularRefundCash(balance);
    }
  }

  validateCardAmount() {
    if (
      this.cardDetails.amount !== null &&
      this.cardDetails.amount !== undefined
    ) {
      this.cardDetails.amount = this.paymentValidationService.roundCurrency(
        this.cardDetails.amount,
      );
    }
    this.validatePartPaymentAmount('Card');
    this.calculateBalance();
  }

  validateUpiAmount() {
    if (
      this.upiDetails.upiAmount !== null &&
      this.upiDetails.upiAmount !== undefined
    ) {
      this.upiDetails.upiAmount = this.paymentValidationService.roundCurrency(
        this.upiDetails.upiAmount,
      );
    }
    this.validatePartPaymentAmount('UPI');
    this.calculateBalance();
  }

  handleUpiPaymentRequest(request: UpiPaymentRequest) {
    if (this.upiPaymentRequestInFlight) {
      return;
    }

    this.upiPaymentRequestInFlight = true;
    this.productService.initiateUpiPayment(request).subscribe({
      next: async (response: any) => {
        this.upiPaymentRequestInFlight = false;

        const paymentData = response?.data ?? response;
        const paymentId = this.extractUpiPaymentId(paymentData);
        if (paymentId) {
          this.upiDetails = {
            ...this.upiDetails,
            upiId: paymentId,
          };
        }
        this.upiQrExpirySeconds = this.resolveUpiQrExpirySeconds(paymentData);
        this.paymentId = paymentId;

        this.transactionId = paymentData?.transactionId || null;
        //         {
        //     "paymentId": "ORD_FrOPxJbqPw",
        //     "status": "SUCCESS",
        //     "message": "Auto callback triggered for testing",
        //     "transactionId": "PAT_FrOPxJbqPx"
        // }
        const rawQrImage =
          paymentData?.pgOrderResponse?.qrCode ||
          paymentData?.qrCode ||
          paymentData?.qrCodeImage ||
          paymentData?.qrImage ||
          paymentData?.image ||
          '';

        if (!rawQrImage) {
          this.messageService.add({
            severity: 'error',
            summary: 'UPI Payment',
            detail:
              response?.message || 'QR code was not returned by the server.',
            life: 3000,
          });
          this.clearUpiQrState();
          return;
        }

        if (typeof rawQrImage === 'string' && rawQrImage.startsWith('data:')) {
          this.upiQrCodeImage = rawQrImage;
          if (paymentId) {
            this.paymentStatusService.startPaymentTracking(paymentId);
          }
          this.messageService.add({
            severity: 'info',
            summary: 'UPI Payment',
            detail:
              'UPI payment initiated. Scan the QR code below to complete payment.',
            life: 3000,
          });
          return;
        }

        if (typeof rawQrImage === 'string') {
          this.upiQrCodeImage =
            (await this.dashboardPdfService.convertImageUrlToBase64(
              rawQrImage,
            )) || rawQrImage;
          if (paymentId) {
            this.paymentStatusService.startPaymentTracking(paymentId);
          }
          this.messageService.add({
            severity: 'info',
            summary: 'UPI Payment',
            detail:
              'UPI payment initiated. Scan the QR code below to complete payment.',
            life: 3000,
          });
          return;
        }

        this.upiQrCodeImage = rawQrImage;
        if (paymentId) {
          this.paymentStatusService.startPaymentTracking(paymentId);
        }
        this.messageService.add({
          severity: 'info',
          summary: 'UPI Payment',
          detail:
            'UPI payment initiated. Scan the QR code below to complete payment.',
          life: 3000,
        });
      },
      error: (error) => {
        this.upiPaymentRequestInFlight = false;
        console.error('Error initiating UPI payment:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'UPI Payment',
          detail: 'Failed to create UPI QR payment.',
          life: 3000,
        });
        this.clearUpiQrState();
      },
    });
  }

  clearUpiQrState() {
    this.paymentStatusService.stopPaymentTracking();
    this.upiQrCodeImage = null;
    this.upiQrExpirySeconds = null;
  }

  private handleTrackedUpiStatus(statusUpdate: PaymentStatusUpdate | null) {
    if (!statusUpdate) {
      return;
    }

    if (statusUpdate.status === 'PENDING') {
      return;
    }

    if (statusUpdate.status === 'SUCCESS') {
      this.transactionId = statusUpdate.transactionId || this.transactionId;
      this.upiDetails = {
        ...this.upiDetails,
        upiId: this.upiDetails.upiId || statusUpdate.paymentId,
        transactionId:
          statusUpdate.transactionId || this.upiDetails.transactionId,
      };

      this.messageService.add({
        severity: 'success',
        summary: 'UPI Payment',
        detail: statusUpdate.message || 'Payment received successfully.',
        life: 3000,
      });

      const canContinuePayment =
        this.showTotalDialog &&
        this.activePaymentTab === 'UPI' &&
        this.canCompletePayment();
      this.clearUpiQrState();

      if (canContinuePayment) {
        this.processPayment();
      }
      return;
    }

    this.messageService.add({
      severity: 'error',
      summary: 'UPI Payment',
      detail:
        statusUpdate.message || `Payment ${statusUpdate.status.toLowerCase()}.`,
      life: 3000,
    });
    this.clearUpiQrState();
  }

  private extractUpiPaymentId(paymentData: any): string | null {
    const paymentId =
      paymentData?.paymentId ||
      paymentData?.pgOrderId ||
      paymentData?.orderId ||
      paymentData?.id ||
      paymentData?.pgOrderResponse?.orderId ||
      paymentData?.pgOrderResponse?.paymentId;

    if (!paymentId) {
      return null;
    }

    return String(paymentId);
  }

  private resolveUpiQrExpirySeconds(paymentData: any): number | null {
    const MIN_QR_EXPIRY_SECONDS = 150;
    const directSeconds =
      paymentData?.expiresIn ??
      paymentData?.expirySeconds ??
      paymentData?.qrExpirySeconds ??
      paymentData?.ttl ??
      paymentData?.timeout ??
      paymentData?.duration;

    if (directSeconds !== undefined && directSeconds !== null) {
      const parsedSeconds = Number(directSeconds);
      if (Number.isFinite(parsedSeconds) && parsedSeconds > 0) {
        return Math.max(Math.floor(parsedSeconds), MIN_QR_EXPIRY_SECONDS);
      }
    }

    const expiryValue =
      paymentData?.expiryDate ??
      paymentData?.expiresAt ??
      paymentData?.validUntil ??
      paymentData?.qrExpiryDate;
    const EXTRA_BUFFER_SECONDS = 150;
    if (expiryValue) {
      const expiryDate = new Date(expiryValue);
      const remainingSeconds =
        Math.floor((expiryDate.getTime() - Date.now()) / 1000) +
        EXTRA_BUFFER_SECONDS;

      if (Number.isFinite(remainingSeconds) && remainingSeconds > 0) {
        return Math.max(remainingSeconds, MIN_QR_EXPIRY_SECONDS);
      }
    }

    return null;
  }

  validateRefundCashAmount() {
    const maxRefund = this.paymentValidationService.getMaxRefundCash(
      this.isExchangeOrder,
      this.getRoundedTotal(),
      this.isSelected('Cash'),
      this.cashAmount,
      this.getAbsoluteBalance(),
    );

    const warning = this.paymentValidationService.validateRefundCashAmount(
      this.refundCashAmount,
      maxRefund,
    );
    if (warning) {
      this.messageService.add(warning);
      // Reset to maximum allowed
      this.refundCashAmount = maxRefund;
    }

    this.refundCashAmount = this.paymentValidationService.roundCurrency(
      this.refundCashAmount,
    );

    this.calculateBalance();
  }

  toggleQR() {
    this.barcodeScannerService.toggleQR(this.buildBarcodeScannerDeps());
  }

  openScanner = () => {
    if (this.hasScannerClicked) {
      this.action?.start();
    } else {
      this.action?.stop();
    }
  };

  private showOrderBlockedMessage(): void {
    // Slow-network message disabled — isOrderBlocked is now set only when OFFLINE.
    // const isOffline =
    //   this.isNetworkOffline ||
    //   this.networkHealthService.isOffline ||
    //   !window.navigator.onLine;
    // this.messageService.add({
    //   severity: 'error',
    //   summary: isOffline ? 'No Network Connection' : 'Network Too Slow',
    //   detail: isOffline
    //     ? 'Cannot process order: you are currently offline. Please check your network and try again.'
    //     : 'Cannot process order: network connection is too slow (3G). Please wait for a stable network.',
    //   life: 5000,
    // });
    this.messageService.add({
      severity: 'error',
      summary: 'No Network Connection',
      detail: 'Cannot process order: you are currently offline. Please check your network and try again.',
      life: 5000,
    });
  }

  // Method to save the current receipt with a temporary ID
  saveReceipt(needHold = false) {
    // ── Network order-blocked guard ─────────────────────────────────────────
    // Blocks when network is OFFLINE, SLOW (3G), or CRITICAL.
    if (this.isOrderBlocked) {
      this.showOrderBlockedMessage();
      return;
    }
    // ───────────────────────────────────────────────────────────────────
    // Exchange orders are determined by this.isExchangeOrder property

    if (!this.products?.length) {
      this.messageService.add({
        severity: 'error',
        summary: 'No items in cart',
        detail: this.isQuotationMode
          ? 'Add atleast one item to generate quotation'
          : 'Add atleast one item to place order',
        life: 3000,
      });
      return;
    }
    if (this.isQuotationMode && !needHold) {
      this.showTotalDialog = true;
      return;
    }

    // For regular orders, if there's a balance and not holding, open payment dialog
    if (
      !this.isExchangeOrder &&
      this.calculateBalance() > 0 &&
      !needHold &&
      !this.isAnyPartPaymentEnabled()
    ) {
      this.showTotalDialog = true;
      return;
    }
    if (!this.isExchangeOrder && needHold && !this.canProceedReceipt()) {
      return;
    }
    let tempId = '';
    if (needHold) {
      const now = new Date();
      tempId = formatDate(now, 'dd-MMM-yyyy-HH-mm-ss', 'en-US');
      const receiptData = {
        products: this.products,
      };
      localStorage.setItem(`receipt_${tempId}`, JSON.stringify(receiptData));
    }

    //  alert(`Receipt saved successfully with ID: ${tempId}`);

    const shippingDetails = this.formDataService.getShippingDetails();

    let payload: any = {
      invoicedate: this.formData?.currentDate
        ? this.formatDate(this.formData.currentDate) // Use formatted date string instead of ISO
        : this.formatDate(new Date()), // Fallback to current date if formData.currentDate is not available
      mobile: this.formData?.mobileNumber,
      name:
        this.formData?.customerName && this.formData.customerName.trim() !== ''
          ? this.formData.customerName
          : 'Walk in Customer',
      salesrep: this.formData?.salesRep,
      discpercentage: 0,
      discount: 0,
      overAllDiscount: this.getOverAllDiscountAmount(),
      overAllDiscountPercent: this.overAllDiscountPercent,
      cart: [],
      upiDetails: {},
      cardDetails: {},
      cashDetails: {},
      redeemCreditDetails: {},
      loyaltyDetails: {
        loyaltyAmount: 0,
        loyaltyPoints: 0,
        customerId: 0,
      },
      total: this.getRoundedTotal(),
      roundOffAmount: this.getRoundOffAmount(),
      isCredit: this.isAnyPartPaymentEnabled() ? 1 : 0,
      groupId: this.getGroupId(),
      isQuotationMode: this.isQuotationMode ? 1 : 0,
      paidamount: this.getPaidAmount(),
      balanceamount: this.calculateBalance(),
      shippingaddress: shippingDetails.shippingaddress || '',
      lrno: shippingDetails.lrno || '',
      vehicleno: shippingDetails.vehicleno || '',
      transportername: shippingDetails.transportername || '',
      deliverychallan: shippingDetails.deliverychallan || '',
      freeAmount: this.getFreeAmount(), // Mobile: total deducted for free products; 0 for Retail
    };

    // Add suspense flag when in suspense mode and has non-GST products
    if (this.isSuspenseMode && this.hasNonGSTProducts()) {
      payload['suspense'] = 1;
    }
    //console.log(payload)
    // Filter products based on exchange mode
    let filteredProducts = this.products;
    console.log(this.products);
    if (this.isExchangeOrder) {
      // For exchange orders, only include items with exchangeQuantity > 0
      filteredProducts = this.products.filter((product) => {
        const exchangeQty = Number(product.exchangeQuantity) || 0;
        return product.returned && exchangeQty > 0;
      });
    }

    // Shares are otherwise only refreshed when the overall discount is edited, so a qty/item
    // change made afterwards would save stale shares, which sales returns credit back from.
    // Never in exchange mode: there the shares come from the original invoice.
    if (!this.isExchangeOrder) {
      this.calculateGlobalDiscountShares();
    }

    let updateCart = [...payload.cart, ...filteredProducts];
    console.log(updateCart);
    payload['cart'] = updateCart as any;

    payload['cart'] = this.productsToCartItems(
      updateCart,
      this.isExchangeOrder,
    );
    payload['upiDetails'] = this.upiDetails;
    payload['cardDetails'] = this.cardDetails;

    // Include cash details in payload
    const cashDetails: any = { cashAmount: this.cashAmount };
    if (this.refundCashAmount > 0) {
      cashDetails['refundCashAmount'] = this.refundCashAmount;
    }
    payload['cashDetails'] = cashDetails;
    console.log(payload, 'payload');
    if (this.isExchangeOrder) {
      this.pendingExchangePayload = { payload, needHold, tempId };

      // Auto-select Cash and set refund amount for exchange orders
      this.autoCheckCashForRefund();

      // Then check if we need to open payment dialog
      // Skip balance validation for exchange orders when "Add to Credit" is selected
      if (
        this.calculateBalance() !== 0 &&
        !needHold &&
        !this.isSelected('Add to Credit')
      ) {
        this.showTotalDialog = true;
        return; // Wait for user to click "Process Payment"
      }

      // If balance is 0, we still need to show payment dialog for confirmation
      // This shouldn't normally happen in exchange mode, but handle it just in case
      this.showTotalDialog = true;
      return;
    } else {
      // For regular orders, validate redeem credit before proceeding
      if (!this.isRedeemCreditValid()) {
        // Determine which validation failed and show appropriate error
        if (this.isSelected('Redeem Credit') && this.redeemCreditAmount > 0) {
          if (this.redeemCreditAmount > this.availableCreditAmount) {
            this.messageService.add({
              severity: 'error',
              summary: 'Cannot Place Order',
              detail: `Redeem amount (₹${this.redeemCreditAmount}) exceeds available credit (₹${this.availableCreditAmount})`,
              life: 3000,
            });
          } else if (this.redeemCreditAmount > this.getRoundedTotal()) {
            this.messageService.add({
              severity: 'error',
              summary: 'Cannot Place Order',
              detail: `Redeem amount (₹${this.redeemCreditAmount}) cannot exceed order total (₹${this.getRoundedTotal()}) to avoid refund`,
              life: 3000,
            });
          }
        }
        return; // Stop order placement
      }

      // Add redeem credit details if applicable
      if (this.isSelected('Redeem Credit') && this.redeemCreditAmount > 0) {
        payload['redeemCreditDetails'] = {
          redeemCreditAmount: this.redeemCreditAmount,
        };

        // Add invoice number to payload when redeeming credit
        if (this.selectedInvoiceNo) {
          payload['invoiceno'] = this.selectedInvoiceNo;
        }
      }

      // REFACTORED: loyalty fields now live on LoyaltyService (reached via
      // the payment dialog's ViewChild) — see PaymentTotalDialogComponent.
      const loyaltySvc = this.paymentTotalDialogRef?.loyalty;
      if (
        loyaltySvc &&
        loyaltySvc.loyaltyPointsInput > 0 &&
        loyaltySvc.customerLoyaltyData
      ) {
        const orderTotal = this.getRoundedTotal();
        const minOrderValue =
          loyaltySvc.customerLoyaltyData.loyality_membership
            ?.min_redeem_order_value || 0;

        if (orderTotal < minOrderValue) {
          this.messageService.add({
            severity: 'error',
            summary: 'Cannot Place Order',
            detail: `Order value (₹${orderTotal}) is below minimum (₹${minOrderValue}) for loyalty redemption`,
            life: 3000,
          });
          loyaltySvc.loyaltyPointsInput = 0;
          loyaltySvc.loyaltyPaymentAmount = 0;
          this.calculateBalance();
          return;
        }
      }

      // Always include loyaltyDetails (backend expects this object)
      payload['loyaltyDetails'] = {
        loyaltyAmount: loyaltySvc?.loyaltyPaymentAmount || 0,
        loyaltyPoints: loyaltySvc?.loyaltyPointsInput || 0,
        customerId: loyaltySvc?.customerLoyaltyData?.id || 0,
      };

      this.placeOrder(payload, needHold, this.holdReceiptName);
    }
  }

  handleExchangeOrderConfirmation(
    payload: any,
    needHold: boolean,
    tempId: string,
  ) {
    // Check if Add to Credit is selected
    if (this.isSelected('Add to Credit')) {
      // Add to Credit is selected - the exchange total becomes the credit amount
      const creditAmount = this.getRoundedTotal(); // Exchange total
      payload['redeemCreditDetails'] = { redeemCreditAmount: creditAmount };
      if (payload['mobile'] == '' && this.mobileNumber) {
        payload['mobile'] = this.mobileNumber;
        payload['name'] = this.customerName || 'Walk in Customer';
      }
      //alert(payload['mobile'] + ',' + this.mobileNumber);
      // Send payment details with zero values since no cash/card/UPI transaction is involved
      payload['cashDetails'] = { cashAmount: 0, refundCashAmount: 0 };
      payload['cardDetails'] = {
        cardNumber: '',
        expiryDate: '',
        amount: 0,
        transactionId: '',
      };
      payload['upiDetails'] = { upiId: '', upiAmount: 0, transactionId: '' };

      // For "Add to Credit", we don't need balance to be 0
      // The whole exchange amount is added as credit
      this.exchangeOrder(payload, needHold, tempId, true); // true = generate credit PDF
    } else {
      // Add to Credit is NOT selected - proceed with refund
      if (this.calculateBalance() === 0) {
        this.exchangeOrder(payload, needHold, tempId, false); // false = no credit PDF
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Balance Error',
          detail: 'Balance must be 0 to proceed with exchange order',
          life: 3000,
        });
      }
    }
  }

  placeOrder(payload: any, needHold: boolean, tempId: string) {
    // ── Double-submission guard ───────────────────────────────────────────────
    // BillingGuardService prevents multiple concurrent placeOrder executions.
    // If lockOrder() returns false, a billing request is already in flight.
    if (!this.billingGuardService.lockOrder()) {
      return;
    }
    // ─────────────────────────────────────────────────────────────────────────
    payload.holdorderuuid = this.holdOrderId;
    console.log(payload);
    // Capture the allItemsNonGST flag BEFORE clearing products array
    const allItemsNonGST = this.isSuspenseMode
      ? this.hasOnlyNonGSTProducts()
      : false;

    // Capture isSuspenseMode state BEFORE any cleanup
    const wasSuspenseMode = this.isSuspenseMode;

    this.productService
      .placeOrder(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: OrderHttpResponse) => {
          // Release billing lock on success
          this.billingGuardService.unlockOrder();
          if (response.code === '200') {
            this.syncInvoicePaymentReferencesFromOrder(response.data);
            this.currentOrderId = response.data?.uuid;

            // For suspense mode, NEVER clear order data before printReceipt
            // The cleanup will happen inside processSuspenseOrder after PDF generation
            const shouldDelayCleanup = wasSuspenseMode;

            if (!shouldDelayCleanup) {
              this.clearOrderData();
            }

            this.messageService.add({
              severity: 'success',
              summary: 'Order Saved',
              detail: 'Items Saved in order',
              life: 3000,
            });
            if (!needHold) this.printReceipt(true, undefined, allItemsNonGST);
            if (needHold) {
              this.holdOrder(this.currentOrderId, tempId);
            }
          } else {
            this.currentOrderId = '';
            this.holdOrderId = '';
          }
        },
        error: (error) => {
          // Release billing lock on error — always, so button re-enables
          this.billingGuardService.unlockOrder();
          console.error('Place order failed:', error);
          this.currentOrderId = '';
          this.holdOrderId = '';

          let errorMessage = 'Failed to place order';

          if (error.status === 503 && error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.status === 0) {
            errorMessage = 'Network error: Unable to connect to server';
          } else if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.statusText) {
            errorMessage = error.statusText;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Cannot Place Order',
            detail: errorMessage,
            life: 5000,
          });
        },
      });
  }

  private syncInvoicePaymentReferencesFromOrder(orderData: any): void {
    if (!this.shouldUseOrderPaymentReferences()) {
      return;
    }

    this.paymentId = orderData?.paymentId ? String(orderData.paymentId) : null;
    this.transactionId = orderData?.transactionId
      ? String(orderData.transactionId)
      : null;
  }

  private shouldUseOrderPaymentReferences(): boolean {
    // const isPgIntegrationEnabled = this.isPgIntegrationEnabled();
    const isSupportedPaymentMode = ['Cash', 'Card', 'Split', 'UPI'].includes(
      this.activePaymentTab,
    );

    return isSupportedPaymentMode;
  }

  private isPgIntegrationEnabled(): boolean {
    try {
      const userInfo = JSON.parse(localStorage.getItem('name') || '{}');
      return Number(userInfo?.pgintegration) === 1;
    } catch {
      return false;
    }
  }

  private clearOrderData() {
    this.products = [];
    this.mobileStockReservationService.clear();
    timer(200)
      .pipe(delay(800), takeUntil(this.destroy$))
      .subscribe(this.openScanner);
    this.productsTemp = [];
    this.holdReceiptName = '';
    this.displayHoldNameDialog = false;
    this.toggleQR();
    this.resetCardDetails();
    this.resetCashDetails();
    this.resetUpiDetails();
    this.resetRedeemCreditDetails();
    this.paymentTotalDialogRef?.loyalty?.resetLoyaltyData();
    this.resetPartPaymentStates();
    this.resetOverAllDiscount();
    this.customerName = '';
    this.mobileNumber = '';

    this.resetAllModes();

    this.formDataService.resetShippingDetails();

    this.formDataService.updateFormData({
      currentDate: new Date(),
      empCode: this.formData?.empCode || '',
      storeCode: this.formData?.storeCode || '',
      customerName: '',
      mobileNumber: '',
      salesRep: '',
    });
  }

  private resetAllModes() {
    this.isWholesaleMode = false;
    this.isQuotationMode = false;
    this.isSuspenseMode = false;
    this.isOfferGroupMode = false;
    this.selectedOfferGroupId = null;
    this.lastSelectedOfferGroupId = null;
    this.isExchangeOrder = false;
    this.isDeleteMode = false;
    this.isDateEditMode = false;

    this.updateFormDataWithQuotationMode();
  }

  exchangeOrder(
    payload: any,
    needHold: boolean,
    tempId: string,
    generateCreditPdf: boolean = false,
  ) {
    console.log(payload, generateCreditPdf);
    // Capture exchanged items BEFORE resetting products array
    // Copies, not references: resetOverAllDiscount() below zeroes globalDiscountShare
    // on the cart products, and the credit note needs it after the save.
    const exchangedItems = generateCreditPdf
      ? this.products
        .filter((product) => {
          const exchangeQty = Number(product.exchangeQuantity) || 0;
          return exchangeQty > 0;
        })
        .map((product) => ({ ...product }))
      : [];
    console.log(exchangedItems, 'exchangedItems');

    // Add invoice number to payload for exchange orders
    if (this.isExchangeOrder && this.selectedInvoiceNo) {
      payload.invoiceno = this.selectedInvoiceNo;
    }
    this.productService
      .exchangeOrder(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: OrderHttpResponse) => {
          if (response.code === '200') {
            // Return invoice created — refresh the Bill No counter (replaces bill-number WebSocket)
            this.billNumberRefreshService.requestRefresh();
            this.isExchangeOrder = false; // Re-enable product search
            this.updateFormDataWithQuotationMode();
            this.refundCashAmount = 0; //Reset the refundCashAmount value as 0
            this.currentOrderId = response.data?.uuid;
            this.products = [];
            this.productsTemp = [];
            this.holdReceiptName = '';
            this.displayHoldNameDialog = false;
            //    this.toggleQR(); disable scanner on exchange
            this.resetCardDetails();
            this.resetCashDetails();
            this.resetUpiDetails();
            this.resetRedeemCreditDetails();
            this.resetPartPaymentStates();
            this.resetOverAllDiscount();
            this.splitPaymentAmounts = { cash: 0, card: 0, upi: 0 };
            this.selectedPaymentOptions = ['Cash']; // Reset to default payment option
            this.customerName = '';
            this.mobileNumber = '';
            this.formDataService.updateFormData({
              currentDate: new Date(), // Reset to today's date after exchange order
              empCode: this.formData?.empCode || '',
              storeCode: this.formData?.storeCode || '',
              customerName: '',
              mobileNumber: '',
              salesRep: '',
              isExchangeOrder: false,
            });
            this.messageService.add({
              severity: 'success',
              summary: 'Exchange Order Saved',
              detail: 'Items exchanged order placed successfully',
              life: 4000,
            });

            // Generate Credit Note PDF only if requested
            if (generateCreditPdf && exchangedItems.length > 0) {
              // generateCreditPdf is async — without a catch, any throw inside
              // it (bad item field, missing invoice data) fails silently.
              this.generateCreditPdf(exchangedItems, payload).catch((err) => {
                console.error('Credit note PDF generation failed:', err);
                this.messageService.add({
                  severity: 'error',
                  summary: 'Credit Note',
                  detail: 'Credit was added, but the credit note could not be generated.',
                  life: 5000,
                });
              });
            } else if (generateCreditPdf) {
              console.warn('Credit note skipped: no exchanged items captured');
            }

            this.selectedInvoiceNo = ''; // Clear the selected invoice number after PDF generation

            //  if (!needHold) this.printReceipt(false)
            if (needHold) {
              this.holdOrder(this.currentOrderId, tempId);
            }
          } else {
            this.currentOrderId = '';
            this.holdOrderId = '';
          }
        },
        (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.message || '',
            life: 3000,
          });
        },
      );
  }

  holdOrder(order_uuid: string, tempId: string) {
    this.productService
      .holdOrder(order_uuid, tempId)
      .subscribe((response: HoldHttpResponse) => {
        if (response.code === '200') {
          this.products = [];
          this.productsTemp = [];
          if (this.showItemDetail) {
            this.showItemDetail = false;
            this.displayNoItem = true;
          }
          // Close the hold receipt dialog
          this.displayHoldNameDialog = false;
          this.holdReceiptName = '';

          this.messageService.add({
            severity: 'success',
            summary: 'Order on Hold',
            detail: response.message,
            life: 3000,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Try Again',
            detail: response.message,
            life: 3000,
          });
        }
      });
  }

  getSpecificTransaction(tempId: string, isResumeReceipt: boolean) {
    this.products = [];
    this.productService
      .tapSpecificHoldOrder(tempId)
      .subscribe((transaction: TransactionHttpResponse) => {
        if (transaction.code === '200') {
          this.holdOrderId = tempId;

          if (transaction.data.user_id) {
            this.mobileNumber = String(transaction.data.user_id);
          }
          if (transaction.data.name) {
            this.customerName = transaction.data.name;
          }

          // Restore quotation mode from order level
          if (transaction.data.isQuotationMode !== undefined) {
            this.isQuotationMode =
              transaction.data.isQuotationMode === 1 ||
              transaction.data.isQuotationMode === true;
          }

          this.products = transaction.data.customerorderitems;

          // Restore modes based on groupId from first cart item
          if (this.products && this.products.length > 0) {
            const firstItem: any = this.products[0];
            const groupId =
              firstItem.groupid !== undefined
                ? firstItem.groupid
                : firstItem.groupId;

            if (groupId !== undefined && groupId !== null) {
              if (groupId === -2) {
                this.isSuspenseMode = true;
                this.isWholesaleMode = false;
                this.isOfferGroupMode = false;
                this.selectedOfferGroupId = null;
              } else if (groupId === -1) {
                this.isWholesaleMode = true;
                this.isSuspenseMode = false;
                this.isOfferGroupMode = false;
                this.selectedOfferGroupId = null;
              } else if (groupId > 0) {
                this.isOfferGroupMode = true;
                this.selectedOfferGroupId = groupId;
                this.isSuspenseMode = false;
                this.isWholesaleMode = false;
              } else {
                this.isWholesaleMode = false;
                this.isSuspenseMode = false;
                this.isOfferGroupMode = false;
                this.selectedOfferGroupId = null;
              }

              console.log(' Restored mode from cart item groupId:', groupId);
            }
          }

          this.formDataService.updateFormData({
            ...this.formData,
            mobileNumber: this.mobileNumber || '',
            customerName: this.customerName || '',
            empCode: this.formData?.empCode || '',
            storeCode: this.formData?.storeCode || '',
            currentDate: this.formData?.currentDate || new Date(),
            salesRep: this.formData?.salesRep || '',
            isWholesaleMode: this.isWholesaleMode,
            isQuotationMode: this.isQuotationMode,
            isSuspenseMode: this.isSuspenseMode,
            isOfferGroupMode: this.isOfferGroupMode,
            isExchangeOrder: false,
            isDeleteMode: false,
          });

          this.products && this.formAllProducts(this.products, isResumeReceipt);

          // Saved sale unit price + saved discount for each held line
          if (isResumeReceipt) {
            this.restoreSavedLinePrices(true);
          }

          // Apply mode-specific logic after products are loaded
          this.applyRestoredModes();

          // this.hideSavedReceiptsDialog();
          this.savedReceiptsDialog = false;
        }
      });
  }

  private applyRestoredModes(): void {
    if (this.isQuotationMode) {
      if (!this.quotationValidityDate) {
        this.quotationValidityDate = new Date(
          Date.now() + 7 * 24 * 60 * 60 * 1000,
        );
      }
    }

    if (this.isSuspenseMode) {
      this.products.forEach((product) => {
        if (product.isgst === undefined || product.isgst === null) {
          product.isgst = 1;
        }
        // isgst = 0 (Non-GST) â†’ selected = true (for suspense account)
        // isgst = 1 (GST) â†’ selected = false (not for suspense)
        product.selected = product.isgst === 0;
      });
      this.productsTemp = this.products.map((product) => ({ ...product }));
    }

    if (this.isWholesaleMode) {
      // Only recalculate if user can edit discounts
      if (this.isSalesDiscountEditEnabled) {
        this.DiscountchangeCalc();
      }
    }

    if (this.isOfferGroupMode && this.selectedOfferGroupId) {
      // Fetch offer prices for existing cart items
      this.updateExistingItemsWithOfferPrices(this.selectedOfferGroupId);
    }
  }
  onHoldReceiptSubmit(event: HoldReceiptSubmitEvent): void {
    this.holdReceiptName = event.holdReceiptName;
    if (event.mobileNumber) {
      this.mobileNumber = event.mobileNumber;
    }
    this.saveReceipt(true);
  }

  /**
   * Called from F6 keyboard handler to open the Resume Receipt dialog.
   * Loads held receipts via ResumeReceiptService, then shows the dialog.
   */
  onOpenResumeDialog(): void {
    this.resumeReceiptService
      .getHoldReceipts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((receipts) => {
        this.savedReceipts = receipts;
      });

    this.selectedReceipt = null;
    this.savedReceiptsDialog = true;
  }

  /**
   * Called when ResumeReceiptDialogComponent emits (resumed) with a UUID.
   * Delegates to the existing getSpecificTransaction()  zero logic change.
   */
  onReceiptResumed(uuid: string): void {
    this.getSpecificTransaction(uuid, true);
  }

  //  End of Hold Receipt / Resume Receipt handlers
  cancelReceipt() {
    console.log('Cancelling receipt...');
  }

  onSplitApplied(event: {
    splitMethod: string;
    numberOfPeople: number;
    selectedProducts: any[];
  }): void {
    this.splitMethod = event.splitMethod;
    this.numberOfPeople = event.numberOfPeople;
    if (event.splitMethod === 'item') {
      this.splitByItem();
    } else if (event.splitMethod === 'evenly') {
      this.splitEvenly();
    }
    this.splitBillDialog = false;
  }

  splitByItem() {
    const selectedProducts = this.products.filter(
      (product) => product?.selected,
    );
    // Implement your logic to handle selected products
  }

  splitEvenly() {
    const totalAmount = this.getRoundedTotal();
    const splitAmount = totalAmount / this.numberOfPeople;

    console.log(
      `Split evenly among ${this.numberOfPeople} people: ${splitAmount}`,
    );
    // Implement your logic to handle even split
  }

  showTransactions() {
    this.displayTransactions = true;
    this.showCalculator = false;
    this.showItemDetail = false;
    this.displayNoItem = false;
    this.showBillDetail = false;
    this.activeItem = this.items && this.items[2];
    this.activeHistoryTab = 0; // Default to Transaction History tab
    this.getAllTransaction(false);
    this.getAllQuotation(); // Load quotation data as well
    this.showTransactionDialog = true;
  }

  onTransactionSelect(transactionUuid: string) {
    this.transactionHistoryService.onTransactionSelect(
      transactionUuid,
      this.buildTransactionHistoryDeps(),
    );
  }
  // Handle quotation selection for viewing
  onQuotationSelect(quotationUuid: string) {
    this.transactionHistoryService.onQuotationSelect(
      quotationUuid,
      this.buildTransactionHistoryDeps(),
    );
  }
  // Handle tab change in history dialog
  onHistoryTabChange(event: any) {
    this.transactionHistoryService.onHistoryTabChange(
      event,
      this.buildTransactionHistoryDeps(),
    );
  }

  // Refresh data based on active tab
  refreshHistoryData() {
    this.transactionHistoryService.refreshHistoryData(
      this.buildTransactionHistoryDeps(),
    );
  }
  // View selected quotation - Load quotation details and populate table
  viewQuotation() {
    this.transactionHistoryService.viewQuotation(
      this.buildTransactionHistoryDeps(),
    );
  }
  getQuotationDetails(quotationUuid: string) {
    this.transactionHistoryService.getQuotationDetails(
      quotationUuid,
      this.buildTransactionHistoryDeps(),
    );
  }

  // Active Orchestrator Handler for Sales History Dialog
  onTransactionSelectByIndex(index: number, event?: Event) {
    this.transactionHistoryService.onTransactionSelectByIndex(
      index,
      event,
      this.buildTransactionHistoryDeps(),
    );
  }

  downloadInvoicePdf(pdfUrl: string, invoiceNo: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    if (!pdfUrl) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No PDF Available',
        detail: 'Invoice PDF is not available for download',
        life: 3000,
      });
      return;
    }

    try {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `invoice_${invoiceNo}.pdf`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.messageService.add({
        severity: 'success',
        summary: 'Download Started',
        detail: `Downloading invoice ${invoiceNo}`,
        life: 2000,
      });
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Download Failed',
        detail: 'Failed to download the invoice PDF',
        life: 3000,
      });
    }
  }

  onRowSelect(event: any) {
    let data = event.data;
    this.selectedTransaction = data.customerorderitems || [];
    this.currentOrderId = data.uuid;
  }
  public onQRScan(itemScanned: ScannerQRCodeResult[], action?: any): void {
    this.barcodeScannerService.onQRScan(
      itemScanned,
      action,
      this.buildBarcodeScannerDeps(),
    );
  }

  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find((f) =>
        /back|rear|environment/gi.test(f.label),
      ); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    };

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe(
        (r: any) => console.log(fn, r),
        alert,
      );
    } else {
      action[fn]().subscribe((r: any) => console.log(fn, r), alert);
    }
  }

  setActivePaymentTab(
    tab: 'Cash' | 'Card' | 'UPI' | 'Redeem Points' | 'Split',
  ) {
    this.activePaymentTab = tab;
    this.resetPartPaymentStates();
    if (tab !== 'UPI') {
      this.clearUpiQrState();
    }
    this.setPaymentTabLogic(tab);
  }

  resetPartPaymentStates() {
    this.paymentTotalDialogRef?.session?.resetPartPaymentStates();
  }

  isAnyPartPaymentEnabled(): boolean {
    return (
      this.isPartPaymentCash || this.isPartPaymentCard || this.isPartPaymentUPI
    );
  }

  getCurrentPartPaymentAmount(): number {
    return this.paymentCalculationService.getCurrentPartPaymentAmount(
      this.isPartPaymentCash,
      this.isPartPaymentCard,
      this.isPartPaymentUPI,
      this.activePaymentTab,
      this.cashAmount,
      this.cardDetails.amount,
      this.upiDetails.upiAmount,
    );
  }

  getRemainingCreditAmount(): number {
    return this.paymentCalculationService.getRemainingCreditAmount(
      this.isAnyPartPaymentEnabled(),
      this.getRoundedTotal(),
      this.getCurrentPartPaymentAmount(),
    );
  }

  // Handle part payment toggle changes
  onPartPaymentToggle(paymentType: 'Cash' | 'Card' | 'UPI', enabled: boolean) {
    if (enabled) {
      switch (paymentType) {
        case 'Cash':
          this.isPartPaymentCash = true;
          this.isPartPaymentCard = false;
          this.isPartPaymentUPI = false;
          break;
        case 'Card':
          this.isPartPaymentCash = false;
          this.isPartPaymentCard = true;
          this.isPartPaymentUPI = false;
          break;
        case 'UPI':
          this.isPartPaymentCash = false;
          this.isPartPaymentCard = false;
          this.isPartPaymentUPI = true;
          break;
      }

      if (
        this.activePaymentTab === 'Split' ||
        this.activePaymentTab === 'Redeem Points'
      ) {
        this.setActivePaymentTab(paymentType);
      }
    } else {
      switch (paymentType) {
        case 'Cash':
          this.isPartPaymentCash = false;
          break;
        case 'Card':
          this.isPartPaymentCard = false;
          break;
        case 'UPI':
          this.isPartPaymentUPI = false;
          break;
      }
    }
  }

  // Part Payment validation
  validatePartPaymentAmount(paymentType: 'Cash' | 'Card' | 'UPI') {
    const totalAmount = this.getRoundedTotal();
    let currentAmount = 0;
    let isPartPaymentEnabled = false;

    switch (paymentType) {
      case 'Cash':
        currentAmount = this.cashAmount || 0;
        isPartPaymentEnabled = this.isPartPaymentCash;
        break;
      case 'Card':
        currentAmount = this.cardDetails.amount || 0;
        isPartPaymentEnabled = this.isPartPaymentCard;
        break;
      case 'UPI':
        currentAmount = this.upiDetails.upiAmount || 0;
        isPartPaymentEnabled = this.isPartPaymentUPI;
        break;
    }

    // If part payment is enabled, validate amount
    if (
      this.paymentValidationService.shouldDisablePartPayment(
        currentAmount,
        totalAmount,
        isPartPaymentEnabled,
      )
    ) {
      switch (paymentType) {
        case 'Cash':
          this.isPartPaymentCash = false;
          break;
        case 'Card':
          this.isPartPaymentCard = false;
          break;
        case 'UPI':
          this.isPartPaymentUPI = false;
          break;
      }
      this.messageService.add(
        this.paymentValidationService.partPaymentDisabledMessage(),
      );
    }
  }

  // Continue with existing setActivePaymentTab logic
  private setPaymentTabLogic(
    tab: 'Cash' | 'Card' | 'UPI' | 'Redeem Points' | 'Split',
  ) {
    if (tab === 'Split') {
      this.selectedPaymentOptions = ['Cash', 'Card', 'UPI'];
      this.splitPaymentAmounts.cash = this.cashAmount || 0;
      this.splitPaymentAmounts.card = this.cardDetails.amount || 0;
      this.splitPaymentAmounts.upi = this.upiDetails.upiAmount || 0;
    } else {
      if (this.isExchangeOrder) {
        if (tab === 'Cash') {
          this.selectedPaymentOptions = ['Cash'];
          this.cardDetails.amount = 0;
          this.upiDetails.upiAmount = 0;
          this.redeemCreditAmount = 0;
        } else if (tab === 'Redeem Points') {
          this.selectedPaymentOptions = ['Add to Credit'];
          this.cashAmount = 0;
          this.cardDetails.amount = 0;
          this.upiDetails.upiAmount = 0;
        } else {
          this.selectedPaymentOptions = [tab];
          if (tab === 'Card') {
            this.cashAmount = 0;
            this.upiDetails.upiAmount = 0;
            this.redeemCreditAmount = 0;
          } else if (tab === 'UPI') {
            this.cashAmount = 0;
            this.cardDetails.amount = 0;
            this.redeemCreditAmount = 0;
          }
        }
      } else {
        this.selectedPaymentOptions = [tab];

        if (tab === 'Cash') {
          this.cardDetails.amount = 0;
          this.upiDetails.upiAmount = 0;
          this.redeemCreditAmount = 0;
        } else if (tab === 'Card') {
          this.cashAmount = 0;
          this.upiDetails.upiAmount = 0;
          this.redeemCreditAmount = 0;
        } else if (tab === 'UPI') {
          this.cashAmount = 0;
          this.cardDetails.amount = 0;
          this.redeemCreditAmount = 0;
        } else if (tab === 'Redeem Points') {
          this.cashAmount = 0;
          this.cardDetails.amount = 0;
          this.upiDetails.upiAmount = 0;
        }
      }

      this.splitPaymentAmounts.cash = 0;
      this.splitPaymentAmounts.card = 0;
      this.splitPaymentAmounts.upi = 0;
    }

    this.onPaymentOptionChange();
  }

  // Sync payment values between individual and split modes
  syncPaymentValues() {
    this.paymentTotalDialogRef?.session?.syncPaymentValues();
  }

  onSplitAmountChange() {
    this.paymentTotalDialogRef?.session?.onSplitAmountChange();
    this.calculateBalance();
  }

  // Payment summary methods for new design
  getPaidAmount(): number {
    return this.paymentCalculationService.getPaidAmount(
      this.activePaymentTab,
      this.cashAmount,
      this.cardDetails.amount,
      this.upiDetails.upiAmount,
      this.redeemCreditAmount,
      this.splitPaymentAmounts,
    );
  }

  getTipAmount(): number {
    return this.paymentCalculationService.getTipAmount();
  }

  getBalanceAmount(): number {
    return this.paymentCalculationService.getBalanceAmount(
      this.calculateBalance(),
    );
  }

  getBalanceLabel(): string {
    return this.paymentCalculationService.getBalanceLabel(
      this.calculateBalance(),
    );
  }

  // Payment validation method
  isPaymentValid(): boolean {
    if (!this.mobileNumber || this.mobileNumber.length !== 10) {
      return false;
    }

    const paidAmount = this.getPaidAmount();
    if (paidAmount <= 0) {
      return false;
    }

    if (this.activePaymentTab === 'Card') {
      return !!(this.cardDetails.amount && this.cardDetails.amount > 0);
    } else if (this.activePaymentTab === 'UPI') {
      return !!(
        this.upiDetails.upiAmount &&
        this.upiDetails.upiAmount > 0 &&
        this.upiDetails.upiId
      );
    } else if (this.activePaymentTab === 'Cash') {
      return !!(this.cashAmount && this.cashAmount > 0);
    } else if (this.activePaymentTab === 'Redeem Points') {
      return !!(
        this.redeemCreditAmount &&
        this.redeemCreditAmount > 0 &&
        this.mobileNumber &&
        this.mobileNumber.length === 10
      );
    } else if (this.activePaymentTab === 'Split') {
      return (
        this.splitPaymentAmounts.cash +
          this.splitPaymentAmounts.card +
          this.splitPaymentAmounts.upi >
        0
      );
    }

    return true;
  }

  printInvoice() {
    this.processPayment();
  }

  onPaymentOptionChange() {
    this.hasScannerClicked = false;

    // For exchange orders, handle mutual exclusion between Cash and Add to Credit
    if (this.isExchangeOrder) {
      if (this.isSelected('Add to Credit')) {
        if (Array.isArray(this.selectedPaymentOptions)) {
          this.selectedPaymentOptions = this.selectedPaymentOptions.filter(
            (option) =>
              option !== 'Cash' && option !== 'UPI' && option !== 'Card',
          );
        }
      } else if (this.isSelected('Cash')) {
        if (Array.isArray(this.selectedPaymentOptions)) {
          this.selectedPaymentOptions = this.selectedPaymentOptions.filter(
            (option) => option !== 'Add to Credit',
          );
        }
      }
    } else {
      if (
        !this.isSelected('Cash') &&
        !this.isSelected('Card') &&
        !this.isSelected('UPI') &&
        !this.isSelected('Redeem Credit')
      ) {
        if (Array.isArray(this.selectedPaymentOptions)) {
          this.selectedPaymentOptions.push('Cash');
        } else {
          this.selectedPaymentOptions = ['Cash'];
        }
      }
    }

    if (this.isSelected('Redeem Credit') || this.isSelected('Add to Credit')) {
      if (!this.isExchangeOrder && this.isSelected('Redeem Credit')) {
        this.fetchCreditAmount();
      }
    } else {
      if (this.hasShownCreditNumberMessage) {
        this.hasShownCreditNumberMessage = false;
        this.messageService.clear();
      }
    }

    if (!this.isSelected('Card')) {
      this.resetCardDetails();
    }
    if (!this.isSelected('UPI')) {
      this.resetUpiDetails();
    }

    this.autoCheckCashForRefund();
  }

  autoCheckCashForRefund() {
    if (this.isExchangeOrder && this.isSelected('Add to Credit')) {
      return; // Skip cash auto-selection for Add to Credit
    }

    // Only auto-select Cash if no payment method is selected
    if (
      !this.selectedPaymentOptions ||
      (Array.isArray(this.selectedPaymentOptions) &&
        this.selectedPaymentOptions.length === 0)
    ) {
      this.selectedPaymentOptions = ['Cash'];
    }

    const balance = this.calculateBalance();
    if (!this.isExchangeOrder) {
      if (balance < 0) {
        this.refundCashAmount = Math.abs(balance);
      } else {
        this.refundCashAmount = 0;
      }
    } else {
      this.refundCashAmount = this.getRoundedTotal();
    }
  }

  /**
   * Called when the user clicks the "Redeem" button inside Cash or Card tab
   * (payment-total-dialog emits redeemToggled with true/false).
   *
   * This is the critical wiring that makes calculateBalance() and the payload
   * builder include the redeem amount:
   *   - ON  → push 'Redeem Credit' into selectedPaymentOptions
   *   - OFF → remove it and reset redeemCreditAmount / availableCreditAmount
   */
  onRedeemToggled(enabled: boolean): void {
    if (enabled) {
      // Add 'Redeem Credit' to selectedPaymentOptions so isSelected() returns true
      if (Array.isArray(this.selectedPaymentOptions)) {
        if (!this.selectedPaymentOptions.includes('Redeem Credit')) {
          this.selectedPaymentOptions = [
            ...this.selectedPaymentOptions,
            'Redeem Credit',
          ];
        }
      } else {
        // selectedPaymentOptions is a string (or null) — convert to array
        const existing = this.selectedPaymentOptions as string | null;
        this.selectedPaymentOptions = existing
          ? [existing, 'Redeem Credit']
          : ['Redeem Credit'];
      }
    } else {
      // Remove 'Redeem Credit' from selectedPaymentOptions and reset state
      if (Array.isArray(this.selectedPaymentOptions)) {
        this.selectedPaymentOptions = this.selectedPaymentOptions.filter(
          (o) => o !== 'Redeem Credit' && o !== 'Redeem Points',
        );
      }
      this.redeemCreditAmount = 0;
      this.availableCreditAmount = 0;
      // Also reset the auto-filled cash/card/upi amount when redeem is turned off
      if (this.activePaymentTab === 'Cash') {
        this.cashAmount = 0;
      } else if (this.activePaymentTab === 'Card') {
        this.cardDetails = { ...this.cardDetails, amount: null };
      } else if (this.activePaymentTab === 'UPI') {
        this.upiDetails = { ...this.upiDetails, upiAmount: 0 };
      }
      this.calculateBalance();
    }
    this.onPaymentOptionChange();
  }

  onInvoiceNumberChange() {
    // Reset the message flag when user starts entering invoice number
    this.hasShownCreditNumberMessage = false;
    if(!this.formData?.mobileNumber){
      this.messageService.add({
        severity: 'error',
        summary: 'Missing Information',
        detail: 'Please enter a mobile number before entering an redeem code.',
        closable: true,
        life: 3000,
      });
    }
    if (this.selectedInvoiceNo && this.formData?.mobileNumber) {
      this.fetchCreditAmount();
    }
  }

  fetchCreditAmount() {
    if (!this.formData?.mobileNumber || !this.selectedInvoiceNo) {
      if (!this.hasShownCreditNumberMessage) {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Missing Information',
        //   detail: 'Enter the code to redeem',
        //   closable: true,
        //   life: 999999,
        // });
        // this.hasShownCreditNumberMessage = true;
      }
      return;
    }

    this.isLoadingCreditAmount = true;
    this.productService
      .getCreditAmount(this.formData.mobileNumber, this.selectedInvoiceNo)
      .subscribe({
        next: (response) => {
          this.isLoadingCreditAmount = false;
          if (response.code === '200') {
            this.availableCreditAmount = response.data.creditAmount;
            this.hasShownCreditNumberMessage = false;
            this.messageService.clear();

            // Auto-bind redeem amount: use min(availableCreditAmount, orderTotal)
            // Scenario: credit=4500, total=29  → bind 29 (cap at order total)
            // Scenario: credit=4500, total=4500 → bind 4500
            // Scenario: credit=4500, total=10000 → bind 4500 (cap at credit)
            this.redeemCreditAmount = Math.min(
              this.availableCreditAmount,
              this.getRoundedTotal(),
            );

            // Trigger auto-fill of cash/card with the remaining balance
            this.validateRedeemCreditAmount();

            this.messageService.add({
              severity: 'success',
              summary: 'Credit Amount Fetched',
              detail: `Available credit: ₹${this.availableCreditAmount}`,
              life: 3000,
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Redeem code not valid',
              life: 3000,
            });
          }
        },
        error: (error) => {
          this.isLoadingCreditAmount = false;
          console.error('Error fetching credit amount:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch credit amount',
            life: 3000,
          });
        },
      });
  }

  processPayment() {
    // ── Network order-blocked guard ─────────────────────────────────────────
    // Blocks when network is OFFLINE, SLOW (3G), or CRITICAL.
    if (this.isOrderBlocked) {
      this.showOrderBlockedMessage();
      return;
    }
    // ───────────────────────────────────────────────────────────────────
    // Validate customer information first (mobile number is mandatory)
    if (!this.isExchangeOrder && !this.validateCustomerInfo()) {
      return;
    }
    console.log(this.isAnyPartPaymentEnabled());
    // Mobile Industry: Validate variant selection
    if (!this.validateVariantSelection()) {
      return;
    }

    // Check balance for both regular and exchange orders
    // For part payment, allow positive balance (remaining will go to credit)
    if (
      !this.isExchangeOrder &&
      this.calculateBalance() > 0 &&
      !this.isAnyPartPaymentEnabled()
    ) {
      console.log(this.calculateBalance());
      this.messageService.add({
        severity: 'error',
        summary: 'Pay Balance',
        detail: 'Balance not tallying. Please complete payment.',
        life: 3000,
      });
      return;
    }

    // For exchange orders, balance must be exactly 0 (unless "Add to Credit" is selected)
    if (
      this.isExchangeOrder &&
      this.calculateBalance() !== 0 &&
      !this.isSelected('Add to Credit')
    ) {
      const balance = this.calculateBalance();
      if (balance > 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Exchange Balance Required',
          detail: `Please match the remaining balance of ₹${balance.toFixed(2)} to complete the exchange`,
          life: 3000,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Exchange Balance Required',
          detail: `Please collect ₹${Math.abs(balance).toFixed(2)} to complete the exchange`,
          life: 3000,
        });
      }
      return;
    }

    const paymentInfo: any = {};

    if (this.isSelected('Cash') && this.cashAmount !== null) {
      paymentInfo['cash'] = this.cashAmount;
    }
    if (this.isSelected('Card') && this.cardDetails.amount !== null) {
      paymentInfo['card'] = this.cardDetails;
    }
    if (
      this.isSelected('UPI') &&
      this.upiDetails.upiId &&
      this.upiDetails.upiAmount !== null
    ) {
      paymentInfo['upi'] = this.upiDetails;
    }

    // For exchange orders, show confirmation within the payment dialog
    //if (this.isExchangeOrder && !this.isSelected('Add to Credit')) {
    if (this.isExchangeOrder) {
      this.showExchangeConfirmation = true;
      return; // Keep the payment dialog open and show exchange confirmation
    }

    // For regular orders or exchange orders with "Add to Credit", proceed directly
    this.showTotalDialog = false;
    this.saveReceipt(false);
  }

  // Handle exchange confirmation within payment dialog
  confirmExchangeAsCredit() {
    this.showExchangeConfirmation = false;
    this.showTotalDialog = false;

    if (!this.pendingExchangePayload) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No pending exchange order found',
        life: 3000,
      });
      return;
    }

    // Set "Add to Credit" option and process
    if (!this.selectedPaymentOptions?.includes('Add to Credit')) {
      if (Array.isArray(this.selectedPaymentOptions)) {
        this.selectedPaymentOptions.push('Add to Credit');
      } else {
        this.selectedPaymentOptions = ['Add to Credit'];
      }
    }

    const { payload, needHold, tempId } = this.pendingExchangePayload;
    this.handleExchangeOrderConfirmation(payload, needHold, tempId);
    this.pendingExchangePayload = null; // Clear pending payload
  }

  confirmExchangeAsRefund() {
    this.showExchangeConfirmation = false;
    this.showTotalDialog = false;

    if (!this.pendingExchangePayload) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No pending exchange order found',
        life: 3000,
      });
      return;
    }

    if (Array.isArray(this.selectedPaymentOptions)) {
      this.selectedPaymentOptions = this.selectedPaymentOptions.filter(
        (option) => option !== 'Add to Credit',
      );
    }

    if (this.calculateBalance() === 0) {
      const { payload, needHold, tempId } = this.pendingExchangePayload;
      this.handleExchangeOrderConfirmation(payload, needHold, tempId);
      this.pendingExchangePayload = null; // Clear pending payload
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Balance Error',
        detail: 'Balance must be 0 to proceed with exchange order',
        life: 3000,
      });
      this.showTotalDialog = true; // Reopen payment dialog
    }
  }

  cancelExchangeConfirmation() {
    this.showExchangeConfirmation = false;
    // Don't clear pendingExchangePayload here - user might want to try again
  }

  // Build exchange payload when payment dialog is opened directly (via F7/F8)
  private buildExchangePayload() {
    const now = new Date();
    const tempId = formatDate(now, 'dd-MMM-yyyy-HH-mm-ss', 'en-US');

    const filteredProducts = this.products.filter((product) => {
      const exchangeQty = Number(product.exchangeQuantity) || 0;
      return product.returned && exchangeQty > 0;
    });

    let payload: any = {
      invoicedate: this.formatDate(new Date()),
      //mobile: this.formData?.mobileNumber,
      mobile: this.formData?.mobileNumber || this.mobileNumber || '',
      name:
        this.formData?.customerName && this.formData.customerName.trim() !== ''
          ? this.formData.customerName
          : 'Walk in Customer',
      salesrep: this.formData?.salesRep,
      discpercentage: 0,
      discount: 0,
      overAllDiscount: this.getOverAllDiscountAmount(),
      overAllDiscountPercent: this.overAllDiscountPercent,
      cart: this.productsToCartItems(filteredProducts, true),
      upiDetails: this.upiDetails,
      cardDetails: this.cardDetails,
      cashDetails: {
        cashAmount: this.cashAmount,
        refundCashAmount: this.refundCashAmount,
      },
      redeemCreditDetails: {},
      loyaltyDetails: {
        loyaltyAmount: 0,
        loyaltyPoints: 0,
        customerId: 0,
      },
      total: this.getRoundedTotal(),
      roundOffAmount: this.getRoundOffAmount(),
      isCredit: this.isAnyPartPaymentEnabled() ? 1 : 0,
      groupId: this.getGroupId(),
      isQuotationMode: this.isQuotationMode ? 1 : 0,
      paidamount: this.getPaidAmount(),
      balanceamount: this.calculateBalance(),
    };
    this.pendingExchangePayload = { payload, needHold: false, tempId };
  }

  // selectProduct(event: any) {
  //   const product = event.value || event;
  //   this.autoCompletedselectedProduct = product;
  //   this.actionSelected();
  //   // marginamount is now handled by getProfitAmount() which sums across all products.
  //   // No manual accumulation needed here.
  //   setTimeout(() => {
  //     this.itemId = '';
  //     if (product?.productmapvalues?.length) {
  //       this.selectedVariantProduct = product;
  //       this.variantOpenTick++;
  //     }
  //     if (this.enableCursorFocus) {
  //       this.focusQuantityInput();
  //     }
  //   }, 100);
  // }

  addProductToCart(productData: any) {
    if (!productData) return;

    let data = { ...productData };
    if (this.isQuotationMode) {
      // In quotation mode, always use barcodesellprice
      data.sellingprice = data.barcodesellprice || data.sellingprice;
    } else if (
      this.isOfferGroupMode &&
      data.groupingprice &&
      data.groupingprice > 0
    ) {
      // In offer group mode, use grouping price
      data.sellingprice = data.groupingprice;
    } else if (data.offerprice > 0) {
      // Otherwise, use offer price if available
      data.sellingprice = data.offerprice;
    }

    let newProduct: Product = {
      ...data,
      // Normalize psid: /productdetails API may return the identifier in `barcode` instead of `psid`.
      // Without this, findScannedProduct always misses the existing cart item and adds a duplicate
      // instead of incrementing quantity.
      psid: data.psid || data.barcode,
      batch: data.batch || '',
      purchaseorder_id: data.purchaseorder_id || 0,
      store_id: data.store_id || 0,
      mrp: data.mrp || 0,
      costprice: data.costprice || 0,
      wholesaleprice: data.wholesaleprice || 0,
      retailprice: data.retailprice || 0,
      sales_tax: data.sales_tax || 0,
      rack: data.rack || '',
    };
    this.productMappingService.normalizeProductColumns(newProduct);
    this.productMappingService.autoSelectSingleMapping(newProduct);
    console.log("Mapped newProduct for cart:", { isbulk: newProduct.isbulk, mappings: newProduct.unit_mappings, data: newProduct });

    // Scan responses may lack product_selling_price_incl; compute it so the cart column shows
    if (newProduct.product_selling_price_incl == null) {
      const taxRate = Number(newProduct.sales_tax || newProduct.tax || 0);
      const exclPrice = Number(newProduct.sellingprice || 0);
      newProduct.product_selling_price_incl = taxRate > 0
        ? Number((exclPrice * (1 + taxRate / 100)).toFixed(2))
        : Number(exclPrice.toFixed(2));
    }

    // Check if this product already exists in cart
    const existingProduct = this.findScannedProduct(
      newProduct.psid,
      newProduct.sellingprice,
      newProduct.batch,
    );

    if (existingProduct) {
      // Product already exists, just increase quantity
      this.updateQuantity(
        newProduct.psid,
        existingProduct,
        newProduct.sellingprice,
        newProduct.batch,
      );
    } else {
      let discountValue = 0;
      let discountValValue = 0;

      if (!this.isSalesDiscountEditEnabled) {
        // Setting disabled: Use API discount values as-is (backend already calculated)
        discountValue = newProduct.discount || 0;
        discountValValue = newProduct.discountval || 0;
      }

      let rawUnitId = newProduct.unit ?? newProduct.unit_mappings?.[0]?.unitid ?? null;
      let defaultUnitId = rawUnitId != null && !isNaN(Number(rawUnitId)) ? Number(rawUnitId) : rawUnitId;

      let addQtyToNewPdt: any = {
        ...newProduct,
        increaseQuantity: 1,
        discount: discountValue,
        discountval: discountValValue,
        unit_id: defaultUnitId,
        free_qty_available: Number(newProduct.free_qty) || 0,
        cart_free_qty: 0,
      };

      if (this.isSuspenseMode) {
        addQtyToNewPdt.isgst = 1;
        addQtyToNewPdt.selected = false;
      }

      this.itemId = '';
      this.products = [addQtyToNewPdt, ...this.products];
      this.productsTemp = this.products.map((product) => ({
        ...product,
      }));

      // Mobile Industry: Handle parameter/variant workflow
      if (this.industryService.isMobile()) {
        if (
          this.hasParametersAndVariants(addQtyToNewPdt) ||
          this.hasOnlyVariants(addQtyToNewPdt)
        ) {
          addQtyToNewPdt.variantAccordionExpanded = true;
          this.selectedVariantProduct = this.products[0];
          this.variantOpenTick++;
        }
      }
    }
  }

  selectProduct(event: any) {
    const product = event.value || event;

    // Retail-only: fetch authoritative full detail by barcode row id before adding to cart.
    // Mobile keeps its existing behavior unchanged (mobile order router lacks this route,
    // and its add-to-cart flow already re-fetches via findItemUsingPSID/scanitem).
    const canFetchDetail = !!product?.id;
    //  !this.industryService.isMobile() &&
    if (canFetchDetail) {
      const groupId = this.isOfferGroupMode
        ? this.selectedOfferGroupId
        : undefined;
      this.productService
        .getProductDetails(product.id, groupId || undefined)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response: ProductSearchHttpResponse) => {
            const productDetail = response?.data || product;
            this.autoCompletedselectedProduct = productDetail;
            if (this.isDeleteMode) {
              this.removeItemByPSID(
                productDetail.psid || productDetail.barcode,
              );
            } else {
              this.addProductToCart(productDetail);
            }
            this.finishProductSelection(productDetail);
          },
          error: () => {
            this.autoCompletedselectedProduct = product;
            if (this.isDeleteMode) {
              this.removeItemByPSID(product.psid || product.barcode);
            } else {
              this.addProductToCart(product);
            }
            this.finishProductSelection(product);
          },
        });
    } else {
      this.autoCompletedselectedProduct = product;
      this.actionSelected();
      this.finishProductSelection(product);
    }
  }

  private finishProductSelection(product: any) {
    this.itemId = '';
    this.selectedProductId = product?.productId || '';
    this.currentPSID = product?.psid || product?.barcode || '';
    this.onSelectProduct(this.selectedProductId, this.currentPSID, false);
    this.autoCompletedselectedProduct = null as any;

    setTimeout(() => {
      this.itemId = '';
      // Variant popup is opened by addProductToCart/updateQuantity on the
      // actual cart row - re-signalling here would open it a second time.
      if (this.enableCursorFocus) {
        this.focusQuantityInput();
      }
    }, 100);
  }

  selectProductAndAdd(product: Product) {
    this.autoCompletedselectedProduct = product;
    this.actionSelected(); // This adds the product to cart

    setTimeout(() => {
      this.itemId = '';
    }, 100);
  }

  // Global keyboard shortcuts
  onGlobalKeyDown(event: KeyboardEvent) {
    this.keyboardNavigationService.onGlobalKeyDown(
      event,
      this.buildKeyboardNavDeps(),
    );
  }

  // Toggle Quotation Mode (Alt+Q)
  // MOVED-TO: src/app/shared/services/order-mode.service.ts -> OrderModeService (whole cluster)
  // Builds the shared dependency bag for the order-mode cluster (toggle
  // quotation/suspense/wholesale mode, updateFormDataWithQuotationMode,
  // canCompleteQuotation, processQuotation, processSuspenseOrder,
  // productsToCartItems, createOrderPayload, updateExistingQuotation,
  // editQuotation, placeOrderFromQuotation). Like the offer-group-mode
  // cluster, this has deep async nesting (subscribe -> subscribe ->
  // subscribe), so every field is a live getter/setter -- see the interface
  // doc comment in order-mode.service.ts.
  private buildOrderModeDeps(): OrderModeDeps {
    return {
      getModePermissions: () => this.modePermissions,
      getIsQuotationMode: () => this.isQuotationMode,
      setIsQuotationMode: (value) => (this.isQuotationMode = value),
      getIsSuspenseMode: () => this.isSuspenseMode,
      setIsSuspenseMode: (value) => (this.isSuspenseMode = value),
      getIsWholesaleMode: () => this.isWholesaleMode,
      setIsWholesaleMode: (value) => (this.isWholesaleMode = value),
      getIsOfferGroupMode: () => this.isOfferGroupMode,
      getIsExchangeOrder: () => this.isExchangeOrder,
      setIsExchangeOrder: (value) => (this.isExchangeOrder = value),
      getIsDeleteMode: () => this.isDeleteMode,
      getIsDateEditMode: () => this.isDateEditMode,
      getCartProducts: () => this.products,
      setCartProducts: (value) => (this.products = value),
      setProductsTemp: (value) => (this.productsTemp = value),
      getIsSalesDiscountEditEnabled: () => this.isSalesDiscountEditEnabled,
      getQuotationValidityDate: () => this.quotationValidityDate,
      setQuotationValidityDate: (value) => (this.quotationValidityDate = value),
      getIsProcessingQuotation: () => this.isProcessingQuotation,
      setIsProcessingQuotation: (value) => (this.isProcessingQuotation = value),
      getIsEditingQuotation: () => this.isEditingQuotation,
      setIsEditingQuotation: (value) => (this.isEditingQuotation = value),
      getEditingQuotationUuid: () => this.editingQuotationUuid,
      setEditingQuotationUuid: (value) => (this.editingQuotationUuid = value),
      getEditingQuotationNumber: () => this.editingQuotationNumber,
      setEditingQuotationNumber: (value) =>
        (this.editingQuotationNumber = value),
      getCustomerName: () => this.customerName,
      setCustomerName: (value) => (this.customerName = value),
      getMobileNumber: () => this.mobileNumber,
      setMobileNumber: (value) => (this.mobileNumber = value),
      getFormData: () => this.formData,
      getEnableCursorFocus: () => this.enableCursorFocus,
      getSelectedCustomer: () => this.selectedCustomer,
      getOverAllDiscountPercent: () => this.overAllDiscountPercent,
      setShowTotalDialog: (value) => (this.showTotalDialog = value),
      setShowTransactionDialog: (value) => (this.showTransactionDialog = value),
      setSelectedInvoiceNo: (value) => (this.selectedInvoiceNo = value),
      setRefundCashAmount: (value) => (this.refundCashAmount = value),
      setIsMobileMandatory: (value) => (this.isMobileMandatory = value),
      setInvoice: (value) => (this.invoice = value),
      getLoyaltyDetails: () => ({
        loyaltyAmount:
          this.paymentTotalDialogRef?.loyalty?.loyaltyPaymentAmount || 0,
        loyaltyPoints:
          this.paymentTotalDialogRef?.loyalty?.loyaltyPointsInput || 0,
        customerId:
          this.paymentTotalDialogRef?.loyalty?.customerLoyaltyData?.id || 0,
      }),
      disableOfferGroupMode: () => this.disableOfferGroupMode(),
      discountChangeCalc: () => this.DiscountchangeCalc(),
      getEffectivePrice: (product) => this.getEffectivePrice(product),
      getInclLineBreakup: (product) => this.getInclLineBreakup(product),
      getGroupId: () => this.getGroupId(),
      isInterStateTax: () => this.isInterStateTax(),
      getOverAllDiscountAmount: () => this.getOverAllDiscountAmount(),
      getFreeAmount: () => this.getFreeAmount(),
      hasNonGSTProducts: () => this.hasNonGSTProducts(),
      formatDate: (date) => this.formatDate(date),
      generateQuotationPDF: (quotationData) =>
        this.generateQuotationPDF(quotationData),
      generateSuspensePdf: (suspenseData) =>
        this.generateSuspensePdf(suspenseData),
      generatePdfNew: () => this.generatePdfNew(),
      clearOrderData: () => this.clearOrderData(),
      resetCardDetails: () => this.resetCardDetails(),
      resetCashDetails: () => this.resetCashDetails(),
      resetUpiDetails: () => this.resetUpiDetails(),
      resetRedeemCreditDetails: () => this.resetRedeemCreditDetails(),
      focusProductSearch: () => this.focusProductSearch(),
      scheduleOpenScannerAfterQuotation: () => {
        timer(200)
          .pipe(delay(800), takeUntil(this.destroy$))
          .subscribe(this.openScanner);
      },
      getQuotationDetailsForEdit: (quotationUuid) =>
        this.getQuotationDetails(quotationUuid),
      destroy$: this.destroy$,
    };
  }

  toggleQuotationMode(): void {
    this.orderModeService.toggleQuotationMode(this.buildOrderModeDeps());
  }

  toggleSuspenseMode(): void {
    this.orderModeService.toggleSuspenseMode(this.buildOrderModeDeps());
  }

  // Toggle Wholesale Mode (Alt+W)
  toggleWholesaleMode(): void {
    this.orderModeService.toggleWholesaleMode(this.buildOrderModeDeps());
  }

  // Get effective price based on current mode (quotation, offer group, wholesale, or normal)
  getEffectivePrice(product: Product): number {
    if (this.isQuotationMode) {
      const listPrice = this.getQuotationListPrice(product);
      // Discount before tax: the line discount comes off the unit price, as in normal
      // mode (where it is already in sellingprice). Discount after tax is subtracted
      // from the totals instead, so the price stays undiscounted there.
      if (!this.isDiscountAfterTaxEnabled) {
        return Math.max(0, (Number(listPrice) || 0) - (Number(product.discountval) || 0));
      }
      return listPrice;
    }
    if (
      this.isOfferGroupMode &&
      product.groupingprice &&
      product.groupingprice > 0
    ) {
      return product.groupingprice;
    }
    if (this.isWholesaleMode) {
      return product.wholesaleprice;
    }
    return product.sellingprice;
  }

  // Get groupId based on current mode
  getGroupId(): number {
    if (this.isSuspenseMode) {
      return -2; // Suspense mode
    }
    if (this.isOfferGroupMode && this.selectedOfferGroupId !== null) {
      return this.selectedOfferGroupId; // Offer Group mode (positive number)
    }
    if (this.isWholesaleMode) {
      return -1; // Wholesale mode
    }
    return 0; // Normal mode
  }

  // Get effective base price for discount calculations
  /** Quotation list price for the line's sale unit, before line discount (secondary unit has its own price). */
  getQuotationListPrice(product: Product): number {
    return product.unitsellprice ?? product.barcodesellprice;
  }

  getEffectiveBasePrice(product: Product): number {
    if (this.isQuotationMode) {
      return this.getQuotationListPrice(product);
    }
    if (
      this.isOfferGroupMode &&
      product.groupingprice &&
      product.groupingprice > 0
    ) {
      return product.groupingprice;
    }
    if (this.isSalesPriceEditEnabled && !this.isWholesaleMode) {
      //console.log('Using selling price for discount calc:', product.sellingprice);
      return product.orgprice ?? product.sellingprice;
    }
    if (this.isWholesaleMode) {
      return product.wholesaleprice;
    }
    // A secondary sale unit has its own price; barcodesellprice is always the base-unit price
    return product.unitsellprice ?? product.barcodesellprice;
  }

  /** Tax % used to convert between excl-tax and incl-tax unit prices. */
  getUnitPriceTaxRate(product: Product): number {
    return Number(product.percentage || 0) ||
      (Number(product.stax || 0) + Number(product.ctax || 0)) ||
      Number(product.itax || 0);
  }

  // Get effective incl-tax unit price for the Unit Price (Incl. Tax) column.
  // Offer group price is stored excl-tax, so it is converted here; every other
  // mode keeps showing product_selling_price_incl as before.
  getEffectiveInclPrice(product: Product): number | undefined {
    if (
      !this.isQuotationMode &&
      this.isOfferGroupMode &&
      product.groupingprice &&
      product.groupingprice > 0
    ) {
      const taxRate = this.getUnitPriceTaxRate(product);
      return taxRate > 0
        ? Math.round(product.groupingprice * (1 + taxRate / 100) * 100) / 100
        : product.groupingprice;
    }
    return product.product_selling_price_incl;
  }

  /** Get effective cost price for a product based on whether a secondary unit is selected */
  getEffectiveCostPrice(product: any): number {
    let costPrice = product.costprice || product.buyingprice || 0;
    // if (product.unit_id && product.unit_mappings?.length) {
    //   const mapping = product.unit_mappings.find((m: any) => m.unitid == product.unit_id);
    //   if (mapping) {
    //     if (mapping.purchaseprice && mapping.purchaseprice > 0) {
    //       costPrice = mapping.purchaseprice;
    //     } else if (mapping.conversionfactor) {
    //       const isLowBaseUnit = product.unit_mappings.some((m: any) => parseFloat(m.conversionfactor) >= 1);
    //       if (isLowBaseUnit) {
    //         const sortedMappings = [...product.unit_mappings].sort((a: any, b: any) => a.id - b.id);
    //         const selectedIndex = sortedMappings.findIndex((m: any) => m.unitid == product.unit_id);
    //         if (selectedIndex !== -1) {
    //           let chainMultiplier = 1;
    //           for (let i = 0; i <= selectedIndex; i++) {
    //             chainMultiplier *= parseFloat(sortedMappings[i].conversionfactor || 1);
    //           }
    //           if (chainMultiplier > 0) {
    //             costPrice = costPrice / chainMultiplier;
    //           }
    //         }
    //       } else {
    //         costPrice = costPrice * parseFloat(mapping.conversionfactor);
    //       }
    //     }
    //   }
    // }
    return costPrice;
  }

  onProductGSTToggle(product: Product): void {
    if (this.isSuspenseMode) {
      product.isgst = product.selected ? 0 : 1;

      // Case-insensitive comparison for barcode/PSID
      const tempProduct = this.productsTemp.find(
        (p) => p && p.psid?.toLowerCase() === product.psid?.toLowerCase(),
      );
      if (tempProduct) {
        tempProduct.isgst = product.isgst;
        tempProduct.selected = product.selected;
      }
    }
  }

  // Check if any product has isgst = 0 (for payment restrictions)
  hasNonGSTProducts(): boolean {
    return this.products.some((product) => product.isgst === 0);
  }

  // Check if ALL products have isgst = 0 (all non-GST)
  hasOnlyNonGSTProducts(): boolean {
    return this.products.every((product) => product.isgst === 0);
  }

  /**
   * Mobile industry only: true when the cart has items and every active
   * (non-returned) line is a full-free item (isFree) — nothing to collect.
   */
  hasOnlyFreeItemsInMobileCart(): boolean {
    if (!this.industryService.isMobile()) return false;
    const activeProducts = (this.products || []).filter((p) => !p.returned);
    return activeProducts.length > 0 && activeProducts.every((p) => p.isFree === true);
  }

  /**
   * Mobile industry: cart is 100% free items. Skip the payment dialog and run
   * the normal checkout pipeline in the background (validate → place order →
   * auto-print → reset) with a zero-amount Cash payment.
   */
  private processFreeMobileCheckout(): void {
    this.activePaymentTab = 'Cash';
    this.selectedPaymentOptions = ['Cash'];
    this.resetCashDetails();
    this.resetCardDetails();
    this.resetUpiDetails();
    this.resetRedeemCreditDetails();
    this.processPayment();
  }

  getTotalDiscountAmountForProduct(product: Product): number {
    const effectiveBasePrice = this.getEffectiveBasePrice(product);
    if (!product.discount || product.discount <= 0) {
      return 0;
    } else {
      let discountAmount = 0;
      if (this.discountMode === 'percentage') {
        discountAmount = (effectiveBasePrice * (product.discount || 0)) / 100;
      } else discountAmount = product.discountval || 0;
      return discountAmount;
    }
  }

  // Incl-tax pricing: the excl price is stored rounded (300.48 / 1.12 -> 268.29), so
  // excl + tax drifts off the shelf price (268.29 x 1.12 = 300.4848). Bill the stored
  // incl price x qty instead and work GST back from it (300.48 x 3 = 901.44 -> taxable
  // 804.86, GST 96.58). Used by the item row, sidebar totals and order payload.
  // Returns null where the existing excl price + tax maths stays (every other mode).
  getInclLineBreakup(product: Product): InclLineBreakup | null {
    if (
      !this.isUnitPriceInclTax ||
      this.isWholesaleMode ||
      this.isQuotationMode ||
      this.isExchangeOrder ||
      this.industryService.isMobile() ||
      (this.isSuspenseMode && product.isgst === 0) ||
      !product?.increaseQuantity ||
      product.returned
    ) {
      return null;
    }
    const round2 = (v: number) => Math.round(v * 100) / 100;

    const computedIncl =
      this.getEffectivePrice(product) + this.gettotaltaxval(product, 1);
    // Trust the stored incl price only while it still matches the excl price: the
    // rounding drift is under 0.01 (0.0064 at 28%), while a before-tax discount,
    // price edit or stale value differs by more.
    const storedIncl = Number(this.getEffectiveInclPrice(product));
    const unitIncl =
      storedIncl > 0 && Math.abs(storedIncl - computedIncl) < 0.01
        ? storedIncl
        : round2(computedIncl);
    const gross = round2(unitIncl * product.increaseQuantity);

    // Same rates gettotaltaxval charges
    const interState = this.isInterStateTax();
    const ctax = interState ? 0 : Number(product.ctax) > 0 ? Number(product.ctax) : 0;
    const stax = interState ? 0 : Number(product.stax) > 0 ? Number(product.stax) : 0;
    const itax = interState && Number(product.itax) > 0 ? Number(product.itax) : 0;
    const rate = ctax + stax + itax;
    if (rate <= 0) {
      return { gross, taxable: gross, cgst: 0, sgst: 0, igst: 0 };
    }

    // CGST and SGST are each rounded from the exact tax so they stay equal (GST returns
    // expect that); the taxable value takes the rounding instead
    // (300.48 -> CGST 16.10 + SGST 16.10, taxable 268.28; not 16.10 + 16.09).
    const exactTax = gross - gross / (1 + rate / 100);
    if (interState) {
      const igst = round2(exactTax);
      return { gross, taxable: round2(gross - igst), cgst: 0, sgst: 0, igst };
    }
    const cgst = round2((exactTax * ctax) / rate);
    const sgst = round2((exactTax * stax) / rate);
    return { gross, taxable: round2(gross - cgst - sgst), cgst, sgst, igst: 0 };
  }

  // Item-row net value. Incl-tax pricing: the line value from getInclLineBreakup, less
  // the after-tax discount the bill total takes off (getExactTotal); otherwise getNetValue.
  getRowNetValue(product: Product): number {
    const round2 = (v: number) => Math.round(v * 100) / 100;
    const incl = this.getInclLineBreakup(product);
    if (!incl) {
      return round2(this.getNetValue(product));
    }
    const afterTaxDiscount = this.isDiscountAfterTaxEnabled
      ? (Number(product.discountval) || 0) * product.increaseQuantity
      : 0;
    return round2(incl.gross - afterTaxDiscount);
  }

  // Calculate net value based on suspense mode and GST flag
  getNetValue(product: Product): number {
    // console.log(this.isDiscountAfterTaxEnabled);
    if (this.isDiscountAfterTaxEnabled) {
      //return 0;
      const effectivePrice = this.getEffectivePrice(product);
      const baseAmount = effectivePrice;
      //console.log(`effectivePrice: ${effectivePrice}, baseAmount: ${baseAmount}, isgst: ${product.isgst}`,   );
      // In suspense mode, if product has isgst = 0, exclude tax
      if (this.isSuspenseMode && product.isgst === 0) {
        return baseAmount;
      }

      console.log('ctax' + product.ctax);
      console.log('stax' + product.stax);
      console.log('itax' + product.itax);

      // Otherwise, include tax as normal
      console.log('baseAmount' + baseAmount);
      const taxAmount = this.gettotaltaxval(product, 1);
      console.log('taxAmount' + taxAmount);
      let totalAmount = baseAmount + taxAmount;
      //console.log('totalAmount' + totalAmount);
      //calculate discount on total amount (price + tax) if discount after tax is enabled

      let discountAmount = 0;
      if (product.discount && product.discount > 0) {
        if (this.discountMode === 'percentage') {
          discountAmount = (totalAmount * (product.discount || 0)) / 100;
        } else discountAmount = product.discountval || 0;
      }

      let totalafterdiscount = totalAmount - discountAmount;
      console.log('totalafterdiscount' + totalafterdiscount);
      let netValue = totalafterdiscount * product.increaseQuantity;
      //console.log('netValue' + netValue);

      // In exchange mode, subtract the prorated globalDiscountShare from original order
      if (this.isExchangeOrder && product.globalDiscountShare) {
        netValue -= this.posCalculationService.getProratedGlobalDiscountShare(
          product,
          product.increaseQuantity,
        );
      }
      console.log('netValue' + netValue);
      //return 0;
      return netValue;
    } else {
      const effectivePrice = this.getEffectivePrice(product);
      const baseAmount = effectivePrice * product.increaseQuantity;
      //console.log(`effectivePrice: ${effectivePrice}, baseAmount: ${baseAmount}, isgst: ${product.isgst}`,   );
      // In suspense mode, if product has isgst = 0, exclude tax
      if (this.isSuspenseMode && product.isgst === 0) {
        return baseAmount;
      }

      // Otherwise, include tax as normal
      const taxAmount =
        this.gettotaltaxval(product, 1) * product.increaseQuantity;
      let netValue = baseAmount + taxAmount;

      // In exchange mode, subtract the prorated globalDiscountShare from original order
      if (this.isExchangeOrder && product.globalDiscountShare) {
        netValue -= this.posCalculationService.getProratedGlobalDiscountShare(
          product,
          product.increaseQuantity,
        );
      }
      return netValue;
    }
  }

  processSuspenseOrder(
    orderUuid: string,
    allItemsNonGST: boolean = false,
  ): void {
    this.orderModeService.processSuspenseOrder(
      orderUuid,
      allItemsNonGST,
      this.buildOrderModeDeps(),
    );
  }

  private updateFormDataWithQuotationMode(): void {
    this.orderModeService.updateFormDataWithQuotationMode(
      this.buildOrderModeDeps(),
    );
  }
  onPaymentDialogKeyDown(event: KeyboardEvent): void {
    this.keyboardNavigationService.onPaymentDialogKeyDown(
      event,
      this.buildKeyboardNavDeps(),
    );
  }
  canCompleteQuotation(): boolean {
    return this.orderModeService.canCompleteQuotation(
      this.buildOrderModeDeps(),
    );
  }

  handleProcessOrder(): void {
    if (this.isOrderBlocked) {
      this.showOrderBlockedMessage();
      return;
    }
    if (this.hasPendingMappingSelection()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Mapping Required',
        detail: 'Please select a mapping for all items before processing order',
        life: 3000,
      });
      return;
    }

    if (this.isQuotationMode) {
      if (this.canCompleteQuotation() && !this.isProcessingQuotation) {
        this.onProcessQuotationClicked();
      }
      return;
    }

    if (this.isExchangeOrder) {
      if (this.products && this.products.length > 0) {
        this.showTotalDialog = true;
        if (this.enableCursorFocus) {
          setTimeout(() => {
            this.focusFirstDialogElement();
          }, 100);
        }
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cannot Process Exchange',
          detail: 'Please add items to process exchange',
          life: 3000,
        });
      }
    } else if (this.canProcessPayment()) {
      this.showTotalDialog = true;
      if (this.enableCursorFocus) {
        setTimeout(() => {
          this.focusFirstDialogElement();
        }, 100);
      }
    } else if (this.hasOnlyFreeItemsInMobileCart()) {
      // Mobile industry, 100% free cart — nothing to collect; skip the
      // payment dialog and run checkout (place order → auto-print → reset).
      this.processFreeMobileCheckout();
    } else {
      const hasProducts = this.products && this.products.length > 0;
      const total = this.getRoundedTotal();
      console.log(this.products, 'products process order');
      if (!hasProducts) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cannot Process Payment',
          detail: 'Please add items to cart before processing payment',
          life: 3000,
        });
      } else if (total <= 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cannot Process Payment',
          detail: 'Order total is ₹0. Please check item prices and quantities',
          life: 3000,
        });
      }
    }
  }

  navigateToCashManagement(): void {
    this.router.navigate(['/cash-management']);
  }

  /** Cash Denomination availability (feature-flags.ts) */
  get isDenominationEnabled(): boolean {
    return this.industryService.isDenominationEnabled();
  }

  navigateToDenomination(): void {
    if (!this.industryService.isDenominationEnabled()) return;
    this.router.navigate(['/cash-denomination']);
  }

  selectFreeProduct(product: Product) {
    // Mobile industry only â€” toggle the free flag and sync productsTemp
    if (!this.industryService.isMobile()) return;
    product.isFree = !product.isFree;
    this.productsTemp = this.products.map((p) => ({ ...p }));
  }

  getFreeAmount(): number {
    return this.posCalculationService.getFreeAmount(this.products, (p) =>
      this.getEffectivePrice(p),
    );
  }

  /** Total free-qty value: sellingprice × cart_free_qty, no tax/discount */
  getTotalFreeAmount(): number {
    return this.posCalculationService.getTotalFreeAmount(this.products);
  }
  /**
   * Called when "Process Quotation" button is clicked.
   * Shows the QuotationOptionsDialog to collect customer info and PDF type
   * BEFORE placing the order and generating the PDF.
   */
  onProcessQuotationClicked(): void {
    if (!this.canCompleteQuotation() && this.isProcessingQuotation) return;
    this.showQuotationOptionsDialog = true;
  }

  /**
   * Called when user confirms the options dialog and hits "Generate PDF".
   * Updates customer/validity from the dialog, then runs the order flow.
   */
  onQuotationOptionsSaved(options: QuotationOptions): void {
    this.showQuotationOptionsDialog = false;
    this._quotationWithGst = options.withGst;
    this._quotationCustomerDetails = options;

    const finalCustomerName = options.customerName?.trim() || '';
    const finalMobileNumber = options.mobileNumber?.trim() || '';

    // Apply customer overrides to dashboard state
    this.customerName = finalCustomerName;
    this.mobileNumber = finalMobileNumber;
    this.quotationValidityDate = options.validUntil;

    // Sync with FormDataService so header and other components stay in sync
    this.formDataService.updateFormData({
      ...this.formData,
      customerName: finalCustomerName,
      mobileNumber: finalMobileNumber,
      empCode: this.formData?.empCode || '',
      storeCode: this.formData?.storeCode || '',
      currentDate: this.formData?.currentDate || new Date(),
      salesRep: this.formData?.salesRep || '',
    });

    // Now run the actual quotation order flow
    this.processQuotation();
  }

  showFreeQtyCol() {
    this.enableFreeQty = !this.enableFreeQty;
  }

  processQuotation(): void {
    this.orderModeService.processQuotation(this.buildOrderModeDeps());
  }
  private productsToCartItems(
    products: Product[],
    isExchangeOrder: boolean = false,
  ): any[] {
    return this.orderModeService.productsToCartItems(
      products,
      isExchangeOrder,
      this.buildOrderModeDeps(),
    );
  }
  private createOrderPayload(): any {
    return this.orderModeService.createOrderPayload(this.buildOrderModeDeps());
  }

  // Generate quotation PDF using quotation data from API
  private generateQuotationPDF(quotationData: any): void {
    const storename = JSON.parse(localStorage.getItem('storename') || '{}');
    const quotationItems = quotationData.customerorderitems || [];
    const validityDate = quotationData.validity
      ? new Date(quotationData.validity)
      : this.quotationValidityDate;

    const clientData = this.dynamicTemplateConfigService.getClientData();
    const rawBank = clientData?.bankaccount;
    const clientBank = Array.isArray(rawBank) ? rawBank[0] : rawBank;

    const qNumber =
      quotationData.quotationnumber ||
      quotationData.quotation_number ||
      quotationData.quotationNumber ||
      quotationData.order_no ||
      quotationData.uuid ||
      '';

    const finalCustomerName =
      this._quotationCustomerDetails?.customerName ||
      this.customerName ||
      quotationData.name ||
      'Walk-In Customer';

    const finalCustomerMobile =
      this._quotationCustomerDetails?.mobileNumber ||
      this.mobileNumber ||
      quotationData.user_id ||
      '';

    const finalCustomerAddress =
      this._quotationCustomerDetails?.customerAddress || '';

    const finalCustomerGSTIN =
      this._quotationCustomerDetails?.customerGSTIN || '';

    // Build InvoiceData from the API response and Client Sale API Data
    const invoiceData = {
      invoiceNumber: qNumber,
      quotationnumber: quotationData.quotationnumber || qNumber,
      quotationNumber: quotationData.quotationNumber || qNumber,
      referenceNo: qNumber,
      invoiceDate: new Date(),
      createdAt: new Date().toISOString(),
      businessName: clientData?.client_name || storename?.name || '',
      businessAddress: [
        storename?.address,
        storename?.address1,
        storename?.address2,
        storename?.pincode,
      ]
        .filter((p: string) => p && p.trim())
        .join(', '),
      businessPhone: clientData?.mobile || storename?.mobile || '',
      businessGSTIN: clientData?.gstno || storename?.gstin || '',
      businessLogo:
        clientData?.logo || storename?.logo || storename?.image || '',
      business: {
        name: clientData?.client_name || storename?.name || '',
        address: [
          storename?.address,
          storename?.address1,
          storename?.address2,
          storename?.pincode,
        ]
          .filter((p: string) => p && p.trim())
          .join(', '),
        phone: clientData?.mobile || storename?.mobile || '',
        gstin: clientData?.gstno || storename?.gstin || '',
        logo: clientData?.logo || storename?.logo || storename?.image || '',
        msmeNo:
          clientData?.msmeno ||
          clientData?.msme_no ||
          clientData?.msmeNo ||
          localStorage.getItem('msmeno') ||
          '',
        msmeType:
          clientData?.msmetype ||
          clientData?.msme_type ||
          clientData?.msmeType ||
          localStorage.getItem('msmetype') ||
          '',
        msmeno:
          clientData?.msmeno ||
          clientData?.msme_no ||
          clientData?.msmeNo ||
          localStorage.getItem('msmeno') ||
          '',
        msmetype:
          clientData?.msmetype ||
          clientData?.msme_type ||
          clientData?.msmeType ||
          localStorage.getItem('msmetype') ||
          '',
      },
      signature: clientData?.signature || '',
      termsAndConditions: clientData?.terms || '',
      bankDetails: clientBank
        ? {
            bankName:
              clientBank.bank_name ||
              clientBank.bankname ||
              clientBank.bankName ||
              '',
            accountHolderName:
              clientBank.account_name ||
              clientBank.account_holder_name ||
              clientBank.accountHolderName ||
              '',
            accountNumber:
              clientBank.account_no ||
              clientBank.account_number ||
              clientBank.accountNumber ||
              '',
            ifscCode:
              clientBank.ifsc_code ||
              clientBank.ifsc ||
              clientBank.ifscCode ||
              '',
            branch:
              clientBank.branch ||
              clientBank.branch_name ||
              clientBank.branchName ||
              '',
          }
        : undefined,
      customerName: finalCustomerName,
      customerMobile: finalCustomerMobile,
      customerGSTIN: finalCustomerGSTIN,
      customerAddress: finalCustomerAddress
        ? { line1: finalCustomerAddress }
        : undefined,
      quotationValidityDate: validityDate,
      invoiceType: 'quotation' as const,
      // PDF shows the list price and the discount in its own column, so it uses the
      // undiscounted quotation price (not getEffectivePrice, which is net of discount)
      subtotal: quotationItems.reduce((s: number, i: any) =>
        s + ((i.quantity || 1) * (this.getQuotationListPrice(i) || 0)), 0),
      totalAmount: quotationData.grandtotal || this.getTotal(),
      grandTotal: quotationData.grandtotal || this.getTotal(),
      cgst: quotationData.cgst || 0,
      sgst: quotationData.sgst || 0,
      igst: quotationData.igst || 0,
      taxAmount: quotationData.tax || 0,
      totalTax: quotationData.tax || 0,
      items: quotationItems.map((product: any) => {
        const qty = product.quantity || 1;
        const price = this.getQuotationListPrice(product) || 0;
        const discount = product.discount || product.discountamount || product.discountamt || 0;
        const taxableAmount = product.taxableamount || (qty * price - discount);
        return {
          name: product.name || '',
          hsncode: product.hsncode || '',
          quantity: qty,
          unit: product.unit || 'PCS',
          price: price,
          discount: discount,
          taxableAmount: taxableAmount,
          taxPercent: product.taxpercent || product.taxrate || 0,
          taxamount: product.taxamount || 0,
          cgstval: product.cgstval || 0,
          sgstval: product.sgstval || 0,
          igstval: product.igstval || 0,
          total: product.grandtotal || taxableAmount + (product.taxamount || 0),
        };
      }),
    };

    // Route to correct template based on the user's choice in the options dialog
    const templateName = this._quotationWithGst
      ? 'quotation-with-gst'
      : 'quotation-without-gst';
    this.pdfGenerationService.openInvoicePdf(invoiceData as any, templateName);
  }
  // Focus on barcode search input (Ctrl+1)
  focusBarcodeSearch() {
    this.focusManagerService.focusBarcodeSearch(this.isBarcodeEnabled);
  }
  // Focus on product search input (Ctrl+2)
  focusProductSearch() {
    this.focusManagerService.focusProductSearch();
  }
  // Focus on discount toggle and toggle it (Ctrl+3)
  focusOnDiscountToggle() {
    this.focusManagerService.focusOnDiscountToggle(
      () => this.isAmountMode,
      (value) => (this.isAmountMode = value),
      (event) => this.onDiscountToggle(event),
    );
  }
  // Transaction History keyboard navigation
  onTransactionHistoryKeyDown(event: KeyboardEvent) {
    this.keyboardNavigationService.onTransactionHistoryKeyDown(
      event,
      this.buildKeyboardNavDeps(),
    );
  }
  navigateTransactionDown() {
    this.keyboardNavigationService.navigateTransactionDown(
      this.buildKeyboardNavDeps(),
    );
  }
  navigateTransactionUp() {
    this.keyboardNavigationService.navigateTransactionUp(
      this.buildKeyboardNavDeps(),
    );
  }
  // Quotation History keyboard navigation methods
  navigateQuotationDown() {
    this.keyboardNavigationService.navigateQuotationDown(
      this.buildKeyboardNavDeps(),
    );
  }
  navigateQuotationUp() {
    this.keyboardNavigationService.navigateQuotationUp(
      this.buildKeyboardNavDeps(),
    );
  }
  selectQuotationByIndex(index: number) {
    this.transactionHistoryService.selectQuotationByIndex(
      index,
      this.buildTransactionHistoryDeps(),
    );
  }
  // Switch between Transaction History and Quotation History tabs
  switchHistoryTab(goRight: boolean) {
    this.transactionHistoryService.switchHistoryTab(
      goRight,
      this.buildTransactionHistoryDeps(),
    );
  }
  selectTransactionByIndex(index: number) {
    this.transactionHistoryService.selectTransactionByIndex(
      index,
      this.buildTransactionHistoryDeps(),
    );
  }
  validateCustomerInfo(): boolean {
    return this.customerLookupService.validateCustomerInfo(
      this.buildCustomerLookupDeps(),
    );
  }

  calculateBalance(): number {
    return this.paymentCalculationService.calculateBalance({
      isExchangeOrder: this.isExchangeOrder,
      isSelected: (paymentType: string) => this.isSelected(paymentType),
      roundedTotal: this.getRoundedTotal(),
      cashAmount: this.cashAmount,
      cardAmount: this.cardDetails.amount,
      upiAmount: this.upiDetails.upiAmount,
      redeemCreditAmount: this.redeemCreditAmount,
      refundCashAmount: this.refundCashAmount,
      loyaltyPaymentAmount:
        this.paymentTotalDialogRef?.loyalty?.loyaltyPaymentAmount ?? 0,
    });
  }

  isSelected(paymentType: string): boolean {
    return (
      this.paymentTotalDialogRef?.session?.isSelected(paymentType) ?? false
    );
  }

  getAvailablePaymentOptions(): string[] {
    if (this.isExchangeOrder) {
      // For exchange orders, exclude UPI and Card, and show "Add to Credit" instead of "Redeem Credit"
      return this.paymentOptions
        .filter((option) => option !== 'UPI' && option !== 'Card') // Remove UPI and Card
        .map((option) =>
          option === 'Redeem Credit' ? 'Add to Credit' : option,
        );
    } else {
      // For regular orders, show normal options including "Redeem Credit"
      return this.paymentOptions;
    }
  }

  isPaymentOptionDisabled(option: string): boolean {
    // In exchange orders, user can switch between Cash and Add to Credit freely
    // No payment options should be disabled
    return false;
  }
  resetCardDetails() {
    this.paymentTotalDialogRef?.session?.resetCardDetails();
  }

  resetUpiDetails() {
    this.paymentTotalDialogRef?.session?.resetUpiDetails();
  }

  resetCashDetails() {
    this.paymentTotalDialogRef?.session?.resetCashAmount();
    this.calculateBalance();
  }

  resetRedeemCreditDetails() {
    this.paymentTotalDialogRef?.session?.resetRedeemCreditFields(
      this.isExchangeOrder,
    );
    this.calculateBalance();
  }

  validateRedeemCreditAmount() {
    const warning = this.paymentValidationService.validateRedeemCreditAmount(
      this.redeemCreditAmount,
      this.availableCreditAmount,
      this.getRoundedTotal(),
    );
    if (warning) {
      this.messageService.add(warning);
    }

    // Auto-fill the remaining balance into Cash, Card, or UPI amount.
    // When Redeem is active inside Cash/Card/UPI tab, the user must NOT type the
    // remaining amount manually — we calculate it and set it automatically.
    if (
      this.redeemCreditAmount > 0 &&
      this.redeemCreditAmount <= this.getRoundedTotal()
    ) {
      const remaining = +(
        this.getRoundedTotal() - this.redeemCreditAmount
      ).toFixed(2);
      if (this.activePaymentTab === 'Cash') {
        this.cashAmount = remaining;
      } else if (this.activePaymentTab === 'Card') {
        this.cardDetails = { ...this.cardDetails, amount: remaining };
      } else if (this.activePaymentTab === 'UPI') {
        this.upiDetails = { ...this.upiDetails, upiAmount: remaining };
      } else if (this.activePaymentTab === 'Split') {
        if (
          !this.splitPaymentAmounts.cash &&
          !this.splitPaymentAmounts.card &&
          !this.splitPaymentAmounts.upi
        ) {
          this.splitPaymentAmounts.cash = remaining;
          this.syncPaymentValues();
        }
      }
    } else if (this.redeemCreditAmount === 0) {
      // Redeem cleared — reset payment amounts so user can enter fresh
      if (this.activePaymentTab === 'Cash') {
        this.cashAmount = 0;
      } else if (this.activePaymentTab === 'Card') {
        this.cardDetails = { ...this.cardDetails, amount: null };
      } else if (this.activePaymentTab === 'UPI') {
        this.upiDetails = { ...this.upiDetails, upiAmount: 0 };
      }
    }

    this.calculateBalance();
  }

  // Helper method to validate redeem credit for order placement (blocking validation)
  isRedeemCreditValid(): boolean {
    return this.paymentValidationService.isRedeemCreditValid(
      this.isSelected('Redeem Credit'),
      this.redeemCreditAmount,
      this.availableCreditAmount,
      this.getRoundedTotal(),
    );
  }

  onToggleButton(event: ToggleButtonChangeEvent) {
    this.isProductSearch = event.checked ?? false;
    if (this.enableCursorFocus) {
      this.focusAutoComplete();
    }
  }

  ondiscountvaluechange(event: any, product: Product) {
    const rawVal = event.target.value;
    const parsed = parseFloat(rawVal);
    const discount = isNaN(parsed) || parsed < 0 ? 0 : parsed;

    product.discount = discount;

    this.isDiscountAfterTaxEnabled =
      this.clientSettingsService.isDiscountAfterTaxEnabled();

    if (!this.isDiscountAfterTaxEnabled) {
      this.offerpriceupdation(rawVal, product, true);
    } else {
      this.offertaxpriceupdation(rawVal, product, true);
    }

    this.calculateGlobalDiscountShares();
  }

  offerpriceupdation(event: any, product: Product, isLive: boolean = false) {
    const discountInput = event;
    let discount = Number(discountInput) || 0;

    const basePrice = this.getEffectiveBasePrice(product);
    const costPrice = this.getEffectiveCostPrice(product);
    const maxDiscountValue = Math.max(0, basePrice - costPrice);

    if (this.discountMode === 'percentage') {
      const maxPercentage =
        maxDiscountValue > 0 ? (maxDiscountValue / basePrice) * 100 : 0;
      const mmaxPercentage = maxPercentage > 100 ? 100 : maxPercentage;

      if (!isLive && Number(discountInput) > mmaxPercentage) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Discount Limited',
          detail: `Maximum discount is ${mmaxPercentage.toFixed(2)}% for this item`,
          life: 3000,
        });
        discount = parseFloat(mmaxPercentage.toFixed(2));
      }
    } else {
      if (!isLive && Number(discountInput) > maxDiscountValue) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Discount Limited',
          detail: `Maximum discount is ₹${maxDiscountValue.toFixed(2)} for this item`,
          life: 3000,
        });
        discount = parseFloat(maxDiscountValue.toFixed(2));
      }
    }

    discount = Math.round(discount * 100) / 100;
    product.discount = discount;

    let discvalue =
      this.discountMode === 'percentage'
        ? (basePrice * discount) / 100
        : discount;

    discvalue = Math.max(0, Math.min(discvalue, maxDiscountValue));
    product.discountval = discvalue;
    product.sellingprice = basePrice - discvalue;
  }

  offertaxpriceupdation(event: any, product: Product, isLive: boolean = false) {
    const discountInput = event;
    let discount = Number(discountInput) || 0;

    const basePricebeforetax = this.getEffectiveBasePrice(product);
    const taxAmount = this.gettotaltaxval(product, 1);
    const basePrice = basePricebeforetax + taxAmount;
    const costPrice = this.getEffectiveCostPrice(product);
    const maxDiscountValue = Math.max(0, basePrice - costPrice);

    if (this.discountMode === 'percentage') {
      const maxPercentage =
        maxDiscountValue > 0 ? (maxDiscountValue / basePrice) * 100 : 0;

      if (!isLive && Number(discountInput) > maxPercentage) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Discount Limited',
          detail: `Maximum discount is ${maxPercentage.toFixed(2)}% for this item`,
          life: 3000,
        });
        discount = parseFloat(maxPercentage.toFixed(2));
      }
    } else {
      if (!isLive && Number(discountInput) > maxDiscountValue) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Discount Limited',
          detail: `Maximum discount is ₹${maxDiscountValue.toFixed(2)} for this item`,
          life: 3000,
        });
        discount = parseFloat(maxDiscountValue.toFixed(2));
      }
    }

    discount = Math.round(discount * 100) / 100;
    product.discount = discount;

    let discvalue =
      this.discountMode === 'percentage'
        ? (basePrice * discount) / 100
        : discount;

    discvalue = Math.max(0, Math.min(discvalue, maxDiscountValue));
    product.discountval = discvalue;
  }

  onDiscountBlur(event: any, product: Product) {
    const discountInput = event.target.value;
    this.isDiscountAfterTaxEnabled =
      this.clientSettingsService.isDiscountAfterTaxEnabled();
    if (!this.isDiscountAfterTaxEnabled)
      this.offerpriceupdation(discountInput, product, false);
    else {
      this.offertaxpriceupdation(discountInput, product, false);
    }
  }

  onUnitPriceBlur(event: any, product: Product): void {
    console.log(product);
    const priceInput = event.target.value;
    let price = Number(priceInput) || 0;

    // When editing incl-tax price, validate against incl-tax cost price
    const costPrice =
      this.isUnitPriceInclTax && !this.isWholesaleMode
        ? product.product_cost_price_incl || this.getEffectiveCostPrice(product)
        : this.getEffectiveCostPrice(product);

    if (price < costPrice) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Price',
        detail: `Unit price cannot be less than cost price (₹${costPrice.toFixed(2)})`,
        life: 3000,
      });

      price = costPrice;
      event.target.value = costPrice.toFixed(2);
    }

    price = Math.round(price * 100) / 100;

    if (this.isWholesaleMode) {
      product.wholesaleprice = price;
      product.orgprice = price;
    } else if (this.isOfferGroupMode) {
      // groupingprice is excl-tax; back-calculate when the cashier typed an incl-tax price
      const taxRate = this.isUnitPriceInclTax ? this.getUnitPriceTaxRate(product) : 0;
      const exclPrice = taxRate > 0
        ? Math.round((price / (1 + taxRate / 100)) * 100) / 100
        : price;
      product.groupingprice = exclPrice;
      product.orgprice = exclPrice;
    } else if (this.industryService.isMobile()) {
      product.sellingpriceincltax = price;
      product.sellingprice = price;
      product.orgprice = price;
    } else if (this.isUnitPriceInclTax) {
      // Cashier entered the incl-tax price; store in product_selling_price_incl
      product.product_selling_price_incl = price;
      // Back-calculate excl-tax sellingprice for existing excl-tax calculations
      const taxRate = this.getUnitPriceTaxRate(product);
      product.sellingprice = taxRate > 0
        ? Math.round((price / (1 + taxRate / 100)) * 100) / 100
        : price;
      product.orgprice = product.sellingprice;
    } else {
      product.sellingprice = price;
      product.orgprice = price;
    }

    if (this.isSalesDiscountEditEnabled && product.discount > 0) {
      this.offerpriceupdation(product.discount, product);
    }
  }

  onExchangeQuantityChange(product: Product): void {
    // Ensure exchange quantity is within valid bounds
    const maxQuantity = product.increaseQuantity || 0;
    let exchangeQty = Number(product.exchangeQuantity) || 0;

    if (exchangeQty > maxQuantity) {
      exchangeQty = maxQuantity;
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Quantity',
        detail: `Exchange quantity cannot exceed available quantity (${maxQuantity})`,
        life: 3000,
      });
    }

    exchangeQty = Math.max(0, exchangeQty);

    product.exchangeQuantity = exchangeQty;

    // Update refund cash amount based on new exchange total
    if (this.isExchangeOrder && !this.isSelected('Add to Credit')) {
      this.refundCashAmount = this.getRoundedTotal();
    }
  }
  onExchangeQuantityTab(event: KeyboardEvent, currentIndex: number): void {
    this.keyboardNavigationService.onExchangeQuantityTab(event, currentIndex);
  }
  onQuantityInputTab(event: Event, currentIndex: number): void {
    this.keyboardNavigationService.onQuantityInputTab(event, currentIndex);
  }
  onAmountInputTab(event: KeyboardEvent, currentIndex: number): void {
    this.keyboardNavigationService.onAmountInputTab(event, currentIndex);
  }

  increaseExchangeQuantity(product: Product): void {
    if (product.isFree) return;
    const currentQty = Number(product.exchangeQuantity) || 0;
    const maxQty = product.increaseQuantity || 0;

    if (currentQty < maxQty) {
      product.exchangeQuantity = currentQty + 1;
    }
  }

  decreaseExchangeQuantity(product: Product): void {
    if (product.isFree) return;
    const currentQty = Number(product.exchangeQuantity) || 0;

    if (currentQty > 0) {
      product.exchangeQuantity = currentQty - 1;
    }
  }
  private focusAutoComplete() {
    this.focusManagerService.focusAutoComplete(this.autoCompleteInput);
  }
  private focusAmountInput() {
    this.focusManagerService.focusAmountInput();
  }
  private focusQuantityInput() {
    this.focusManagerService.focusQuantityInput();
  }
  private focusDiscountInput() {
    this.focusManagerService.focusDiscountInput();
  }
  private focusFirstExchangeQuantityInput() {
    this.focusManagerService.focusFirstExchangeQuantityInput();
  }
  handleOfferGroupDialogTabNavigation(event: KeyboardEvent) {
    this.keyboardNavigationService.handleOfferGroupDialogTabNavigation(
      event,
      this.buildKeyboardNavDeps(),
    );
  }
  handleHistoryDialogTabNavigation(event: KeyboardEvent) {
    this.keyboardNavigationService.handleHistoryDialogTabNavigation(event);
  }
  printReceipt(
    canGenerateInvoice: boolean = false,
    orderID?: string,
    allItemsNonGST: boolean = false,
    pdfUrl?: string | any,
  ) {
    // 1. Check if invoicepdf URL exists (passed as argument or from the selected transaction row)
    const selectedTx =
      this.flattenedTransactions?.[this.selectedTransactionIndex];
    const finalPdfUrl =
      pdfUrl || (orderID ? selectedTx?.invoicepdf : undefined);

    console.log('[printReceipt] Checking invoicepdf URL:', {
      passedPdfUrl: pdfUrl,
      selectedTxPdfUrl: selectedTx?.invoicepdf,
      finalPdfUrl,
    });

    const hasInvoicePdf = !!(
      finalPdfUrl &&
      typeof finalPdfUrl === 'string' &&
      finalPdfUrl.trim() !== ''
    );

    console.log(
      '[printReceipt] Has Invoice PDF URL:',
      hasInvoicePdf,
      finalPdfUrl,
    );

    if (hasInvoicePdf) {
      console.log('✅ Invoice PDF URL exists:', finalPdfUrl);
    } else {
      console.log('❌ No Invoice PDF URL found for this transaction.');
    }

    console.log(canGenerateInvoice, orderID, allItemsNonGST, 'printReceipt');
    // Use provided orderID for transaction history, or currentOrderId for normal flow
    const targetOrderId = orderID || this.currentOrderId;

    console.log('[printReceipt] Called with:', {
      canGenerateInvoice,
      orderID,
      allItemsNonGST,
      targetOrderId,
      isSuspenseMode: this.isSuspenseMode,
      hasInvoicePdf,
    });

    if (!targetOrderId) {
      this.messageService.add({
        severity: 'error',
        summary: 'No order placed/Selected',
        detail: 'Place/Select the order to print receipt',
        life: 3000,
      });
      return;
    }

    // In suspense mode, only process suspense flow - skip normal invoice generation
    if (this.isSuspenseMode && targetOrderId) {
      console.log('[printReceipt] Routing to processSuspenseOrder');
      this.processSuspenseOrder(targetOrderId, allItemsNonGST);
      return; // Exit early, don't generate normal invoice
    }

    console.log('[printReceipt] Proceeding with normal invoice generation');

    // Continue with normal invoice generation only when NOT in suspense mode
    if (canGenerateInvoice) {
      this.productService
        .generateInvoice(
          targetOrderId,
          this.transactionId ?? '',
          this.paymentId ?? '',
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: InvoiceHttpResponse) => {
          if (response.code === '200') {
            // Sale invoice created — refresh the Bill No counter (replaces bill-number WebSocket)
            this.billNumberRefreshService.requestRefresh();
            this.invoice = response.data;
            // If invoice already has a PDF in Azure, skip upload; otherwise upload to Azure
            const alreadyHasPdf =
              hasInvoicePdf || !!(response.data?.invoice as any)?.invoicepdf;
            console.log(
              '[generateInvoice complete] Already has PDF in Azure:',
              alreadyHasPdf,
            );
            this.fetchCustomerAndGeneratePdf(alreadyHasPdf);
          } else {
            if (!orderID) {
              this.currentOrderId = '';
              this.holdOrderId = '';
            }
          }
        });
    } else {
      this.productService
        .printInvoice(targetOrderId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: InvoiceHttpResponse) => {
          if (response.code === '200') {
            this.invoice = response.data;
            // If invoice already has a PDF in Azure, skip upload; otherwise upload to Azure
            const alreadyHasPdf =
              hasInvoicePdf || !!(response.data?.invoice as any)?.invoicepdf;
            console.log(
              '[printInvoice complete] Already has PDF in Azure:',
              alreadyHasPdf,
            );
            this.fetchCustomerAndGeneratePdf(alreadyHasPdf);
          } else {
            // Only reset currentOrderId if we're using it (not from transaction history)
            if (!orderID) {
              this.currentOrderId = '';
              this.holdOrderId = '';
            }
          }
        });
    }
  }

  /**
   * Fetch customer data from customer list and populate selectedCustomer before generating PDF
   * This ensures buyer address is available even after page refresh
   * @param isViewingExistingInvoice - True if viewing from transaction history (skip upload)
   */
  private async fetchCustomerAndGeneratePdf(
    isViewingExistingInvoice: boolean = false,
  ): Promise<void> {
    const invoiceData = this.invoice?.invoice;
    console.log(invoiceData);
    if (!invoiceData) {
      this.generatePdfNew(isViewingExistingInvoice);
      return;
    }

    console.log('[fetchCustomerAndGeneratePdf] Invoice data:', {
      customer_id: invoiceData.customer_id,
      name: invoiceData.name,
      user_id: invoiceData.user_id,
      isViewingExistingInvoice,
    });

    if (invoiceData.customer_id) {
      try {
        await this.ensureCustomersLoaded();

        const customer = this.customers.find(
          (c) => c.id === invoiceData.customer_id,
        );

        if (customer) {
          console.log('[fetchCustomerAndGeneratePdf] Customer found:', {
            id: customer.id,
            name: customer.customer_name,
            mobile: customer.mobile_no,
            address_line1: customer.address_line1,
            city: customer.city,
            state: customer.state,
          });

          this.selectedCustomer = customer;

          const hasAddress =
            customer.address_line1 ||
            customer.address_line2 ||
            customer.address_line3 ||
            customer.city ||
            customer.state;

          if (!hasAddress) {
            console.warn(
              '[fetchCustomerAndGeneratePdf] Customer found but address fields are empty',
            );
          }
        } else {
          this.selectedCustomer = null;
        }
      } catch (error) {
        console.error(
          '[fetchCustomerAndGeneratePdf] Error loading customers:',
          error,
        );
        this.selectedCustomer = null;
      }
    } else {
      this.selectedCustomer = null;
    }

    this.generatePdfNew(isViewingExistingInvoice);
  }

  async generatePdf() {
    const ctx = {
      invoice: this.invoice,
      storename: this.storename,
      selectedCustomer: this.selectedCustomer,
      clientId: this.clientId,
      isDecimalQuantityEnabled: this.isDecimalQuantityEnabled,
    };
    return this.dashboardPdfService.generatePdf(ctx);
  }

  async generatePdfNew(isViewingExistingInvoice: boolean = false) {
    const ctx = {
      invoice: this.invoice,
      storename: this.storename,
      selectedCustomer: this.selectedCustomer,
      clientId: this.clientId,
      isDecimalQuantityEnabled: this.isDecimalQuantityEnabled,
      isUnitPriceInclTax: this.isUnitPriceInclTax,
      generatePdfFallback: () => this.generatePdf(),
    };
    return this.dashboardPdfService.generatePdfNew(
      ctx,
      isViewingExistingInvoice,
    );
  }

  async generateCreditPdf(exchangedItems?: any[], payload?: any) {
    const users: any = {
      name: payload.name,
      mobileNo: payload.mobile,
    };
    const ctx = {
      selectedInvoiceData: this.selectedInvoiceData,
      products: this.products,
      formData: this.formData,
      userName: this.userName,
      customer: users,
      isInterStateTax: () => this.isInterStateTax(),
      getEffectivePrice: (p: any) => this.getEffectivePrice(p),
      currentOrderId: this.currentOrderId,
      selectedInvoiceNo: this.selectedInvoiceNo,
    };
    console.log(ctx, 'ctx for retunr');
    return this.dashboardPdfService.generateCreditPdf(ctx, exchangedItems);
  }
  updateExistingQuotation(): void {
    this.orderModeService.updateExistingQuotation(this.buildOrderModeDeps());
  }

  editQuotation(quotation: any): void {
    this.orderModeService.editQuotation(quotation, this.buildOrderModeDeps());
  }

  sharingTransactionWhatsapp = false;

  /** Super Admin setting: WhatsApp sharing is shown only for businesses it is enabled for */
  get whatsappShareAllowed(): boolean {
    return this.whatsappShareService.allowed;
  }

  async shareSelectedTransactionWhatsapp(): Promise<void> {
    const transaction = this.flattenedTransactions[this.selectedTransactionIndex];
    if (!transaction || this.sharingTransactionWhatsapp) return;
    this.sharingTransactionWhatsapp = true;
    try {
      await this.whatsappShareService.shareTransaction(transaction, this.messageService, 'FO_DASHBOARD');
    } finally {
      this.sharingTransactionWhatsapp = false;
    }
  }

  getSelectedTransactionOrderId(): string {
    return this.transactionHistoryService.getSelectedTransactionOrderId(
      this.buildTransactionHistoryDeps(),
    );
  }
  // Place order from quotation
  placeOrderFromQuotation(quotation: any): void {
    this.orderModeService.placeOrderFromQuotation(
      quotation,
      this.buildOrderModeDeps(),
    );
  }

  // Generate PDF for suspense account invoice
  async generateSuspensePdf(suspenseData: any) {
    const suspense = suspenseData.Suspense;
    const allSuspenseItems = suspense.suspenseitems || [];

    // Filter to only include items with isgst = 0 (non-GST items)
    const suspenseItems = allSuspenseItems.filter(
      (item: any) => item.isgst === 0 || item.isgst === null,
    );

    if (!suspense || suspenseItems.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Suspense Items',
        detail: 'No non-GST items found for suspense PDF generation',
        life: 3000,
      });
      return;
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
    const formattedTime = currentDate.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    // Create table data for suspense items (no GST column for DRAFT)
    const tableData = [
      [
        { text: 'Item', style: 'tableHeader' },
        { text: 'Qty', style: 'tableHeader' },
        { text: 'Rate', style: 'tableHeader' },
        { text: 'Amount', style: 'tableHeader' },
      ],
    ];

    // Calculate totals from filtered non-GST items only
    let calculatedSubtotal = 0;
    let calculatedGrandTotal = 0;

    suspenseItems.forEach((item: any) => {
      const itemSubtotal = (item.price || 0) * (item.quantity || 0);
      const itemGrandTotal = item.grandtotal || 0;

      calculatedSubtotal += itemSubtotal;
      calculatedGrandTotal += itemGrandTotal;

      tableData.push([
        item.name || 'N/A',
        { text: item.quantity?.toString() || '0', alignment: 'center' },
        { text: `₹${(item.price || 0).toFixed(2)}`, alignment: 'right' },
        { text: `₹${itemGrandTotal.toFixed(2)}`, alignment: 'right' },
      ]);
    });

    const docDefinition: any = {
      pageSize: { width: 226.77, height: 'auto' }, // 80mm width for thermal printer
      pageMargins: [10, 10, 10, 10],
      content: [
        {
          text: 'DRAFT',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 10],
        },
        {
          text: ``,
          fontSize: 8,
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date: ${formattedDate} ${formattedTime}`,
          fontSize: 8,
          margin: [0, 0, 0, 5],
        },
        {
          text: `Customer: ${suspense.name || 'N/A'}`,
          fontSize: 8,
          margin: [0, 0, 0, 5],
        },
        {
          text: `Mobile: ${suspense.user_id || 'N/A'}`,
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            headerRows: 1,
            widths: ['*', 25, 35, 40],
            body: tableData,
          },
          layout: {
            hLineWidth: function (i: any, node: any) {
              return i === 0 || i === node.table.body.length ? 0.5 : 0.2;
            },
            vLineWidth: function (i: any, node: any) {
              return 0.2;
            },
            hLineColor: function (i: any, node: any) {
              return 'gray';
            },
            vLineColor: function (i: any, node: any) {
              return 'gray';
            },
            paddingLeft: function (i: any, node: any) {
              return 2;
            },
            paddingRight: function (i: any, node: any) {
              return 2;
            },
            paddingTop: function (i: any, node: any) {
              return 1;
            },
            paddingBottom: function (i: any, node: any) {
              return 1;
            },
          },
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            { width: '*', text: '' },
            {
              width: 'auto',
              table: {
                body: [['Total:', `₹${calculatedGrandTotal.toFixed(2)}`]],
              },
              layout: 'noBorders',
              fontSize: 8,
              bold: true,
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: '*** THIS IS NOT AN INVOICE ***',
          style: 'header',
          alignment: 'center',
          fontSize: 10,
          color: '#dc2626',
          margin: [0, 10, 0, 5],
        },
        {
          text: `Generated: ${formattedDate} at ${formattedTime}`,
          fontSize: 6,
          alignment: 'center',
          margin: [0, 5, 0, 0],
        },
      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
        },
      },
      defaultStyle: {
        fontSize: 7,
      },
    };

    // compress:false prevents "Cannot create final Buffer > 0x7fffffff bytes"
    const pdfDocGenerator = pdfMake.createPdf({
      ...(docDefinition as any),
      compress: false,
    });

    try {
      pdfDocGenerator.open();
    } catch (error) {
      console.warn('PDF popup blocked, downloading instead:', error);
      pdfDocGenerator.download(
        `suspense-invoice-${suspense.suspenseid || 'receipt'}.pdf`,
      );
    }

    const suspenseUuid = suspenseData?.Suspense?.uuid;
    if (suspenseUuid) {
      try {
        const blob = await new Promise<Blob>((resolve) => {
          pdfDocGenerator.getBlob((blob) => resolve(blob));
        });

        const suspenseId = suspense.suspenseid || 'unknown';
        const fileName = `suspense_${suspenseId}_${Date.now()}.pdf`;

        this.pdfUploadService
          .uploadSuspensePdf(blob, suspenseUuid, fileName)
          .subscribe({
            next: (response) => {
              this.messageService.add({
                severity: 'success',
                summary: 'PDF Saved',
                detail: 'Suspense PDF uploaded',
                life: 2000,
              });
            },
            error: (error) => {
              this.messageService.add({
                severity: 'warn',
                summary: 'Upload Failed',
                detail: 'Failed to upload PDF',
                life: 3000,
              });
            },
          });
      } catch (error) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Upload Failed',
          detail: 'Failed to generate PDF for upload',
          life: 3000,
        });
      }
    } else {
      console.warn('[PDF Upload] No suspense UUID found, skipping upload');
    }
  }

  canResetPOS(_this: any) {
    this.confirmationService.confirm({
      message: 'This clears the current bill and starts a new one.',
      header: 'Reset bill?',
      icon: 'pi pi-refresh',
      acceptLabel: 'Reset bill',
      rejectLabel: 'Keep bill',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        resetFunction(_this);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelled',
          detail: 'Reset operation was cancelled',
          life: 3000,
        });
      },
      key: 'positionDialog',
    });
  }

  canShowRequiredModal() {
    return !!this.displayMobileNumberDialog;
  }

  canCloseRequiredModal() {
    return !!this.displayMobileNumberDialog;
  }
  private setupGlobalKeyboardShortcuts(): void {
    this.keyboardNavigationService.setupGlobalKeyboardShortcuts(
      this.buildKeyboardNavDeps(),
    );
  }

  loadClientSettings(): void {
    if (!this.authService.isAuthenticated()) {
      return;
    }

    this.clientSettingsService.loadClientSettings().subscribe((settings) => {
      this.clientSettingsService.permissions$.subscribe((permissions) => {
        this.modePermissions = permissions;
      });
      this.enableCursorFocus =
        this.clientSettingsService.isCursorFocusEnabled();
      this.isBarcodeEnabled = this.clientSettingsService.isBarcodeEnabled();
      this.isFreeQtyEnabled = this.clientSettingsService.isFreeQtyEnabled();
      this.isBatchEnabled = this.clientSettingsService.isBatchEnabled();
      this.isMobileMandatory =
        this.clientSettingsService.isCustomerMobileMandatory();
      this.isDiscountAfterTaxEnabled =
        this.clientSettingsService.isDiscountAfterTaxEnabled();
      this.enableOverAllDiscount =
        this.clientSettingsService.isOverAllDiscountEnabled();
      this.isCounterSessionEnabled =
        this.clientSettingsService.isCounterSessionEnabled();
      this.isDecimalQuantityEnabled =
        this.clientSettingsService.isDecimalQuantityEnabled();
      this.isSalesDiscountEditEnabled =
        this.clientSettingsService.isSalesDiscountEditEnabled();
      this.isSalesPriceEditEnabled =
        this.clientSettingsService.isSalesPriceEditEnabled();
      this.isUnitPriceInclTax =
        this.clientSettingsService.isUnitPriceInclTaxEnabled();
      // NOW call checkPunchStatusOnLoad() - isCounterSessionEnabled is ready
      this.checkPunchStatusOnLoad();

      if (this.enableCursorFocus) {
        setTimeout(() => {
          this.focusProductSearch();
        }, 300);
      }
    });
  }

  loadClientTemplates(): void {
    if (!this.authService.isAuthenticated()) {
      return;
    }

    const clientId = parseInt(this.clientId ?? '');
    if (!clientId) {
      return;
    }

    this.clientTemplateService.getClientTemplates(clientId).subscribe({
      next: (templates) => {
        const defaultTemplate = this.clientTemplateService.getDefaultTemplate();
        if (defaultTemplate) {
          const templateName = this.clientTemplateService.getTemplateNameById(
            defaultTemplate.template_id,
          );
        }
      },
      error: (error) => {
        console.error('Failed to load client templates:', error);
      },
    });
  }

  // MOVED-TO: src/app/shared/services/offer-group-mode.service.ts -> OfferGroupModeService (whole cluster)
  // Builds the shared dependency bag for the offer/pricing-group mode cluster
  // (loadPricingGroups, toggleOfferGroupMode, enable/disableOfferGroupMode,
  // updateExistingItemsWithOfferPrices, revertExistingItemsToOriginalPrices,
  // filterCustomersForOfferGroup, onOfferGroup*, onMobileEntered,
  // autoSelectPricingGroup, autoSelectFirstPricingGroup). Nearly every method
  // here has an async gap before touching component state, so every field is
  // a live getter/setter rather than a snapshot -- see the interface doc
  // comment in offer-group-mode.service.ts.
  private buildOfferGroupModeDeps(): OfferGroupModeDeps {
    return {
      getPricingGroups: () => this.pricingGroups,
      setPricingGroups: (value) => (this.pricingGroups = value),
      getModePermissions: () => this.modePermissions,
      getIsOfferGroupMode: () => this.isOfferGroupMode,
      setIsOfferGroupMode: (value) => (this.isOfferGroupMode = value),
      getMobileNumber: () => this.mobileNumber,
      getCustomerMobile: () => this.customerMobile,
      setCustomerMobile: (value) => (this.customerMobile = value),
      getHasCustomerOverride: () => this.hasCustomerOverride,
      setShowOfferGroupCustomerDialog: (value) =>
        (this.showOfferGroupCustomerDialog = value),
      getOfferGroupMobileAutocomplete: () => this.offerGroupMobileAutocomplete,
      getSelectedCustomer: () => this.selectedCustomer,
      setSelectedCustomer: (value) => (this.selectedCustomer = value),
      getSelectedOfferGroupId: () => this.selectedOfferGroupId,
      setSelectedOfferGroupId: (value) => (this.selectedOfferGroupId = value),
      getLastSelectedOfferGroupId: () => this.lastSelectedOfferGroupId,
      setLastSelectedOfferGroupId: (value) =>
        (this.lastSelectedOfferGroupId = value),
      getIsExchangeOrder: () => this.isExchangeOrder,
      getIsQuotationMode: () => this.isQuotationMode,
      setIsQuotationMode: (value) => (this.isQuotationMode = value),
      getIsWholesaleMode: () => this.isWholesaleMode,
      setIsWholesaleMode: (value) => (this.isWholesaleMode = value),
      getIsSuspenseMode: () => this.isSuspenseMode,
      setIsSuspenseMode: (value) => (this.isSuspenseMode = value),
      getCartProducts: () => this.products,
      setProductsTemp: (value) => (this.productsTemp = value),
      getIsSalesDiscountEditEnabled: () => this.isSalesDiscountEditEnabled,
      getItemId: () => this.itemId,
      getCustomers: () => this.customers,
      setFilteredCustomersForOfferGroup: (value) =>
        (this.filteredCustomersForOfferGroup = value),
      ensureCustomersLoaded: () => this.ensureCustomersLoaded(),
      updateFormDataWithQuotationMode: () =>
        this.updateFormDataWithQuotationMode(),
      searchProducts: (searchText) => this.getProducts(searchText),
      discountChangeCalc: () => this.DiscountchangeCalc(),
    };
  }
  async loadPricingGroups(): Promise<void> {
    await this.offerGroupModeService.loadPricingGroups(
      this.buildOfferGroupModeDeps(),
    );
  }

  private async ensureCustomersLoaded(): Promise<void> {
    await this.customerLookupService.ensureCustomersLoaded(
      this.buildCustomerLookupDeps(),
    );
  }
  async toggleOfferGroupMode(): Promise<void> {
    await this.offerGroupModeService.toggleOfferGroupMode(
      this.buildOfferGroupModeDeps(),
    );
  }
  updateExistingItemsWithOfferPrices(groupId: number): void {
    this.offerGroupModeService.updateExistingItemsWithOfferPrices(
      groupId,
      this.buildOfferGroupModeDeps(),
    );
  }
  revertExistingItemsToOriginalPrices(): void {
    this.offerGroupModeService.revertExistingItemsToOriginalPrices(
      this.buildOfferGroupModeDeps(),
    );
  }
  async enableOfferGroupMode(): Promise<void> {
    await this.offerGroupModeService.enableOfferGroupMode(
      this.buildOfferGroupModeDeps(),
    );
  }
  disableOfferGroupMode(): void {
    this.offerGroupModeService.disableOfferGroupMode(
      this.buildOfferGroupModeDeps(),
    );
  }

  async filterCustomersForOfferGroup(event: any) {
    await this.offerGroupModeService.filterCustomersForOfferGroup(
      event,
      this.buildOfferGroupModeDeps(),
    );
  }
  onOfferGroupFilterCustomers(event: any): void {
    this.offerGroupModeService.onOfferGroupFilterCustomers(
      event,
      this.buildOfferGroupModeDeps(),
    );
  }
  onOfferGroupMobileSelect(event: any): void {
    this.offerGroupModeService.onOfferGroupMobileSelect(
      event,
      this.buildOfferGroupModeDeps(),
    );
  }
  onMobileEntered(): void {
    this.offerGroupModeService.onMobileEntered(this.buildOfferGroupModeDeps());
  }
  // Note: autoSelectPricingGroup/autoSelectFirstPricingGroup were private and only
  // called internally by other methods in this cluster (all now delegating to
  // OfferGroupModeService, which has its own private copies) -- no remaining
  // component-local caller, so no delegating stub is kept for them here.

  proceedWithCustomer(): void {
    if (this.customerMobile) {
      this.onMobileEntered();

      this.mobileNumber = this.customerMobile;
      if (this.selectedCustomer) {
        this.customerName = this.selectedCustomer.customer_name;
      }

      this.formDataService.updateFormData({
        currentDate: this.formData?.currentDate || new Date(),
        empCode: this.formData?.empCode || '',
        storeCode: this.formData?.storeCode || '',
        mobileNumber: this.mobileNumber,
        customerName: this.customerName,
        salesRep: this.formData?.salesRep || '',
        isQuotationMode: this.isQuotationMode,
        isSuspenseMode: this.isSuspenseMode,
        isWholesaleMode: this.isWholesaleMode,
        isOfferGroupMode: this.isOfferGroupMode,
      });
    }
    this.enableOfferGroupMode();
    this.showOfferGroupCustomerDialog = false;
  }

  onProceedWithCustomer(): void {
    this.proceedWithCustomer();
  }

  proceedWithoutCustomer(): void {
    this.hasCustomerOverride = true;
    this.enableOfferGroupMode();
    this.showOfferGroupCustomerDialog = false;
  }

  onProceedWithoutCustomer(): void {
    this.proceedWithoutCustomer();
  }

  onOfferGroupSelected(): void {
    this.offerGroupModeService.onOfferGroupSelected(
      this.buildOfferGroupModeDeps(),
    );
  }

  private updateHeaderAfterCustomerLookup(): void {
    if (this.selectedCustomer) {
      this.customerName = this.selectedCustomer.customer_name;
    } else {
      this.customerName = '';
    }

    this.formDataService.updateFormData({
      currentDate: this.formData?.currentDate || new Date(),
      empCode: this.formData?.empCode || '',
      storeCode: this.formData?.storeCode || '',
      mobileNumber: this.mobileNumber,
      customerName: this.customerName,
      salesRep: this.formData?.salesRep || '',
      isQuotationMode: this.isQuotationMode,
      isSuspenseMode: this.isSuspenseMode,
      isWholesaleMode: this.isWholesaleMode,
      isOfferGroupMode: this.isOfferGroupMode,
    });
  }

  ngOnDestroy() {
    this.accountRegistry.setPendingBillCounter(null);
    this.paymentStatusService.stopPaymentTracking();

    if (this.formDataSubscription) {
      this.formDataSubscription.unsubscribe();
    }
    if (this.productSearchSubscription) {
      this.productSearchSubscription.unsubscribe();
    }
    this.customEventSubscription && this.customEventSubscription.unsubscribe();
    this.authSubscription && this.authSubscription.unsubscribe();

    // ===== INFINITE SCROLL CLEANUP =====
    this.detachAutocompleteScrollListener();
    this.loadMorePage$.complete();
    // ====================================

    this.destroy$.next();

    this.destroy$.complete();
  }

  // ============================================
  // CASH IN/OUT DIALOG METHODS
  // ============================================

  private checkPunchStatusOnLoad(): void {
    // Only check punch status if counter session is enabled
    if (!this.isCounterSessionEnabled) {
      console.log(
        '[PUNCH] Counter session monitoring disabled, skipping Cash In check',
      );
      return;
    }
    this.cashDenominationService.getPunchStatus().subscribe({
      next: (response) => {
        this.punchStatus = response.data;
        localStorage.setItem('punchStatus', JSON.stringify(this.punchStatus));

        if (!this.punchStatus.hasCashInPunched) {
          setTimeout(() => {
            this.showCashInDialog = true;
          }, 500);
        }
      },
      error: (err) => {
        console.error('Error fetching punch status:', err);
      },
    });
  }

  onCashInComplete(event: {
    action: 'saved' | 'skipped';
    tab: string;
    total: number;
  }): void {
    this.showCashInDialog = false;

    if (event.action === 'saved') {
      this.messageService.add({
        severity: 'success',
        summary: 'Cash In Recorded',
        detail: `Opening cash of ₹${event.total.toLocaleString('en-IN')} has been recorded.`,
        life: 5000,
      });

      if (this.punchStatus) {
        this.punchStatus.hasCashInPunched = true;
        localStorage.setItem('punchStatus', JSON.stringify(this.punchStatus));
      }
    }
  }

  // ============================================
  // Mobile Industry: Variant Selection Methods (Phase 3)
  // ============================================

  /**
   * Check if product requires variant selection
   */
  hasVariantSelection(product: Product): boolean {
    if (!this.industryService.isMobile()) return false;
    if (product.selectedMapValue) return true;
    if (!product.productmapvalues || product.productmapvalues.length === 0)
      return false;

    // Check if any option has non-null parameters or variants
    return product.productmapvalues.some(
      (pmv) =>
        pmv.parameter1_value ||
        pmv.parameter2_value ||
        pmv.variant1_value ||
        pmv.variant2_value,
    );
  }

  /**
   * Get available variant options (qty > 0)
   */
  getAvailableVariantOptions(product: Product): ProductMapValue[] {
    if (!product.productmapvalues) return [];

    return product.productmapvalues
      .filter(
        (pmv) =>
          pmv.parameter1_value ||
          pmv.parameter2_value ||
          pmv.variant1_value ||
          pmv.variant2_value,
      )
      .sort((a, b) => b.qty - a.qty); // Sort by qty descending
  }

  /**
   * Get all variant options including out of stock
   */
  getAllVariantOptions(product: Product): ProductMapValue[] {
    return this.getAvailableVariantOptions(product);
  }

  /**
   * Select variant option
   */
  selectVariantOption(product: Product, option: ProductMapValue) {
    if (option.qty === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Out of Stock',
        detail: 'This variant is currently unavailable',
      });
      return;
    }

    product.selectedMapValue = option;
    product.stockquanity = option.qty;
    product.variantAccordionExpanded = false; // Auto-collapse

    this.messageService.add({
      severity: 'success',
      summary: 'Variant Selected',
      detail: this.getVariantSummary(option),
    });
  }

  /**
   * Toggle accordion
   */
  toggleVariantAccordion(product: Product) {
    product.variantAccordionExpanded = !product.variantAccordionExpanded;
  }

  /**
   * Check if variant option is selected
   */
  isVariantSelected(product: Product, option: ProductMapValue): boolean {
    return product.selectedMapValue?.id === option.id;
  }

  /**
   * Get variant summary for display
   */
  getVariantSummary(option: ProductMapValue): string {
    const parts: string[] = [];

    if (option.parameter1_value) parts.push(`IMEI: ${option.parameter1_value}`);
    if (option.variant1_value) parts.push(option.variant1_value);
    if (option.variant2_value) parts.push(option.variant2_value);

    return parts.join(' • ') || 'Selected';
  }

  /**
   * Get selected variant summary for display
   */
  getSelectedVariantSummary(product: Product): string {
    if (!product.selectedMapValue) {
      return 'Select IMEI/Variant';
    }
    return this.getVariantSummary(product.selectedMapValue);
  }

  hasParametersAndVariants(product: Product): boolean {
    if (!this.industryService.isMobile()) return false;
    if (!product.productmapvalues || product.productmapvalues.length === 0)
      return false;

    const hasParams = product.productmapvalues.some(
      (pmv) => pmv.parameters && pmv.parameters.length > 0,
    );
    const hasVariants = product.productmapvalues.some(
      (pmv) => pmv.variants && pmv.variants.length > 0,
    );

    return hasParams && hasVariants;
  }

  /**
   * Case 2: Check if product has only variants (no parameters)
   */
  hasOnlyVariants(product: Product): boolean {
    if (!this.industryService.isMobile()) return false;
    if (!product.productmapvalues || product.productmapvalues.length === 0)
      return false;

    const hasParams = product.productmapvalues.some(
      (pmv) => pmv.parameters && pmv.parameters.length > 0,
    );
    const hasVariants = product.productmapvalues.some(
      (pmv) => pmv.variants && pmv.variants.length > 0,
    );

    return !hasParams && hasVariants;
  }

  /**
   * Case 3: Check if product has neither parameters nor variants
   */
  hasNoParametersOrVariants(product: Product): boolean {
    if (!this.industryService.isMobile()) return true; // Retail always Case 3
    if (!product.productmapvalues || product.productmapvalues.length === 0)
      return true;

    const hasParams = product.productmapvalues.some(
      (pmv) => pmv.parameters && pmv.parameters.length > 0,
    );
    const hasVariants = product.productmapvalues.some(
      (pmv) => pmv.variants && pmv.variants.length > 0,
    );

    return !hasParams && !hasVariants;
  }

  /**
   * Check if product requires parameter/variant selection before quantity editing
   */
  requiresSelectionBeforeQuantity(product: Product): boolean {
    if (!this.industryService.isMobile()) return false;
    return false;
  }

  /**
   * Get unique variant options for dropdown (Case 2)
   */
  getVariantDropdownOptions(
    product: Product,
  ): Array<{ label: string; value: ProductMapValue }> {
    if (!product.productmapvalues) return [];

    const options = product.productmapvalues
      .filter((pmv) => pmv.variants && pmv.variants.length > 0)
      .map((pmv) => {
        const variantNames = pmv
          .variants!.map((v) => v.variant_value_name)
          .filter(Boolean)
          .join(' • ');
        return {
          label: `${variantNames} (Qty: ${pmv.qty})`,
          value: pmv,
        };
      });

    return options;
  }
  /**
   * Open parameter selection popup (Case 1)
   */
  openParameterPopup(product: Product, overlayPanel: any) {
    if (!this.hasParametersAndVariants(product)) return;
    overlayPanel.show(event);
  }

  /**
   * Validate variant selection before payment
   */
  validateVariantSelection(): boolean {
    if (!this.industryService.isMobile()) return true;

    for (const product of this.products) {
      // Check if product requires selection
      if (this.requiresSelectionBeforeQuantity(product)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Selection Required',
          detail: `Please complete the required Parameter/Variant selection for ${product.name} before processing the order.`,
          life: 5000,
        });
        return false;
      }

      // Validate qty against selected option
      if (
        product.selectedMapValue &&
        product.increaseQuantity > product.selectedMapValue.qty
      ) {
        this.messageService.add({
          severity: 'error',
          summary: 'Insufficient Stock',
          detail: `Only ${product.selectedMapValue.qty} units available for ${product.name}`,
        });
        return false;
      }
    }

    return true;
  }

  hasPendingVariantSelection(): boolean {
    return this.posCalculationService.hasPendingVariantSelection(this.products);
  }

  hasPendingMappingSelection(): boolean {
    if (!this.industryService.isMobile()) return false;
    return (this.products || []).some(
      (product) =>
        product.mappings &&
        product.mappings.length > 0 &&
        product.selectedMappingId == null &&
        product.mapping_id == null,
    );
  }
}
